!(function (e) {
    var t = {};
    function n(i) {
        if (t[i]) return t[i].exports;
        var o = (t[i] = { i: i, l: !1, exports: {} });
        return e[i].call(o.exports, o, o.exports, n), (o.l = !0), o.exports;
    }
    (n.m = e),
        (n.c = t),
        (n.d = function (e, t, i) {
            n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
        }),
        (n.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (n.t = function (e, t) {
            if ((1 & t && (e = n(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if ((n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var o in e)
                    n.d(
                        i,
                        o,
                        function (t) {
                            return e[t];
                        }.bind(null, o)
                    );
            return i;
        }),
        (n.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return n.d(t, "a", t), t;
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.p = ""),
        n((n.s = 21));
})([
    function (e, t, n) {
        var i;
        /*!
         * jQuery JavaScript Library v3.6.0
         * https://jquery.com/
         *
         * Includes Sizzle.js
         * https://sizzlejs.com/
         *
         * Copyright OpenJS Foundation and other contributors
         * Released under the MIT license
         * https://jquery.org/license
         *
         * Date: 2021-03-02T17:08Z
         */ !(function (t, n) {
            "use strict";
            "object" == typeof e.exports
                ? (e.exports = t.document
                      ? n(t, !0)
                      : function (e) {
                            if (!e.document) throw new Error("jQuery requires a window with a document");
                            return n(e);
                        })
                : n(t);
        })("undefined" != typeof window ? window : this, function (n, o) {
            "use strict";
            var r = [],
                s = Object.getPrototypeOf,
                a = r.slice,
                l = r.flat
                    ? function (e) {
                          return r.flat.call(e);
                      }
                    : function (e) {
                          return r.concat.apply([], e);
                      },
                c = r.push,
                d = r.indexOf,
                u = {},
                p = u.toString,
                f = u.hasOwnProperty,
                h = f.toString,
                v = h.call(Object),
                y = {},
                g = function (e) {
                    return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
                },
                m = function (e) {
                    return null != e && e === e.window;
                },
                b = n.document,
                w = { type: !0, src: !0, nonce: !0, noModule: !0 };
            function x(e, t, n) {
                var i,
                    o,
                    r = (n = n || b).createElement("script");
                if (((r.text = e), t)) for (i in w) (o = t[i] || (t.getAttribute && t.getAttribute(i))) && r.setAttribute(i, o);
                n.head.appendChild(r).parentNode.removeChild(r);
            }
            function T(e) {
                return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? u[p.call(e)] || "object" : typeof e;
            }
            var S = function (e, t) {
                return new S.fn.init(e, t);
            };
            function k(e) {
                var t = !!e && "length" in e && e.length,
                    n = T(e);
                return !g(e) && !m(e) && ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
            }
            (S.fn = S.prototype = {
                jquery: "3.6.0",
                constructor: S,
                length: 0,
                toArray: function () {
                    return a.call(this);
                },
                get: function (e) {
                    return null == e ? a.call(this) : e < 0 ? this[e + this.length] : this[e];
                },
                pushStack: function (e) {
                    var t = S.merge(this.constructor(), e);
                    return (t.prevObject = this), t;
                },
                each: function (e) {
                    return S.each(this, e);
                },
                map: function (e) {
                    return this.pushStack(
                        S.map(this, function (t, n) {
                            return e.call(t, n, t);
                        })
                    );
                },
                slice: function () {
                    return this.pushStack(a.apply(this, arguments));
                },
                first: function () {
                    return this.eq(0);
                },
                last: function () {
                    return this.eq(-1);
                },
                even: function () {
                    return this.pushStack(
                        S.grep(this, function (e, t) {
                            return (t + 1) % 2;
                        })
                    );
                },
                odd: function () {
                    return this.pushStack(
                        S.grep(this, function (e, t) {
                            return t % 2;
                        })
                    );
                },
                eq: function (e) {
                    var t = this.length,
                        n = +e + (e < 0 ? t : 0);
                    return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
                },
                end: function () {
                    return this.prevObject || this.constructor();
                },
                push: c,
                sort: r.sort,
                splice: r.splice,
            }),
                (S.extend = S.fn.extend = function () {
                    var e,
                        t,
                        n,
                        i,
                        o,
                        r,
                        s = arguments[0] || {},
                        a = 1,
                        l = arguments.length,
                        c = !1;
                    for ("boolean" == typeof s && ((c = s), (s = arguments[a] || {}), a++), "object" == typeof s || g(s) || (s = {}), a === l && ((s = this), a--); a < l; a++)
                        if (null != (e = arguments[a]))
                            for (t in e)
                                (i = e[t]),
                                    "__proto__" !== t &&
                                        s !== i &&
                                        (c && i && (S.isPlainObject(i) || (o = Array.isArray(i)))
                                            ? ((n = s[t]), (r = o && !Array.isArray(n) ? [] : o || S.isPlainObject(n) ? n : {}), (o = !1), (s[t] = S.extend(c, r, i)))
                                            : void 0 !== i && (s[t] = i));
                    return s;
                }),
                S.extend({
                    expando: "jQuery" + ("3.6.0" + Math.random()).replace(/\D/g, ""),
                    isReady: !0,
                    error: function (e) {
                        throw new Error(e);
                    },
                    noop: function () {},
                    isPlainObject: function (e) {
                        var t, n;
                        return !(!e || "[object Object]" !== p.call(e)) && (!(t = s(e)) || ("function" == typeof (n = f.call(t, "constructor") && t.constructor) && h.call(n) === v));
                    },
                    isEmptyObject: function (e) {
                        var t;
                        for (t in e) return !1;
                        return !0;
                    },
                    globalEval: function (e, t, n) {
                        x(e, { nonce: t && t.nonce }, n);
                    },
                    each: function (e, t) {
                        var n,
                            i = 0;
                        if (k(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                        else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                        return e;
                    },
                    makeArray: function (e, t) {
                        var n = t || [];
                        return null != e && (k(Object(e)) ? S.merge(n, "string" == typeof e ? [e] : e) : c.call(n, e)), n;
                    },
                    inArray: function (e, t, n) {
                        return null == t ? -1 : d.call(t, e, n);
                    },
                    merge: function (e, t) {
                        for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
                        return (e.length = o), e;
                    },
                    grep: function (e, t, n) {
                        for (var i = [], o = 0, r = e.length, s = !n; o < r; o++) !t(e[o], o) !== s && i.push(e[o]);
                        return i;
                    },
                    map: function (e, t, n) {
                        var i,
                            o,
                            r = 0,
                            s = [];
                        if (k(e)) for (i = e.length; r < i; r++) null != (o = t(e[r], r, n)) && s.push(o);
                        else for (r in e) null != (o = t(e[r], r, n)) && s.push(o);
                        return l(s);
                    },
                    guid: 1,
                    support: y,
                }),
                "function" == typeof Symbol && (S.fn[Symbol.iterator] = r[Symbol.iterator]),
                S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                    u["[object " + t + "]"] = t.toLowerCase();
                });
            var C =
                /*!
                 * Sizzle CSS Selector Engine v2.3.6
                 * https://sizzlejs.com/
                 *
                 * Copyright JS Foundation and other contributors
                 * Released under the MIT license
                 * https://js.foundation/
                 *
                 * Date: 2021-02-16
                 */
                (function (e) {
                    var t,
                        n,
                        i,
                        o,
                        r,
                        s,
                        a,
                        l,
                        c,
                        d,
                        u,
                        p,
                        f,
                        h,
                        v,
                        y,
                        g,
                        m,
                        b,
                        w = "sizzle" + 1 * new Date(),
                        x = e.document,
                        T = 0,
                        S = 0,
                        k = le(),
                        C = le(),
                        A = le(),
                        j = le(),
                        $ = function (e, t) {
                            return e === t && (u = !0), 0;
                        },
                        E = {}.hasOwnProperty,
                        L = [],
                        D = L.pop,
                        O = L.push,
                        M = L.push,
                        H = L.slice,
                        q = function (e, t) {
                            for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
                            return -1;
                        },
                        P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                        N = "[\\x20\\t\\r\\n\\f]",
                        I = "(?:\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                        _ = "\\[" + N + "*(" + I + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + N + "*\\]",
                        z = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + _ + ")*)|.*)\\)|)",
                        R = new RegExp(N + "+", "g"),
                        W = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"),
                        F = new RegExp("^" + N + "*," + N + "*"),
                        B = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
                        U = new RegExp(N + "|>"),
                        X = new RegExp(z),
                        Y = new RegExp("^" + I + "$"),
                        V = {
                            ID: new RegExp("^#(" + I + ")"),
                            CLASS: new RegExp("^\\.(" + I + ")"),
                            TAG: new RegExp("^(" + I + "|[*])"),
                            ATTR: new RegExp("^" + _),
                            PSEUDO: new RegExp("^" + z),
                            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
                            bool: new RegExp("^(?:" + P + ")$", "i"),
                            needsContext: new RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i"),
                        },
                        J = /HTML$/i,
                        G = /^(?:input|select|textarea|button)$/i,
                        Q = /^h\d$/i,
                        K = /^[^{]+\{\s*\[native \w/,
                        Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                        ee = /[+~]/,
                        te = new RegExp("\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\([^\\r\\n\\f])", "g"),
                        ne = function (e, t) {
                            var n = "0x" + e.slice(1) - 65536;
                            return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320));
                        },
                        ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                        oe = function (e, t) {
                            return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
                        },
                        re = function () {
                            p();
                        },
                        se = we(
                            function (e) {
                                return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                            },
                            { dir: "parentNode", next: "legend" }
                        );
                    try {
                        M.apply((L = H.call(x.childNodes)), x.childNodes), L[x.childNodes.length].nodeType;
                    } catch (e) {
                        M = {
                            apply: L.length
                                ? function (e, t) {
                                      O.apply(e, H.call(t));
                                  }
                                : function (e, t) {
                                      for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                                      e.length = n - 1;
                                  },
                        };
                    }
                    function ae(e, t, i, o) {
                        var r,
                            a,
                            c,
                            d,
                            u,
                            h,
                            g,
                            m = t && t.ownerDocument,
                            x = t ? t.nodeType : 9;
                        if (((i = i || []), "string" != typeof e || !e || (1 !== x && 9 !== x && 11 !== x))) return i;
                        if (!o && (p(t), (t = t || f), v)) {
                            if (11 !== x && (u = Z.exec(e)))
                                if ((r = u[1])) {
                                    if (9 === x) {
                                        if (!(c = t.getElementById(r))) return i;
                                        if (c.id === r) return i.push(c), i;
                                    } else if (m && (c = m.getElementById(r)) && b(t, c) && c.id === r) return i.push(c), i;
                                } else {
                                    if (u[2]) return M.apply(i, t.getElementsByTagName(e)), i;
                                    if ((r = u[3]) && n.getElementsByClassName && t.getElementsByClassName) return M.apply(i, t.getElementsByClassName(r)), i;
                                }
                            if (n.qsa && !j[e + " "] && (!y || !y.test(e)) && (1 !== x || "object" !== t.nodeName.toLowerCase())) {
                                if (((g = e), (m = t), 1 === x && (U.test(e) || B.test(e)))) {
                                    for (((m = (ee.test(e) && ge(t.parentNode)) || t) === t && n.scope) || ((d = t.getAttribute("id")) ? (d = d.replace(ie, oe)) : t.setAttribute("id", (d = w))), a = (h = s(e)).length; a--; )
                                        h[a] = (d ? "#" + d : ":scope") + " " + be(h[a]);
                                    g = h.join(",");
                                }
                                try {
                                    return M.apply(i, m.querySelectorAll(g)), i;
                                } catch (t) {
                                    j(e, !0);
                                } finally {
                                    d === w && t.removeAttribute("id");
                                }
                            }
                        }
                        return l(e.replace(W, "$1"), t, i, o);
                    }
                    function le() {
                        var e = [];
                        return function t(n, o) {
                            return e.push(n + " ") > i.cacheLength && delete t[e.shift()], (t[n + " "] = o);
                        };
                    }
                    function ce(e) {
                        return (e[w] = !0), e;
                    }
                    function de(e) {
                        var t = f.createElement("fieldset");
                        try {
                            return !!e(t);
                        } catch (e) {
                            return !1;
                        } finally {
                            t.parentNode && t.parentNode.removeChild(t), (t = null);
                        }
                    }
                    function ue(e, t) {
                        for (var n = e.split("|"), o = n.length; o--; ) i.attrHandle[n[o]] = t;
                    }
                    function pe(e, t) {
                        var n = t && e,
                            i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                        if (i) return i;
                        if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                        return e ? 1 : -1;
                    }
                    function fe(e) {
                        return function (t) {
                            return "input" === t.nodeName.toLowerCase() && t.type === e;
                        };
                    }
                    function he(e) {
                        return function (t) {
                            var n = t.nodeName.toLowerCase();
                            return ("input" === n || "button" === n) && t.type === e;
                        };
                    }
                    function ve(e) {
                        return function (t) {
                            return "form" in t
                                ? t.parentNode && !1 === t.disabled
                                    ? "label" in t
                                        ? "label" in t.parentNode
                                            ? t.parentNode.disabled === e
                                            : t.disabled === e
                                        : t.isDisabled === e || (t.isDisabled !== !e && se(t) === e)
                                    : t.disabled === e
                                : "label" in t && t.disabled === e;
                        };
                    }
                    function ye(e) {
                        return ce(function (t) {
                            return (
                                (t = +t),
                                ce(function (n, i) {
                                    for (var o, r = e([], n.length, t), s = r.length; s--; ) n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
                                })
                            );
                        });
                    }
                    function ge(e) {
                        return e && void 0 !== e.getElementsByTagName && e;
                    }
                    for (t in ((n = ae.support = {}),
                    (r = ae.isXML = function (e) {
                        var t = e && e.namespaceURI,
                            n = e && (e.ownerDocument || e).documentElement;
                        return !J.test(t || (n && n.nodeName) || "HTML");
                    }),
                    (p = ae.setDocument = function (e) {
                        var t,
                            o,
                            s = e ? e.ownerDocument || e : x;
                        return s != f && 9 === s.nodeType && s.documentElement
                            ? ((h = (f = s).documentElement),
                              (v = !r(f)),
                              x != f && (o = f.defaultView) && o.top !== o && (o.addEventListener ? o.addEventListener("unload", re, !1) : o.attachEvent && o.attachEvent("onunload", re)),
                              (n.scope = de(function (e) {
                                  return h.appendChild(e).appendChild(f.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
                              })),
                              (n.attributes = de(function (e) {
                                  return (e.className = "i"), !e.getAttribute("className");
                              })),
                              (n.getElementsByTagName = de(function (e) {
                                  return e.appendChild(f.createComment("")), !e.getElementsByTagName("*").length;
                              })),
                              (n.getElementsByClassName = K.test(f.getElementsByClassName)),
                              (n.getById = de(function (e) {
                                  return (h.appendChild(e).id = w), !f.getElementsByName || !f.getElementsByName(w).length;
                              })),
                              n.getById
                                  ? ((i.filter.ID = function (e) {
                                        var t = e.replace(te, ne);
                                        return function (e) {
                                            return e.getAttribute("id") === t;
                                        };
                                    }),
                                    (i.find.ID = function (e, t) {
                                        if (void 0 !== t.getElementById && v) {
                                            var n = t.getElementById(e);
                                            return n ? [n] : [];
                                        }
                                    }))
                                  : ((i.filter.ID = function (e) {
                                        var t = e.replace(te, ne);
                                        return function (e) {
                                            var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                            return n && n.value === t;
                                        };
                                    }),
                                    (i.find.ID = function (e, t) {
                                        if (void 0 !== t.getElementById && v) {
                                            var n,
                                                i,
                                                o,
                                                r = t.getElementById(e);
                                            if (r) {
                                                if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                                                for (o = t.getElementsByName(e), i = 0; (r = o[i++]); ) if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                                            }
                                            return [];
                                        }
                                    })),
                              (i.find.TAG = n.getElementsByTagName
                                  ? function (e, t) {
                                        return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
                                    }
                                  : function (e, t) {
                                        var n,
                                            i = [],
                                            o = 0,
                                            r = t.getElementsByTagName(e);
                                        if ("*" === e) {
                                            for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                                            return i;
                                        }
                                        return r;
                                    }),
                              (i.find.CLASS =
                                  n.getElementsByClassName &&
                                  function (e, t) {
                                      if (void 0 !== t.getElementsByClassName && v) return t.getElementsByClassName(e);
                                  }),
                              (g = []),
                              (y = []),
                              (n.qsa = K.test(f.querySelectorAll)) &&
                                  (de(function (e) {
                                      var t;
                                      (h.appendChild(e).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                          e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + N + "*(?:''|\"\")"),
                                          e.querySelectorAll("[selected]").length || y.push("\\[" + N + "*(?:value|" + P + ")"),
                                          e.querySelectorAll("[id~=" + w + "-]").length || y.push("~="),
                                          (t = f.createElement("input")).setAttribute("name", ""),
                                          e.appendChild(t),
                                          e.querySelectorAll("[name='']").length || y.push("\\[" + N + "*name" + N + "*=" + N + "*(?:''|\"\")"),
                                          e.querySelectorAll(":checked").length || y.push(":checked"),
                                          e.querySelectorAll("a#" + w + "+*").length || y.push(".#.+[+~]"),
                                          e.querySelectorAll("\\\f"),
                                          y.push("[\\r\\n\\f]");
                                  }),
                                  de(function (e) {
                                      e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                      var t = f.createElement("input");
                                      t.setAttribute("type", "hidden"),
                                          e.appendChild(t).setAttribute("name", "D"),
                                          e.querySelectorAll("[name=d]").length && y.push("name" + N + "*[*^$|!~]?="),
                                          2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"),
                                          (h.appendChild(e).disabled = !0),
                                          2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"),
                                          e.querySelectorAll("*,:x"),
                                          y.push(",.*:");
                                  })),
                              (n.matchesSelector = K.test((m = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector))) &&
                                  de(function (e) {
                                      (n.disconnectedMatch = m.call(e, "*")), m.call(e, "[s!='']:x"), g.push("!=", z);
                                  }),
                              (y = y.length && new RegExp(y.join("|"))),
                              (g = g.length && new RegExp(g.join("|"))),
                              (t = K.test(h.compareDocumentPosition)),
                              (b =
                                  t || K.test(h.contains)
                                      ? function (e, t) {
                                            var n = 9 === e.nodeType ? e.documentElement : e,
                                                i = t && t.parentNode;
                                            return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
                                        }
                                      : function (e, t) {
                                            if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                            return !1;
                                        }),
                              ($ = t
                                  ? function (e, t) {
                                        if (e === t) return (u = !0), 0;
                                        var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                        return (
                                            i ||
                                            (1 & (i = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!n.sortDetached && t.compareDocumentPosition(e) === i)
                                                ? e == f || (e.ownerDocument == x && b(x, e))
                                                    ? -1
                                                    : t == f || (t.ownerDocument == x && b(x, t))
                                                    ? 1
                                                    : d
                                                    ? q(d, e) - q(d, t)
                                                    : 0
                                                : 4 & i
                                                ? -1
                                                : 1)
                                        );
                                    }
                                  : function (e, t) {
                                        if (e === t) return (u = !0), 0;
                                        var n,
                                            i = 0,
                                            o = e.parentNode,
                                            r = t.parentNode,
                                            s = [e],
                                            a = [t];
                                        if (!o || !r) return e == f ? -1 : t == f ? 1 : o ? -1 : r ? 1 : d ? q(d, e) - q(d, t) : 0;
                                        if (o === r) return pe(e, t);
                                        for (n = e; (n = n.parentNode); ) s.unshift(n);
                                        for (n = t; (n = n.parentNode); ) a.unshift(n);
                                        for (; s[i] === a[i]; ) i++;
                                        return i ? pe(s[i], a[i]) : s[i] == x ? -1 : a[i] == x ? 1 : 0;
                                    }),
                              f)
                            : f;
                    }),
                    (ae.matches = function (e, t) {
                        return ae(e, null, null, t);
                    }),
                    (ae.matchesSelector = function (e, t) {
                        if ((p(e), n.matchesSelector && v && !j[t + " "] && (!g || !g.test(t)) && (!y || !y.test(t))))
                            try {
                                var i = m.call(e, t);
                                if (i || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return i;
                            } catch (e) {
                                j(t, !0);
                            }
                        return ae(t, f, null, [e]).length > 0;
                    }),
                    (ae.contains = function (e, t) {
                        return (e.ownerDocument || e) != f && p(e), b(e, t);
                    }),
                    (ae.attr = function (e, t) {
                        (e.ownerDocument || e) != f && p(e);
                        var o = i.attrHandle[t.toLowerCase()],
                            r = o && E.call(i.attrHandle, t.toLowerCase()) ? o(e, t, !v) : void 0;
                        return void 0 !== r ? r : n.attributes || !v ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
                    }),
                    (ae.escape = function (e) {
                        return (e + "").replace(ie, oe);
                    }),
                    (ae.error = function (e) {
                        throw new Error("Syntax error, unrecognized expression: " + e);
                    }),
                    (ae.uniqueSort = function (e) {
                        var t,
                            i = [],
                            o = 0,
                            r = 0;
                        if (((u = !n.detectDuplicates), (d = !n.sortStable && e.slice(0)), e.sort($), u)) {
                            for (; (t = e[r++]); ) t === e[r] && (o = i.push(r));
                            for (; o--; ) e.splice(i[o], 1);
                        }
                        return (d = null), e;
                    }),
                    (o = ae.getText = function (e) {
                        var t,
                            n = "",
                            i = 0,
                            r = e.nodeType;
                        if (r) {
                            if (1 === r || 9 === r || 11 === r) {
                                if ("string" == typeof e.textContent) return e.textContent;
                                for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
                            } else if (3 === r || 4 === r) return e.nodeValue;
                        } else for (; (t = e[i++]); ) n += o(t);
                        return n;
                    }),
                    ((i = ae.selectors = {
                        cacheLength: 50,
                        createPseudo: ce,
                        match: V,
                        attrHandle: {},
                        find: {},
                        relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                        preFilter: {
                            ATTR: function (e) {
                                return (e[1] = e[1].replace(te, ne)), (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                            },
                            CHILD: function (e) {
                                return (
                                    (e[1] = e[1].toLowerCase()),
                                    "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && ae.error(e[0]),
                                    e
                                );
                            },
                            PSEUDO: function (e) {
                                var t,
                                    n = !e[6] && e[2];
                                return V.CHILD.test(e[0])
                                    ? null
                                    : (e[3] ? (e[2] = e[4] || e[5] || "") : n && X.test(n) && (t = s(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                            },
                        },
                        filter: {
                            TAG: function (e) {
                                var t = e.replace(te, ne).toLowerCase();
                                return "*" === e
                                    ? function () {
                                          return !0;
                                      }
                                    : function (e) {
                                          return e.nodeName && e.nodeName.toLowerCase() === t;
                                      };
                            },
                            CLASS: function (e) {
                                var t = k[e + " "];
                                return (
                                    t ||
                                    ((t = new RegExp("(^|" + N + ")" + e + "(" + N + "|$)")) &&
                                        k(e, function (e) {
                                            return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                                        }))
                                );
                            },
                            ATTR: function (e, t, n) {
                                return function (i) {
                                    var o = ae.attr(i, e);
                                    return null == o
                                        ? "!=" === t
                                        : !t ||
                                              ((o += ""),
                                              "=" === t
                                                  ? o === n
                                                  : "!=" === t
                                                  ? o !== n
                                                  : "^=" === t
                                                  ? n && 0 === o.indexOf(n)
                                                  : "*=" === t
                                                  ? n && o.indexOf(n) > -1
                                                  : "$=" === t
                                                  ? n && o.slice(-n.length) === n
                                                  : "~=" === t
                                                  ? (" " + o.replace(R, " ") + " ").indexOf(n) > -1
                                                  : "|=" === t && (o === n || o.slice(0, n.length + 1) === n + "-"));
                                };
                            },
                            CHILD: function (e, t, n, i, o) {
                                var r = "nth" !== e.slice(0, 3),
                                    s = "last" !== e.slice(-4),
                                    a = "of-type" === t;
                                return 1 === i && 0 === o
                                    ? function (e) {
                                          return !!e.parentNode;
                                      }
                                    : function (t, n, l) {
                                          var c,
                                              d,
                                              u,
                                              p,
                                              f,
                                              h,
                                              v = r !== s ? "nextSibling" : "previousSibling",
                                              y = t.parentNode,
                                              g = a && t.nodeName.toLowerCase(),
                                              m = !l && !a,
                                              b = !1;
                                          if (y) {
                                              if (r) {
                                                  for (; v; ) {
                                                      for (p = t; (p = p[v]); ) if (a ? p.nodeName.toLowerCase() === g : 1 === p.nodeType) return !1;
                                                      h = v = "only" === e && !h && "nextSibling";
                                                  }
                                                  return !0;
                                              }
                                              if (((h = [s ? y.firstChild : y.lastChild]), s && m)) {
                                                  for (
                                                      b = (f = (c = (d = (u = (p = y)[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] || [])[0] === T && c[1]) && c[2], p = f && y.childNodes[f];
                                                      (p = (++f && p && p[v]) || (b = f = 0) || h.pop());

                                                  )
                                                      if (1 === p.nodeType && ++b && p === t) {
                                                          d[e] = [T, f, b];
                                                          break;
                                                      }
                                              } else if ((m && (b = f = (c = (d = (u = (p = t)[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] || [])[0] === T && c[1]), !1 === b))
                                                  for (
                                                      ;
                                                      (p = (++f && p && p[v]) || (b = f = 0) || h.pop()) &&
                                                      ((a ? p.nodeName.toLowerCase() !== g : 1 !== p.nodeType) || !++b || (m && ((d = (u = p[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] = [T, b]), p !== t));

                                                  );
                                              return (b -= o) === i || (b % i == 0 && b / i >= 0);
                                          }
                                      };
                            },
                            PSEUDO: function (e, t) {
                                var n,
                                    o = i.pseudos[e] || i.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
                                return o[w]
                                    ? o(t)
                                    : o.length > 1
                                    ? ((n = [e, e, "", t]),
                                      i.setFilters.hasOwnProperty(e.toLowerCase())
                                          ? ce(function (e, n) {
                                                for (var i, r = o(e, t), s = r.length; s--; ) e[(i = q(e, r[s]))] = !(n[i] = r[s]);
                                            })
                                          : function (e) {
                                                return o(e, 0, n);
                                            })
                                    : o;
                            },
                        },
                        pseudos: {
                            not: ce(function (e) {
                                var t = [],
                                    n = [],
                                    i = a(e.replace(W, "$1"));
                                return i[w]
                                    ? ce(function (e, t, n, o) {
                                          for (var r, s = i(e, null, o, []), a = e.length; a--; ) (r = s[a]) && (e[a] = !(t[a] = r));
                                      })
                                    : function (e, o, r) {
                                          return (t[0] = e), i(t, null, r, n), (t[0] = null), !n.pop();
                                      };
                            }),
                            has: ce(function (e) {
                                return function (t) {
                                    return ae(e, t).length > 0;
                                };
                            }),
                            contains: ce(function (e) {
                                return (
                                    (e = e.replace(te, ne)),
                                    function (t) {
                                        return (t.textContent || o(t)).indexOf(e) > -1;
                                    }
                                );
                            }),
                            lang: ce(function (e) {
                                return (
                                    Y.test(e || "") || ae.error("unsupported lang: " + e),
                                    (e = e.replace(te, ne).toLowerCase()),
                                    function (t) {
                                        var n;
                                        do {
                                            if ((n = v ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                                        } while ((t = t.parentNode) && 1 === t.nodeType);
                                        return !1;
                                    }
                                );
                            }),
                            target: function (t) {
                                var n = e.location && e.location.hash;
                                return n && n.slice(1) === t.id;
                            },
                            root: function (e) {
                                return e === h;
                            },
                            focus: function (e) {
                                return e === f.activeElement && (!f.hasFocus || f.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                            },
                            enabled: ve(!1),
                            disabled: ve(!0),
                            checked: function (e) {
                                var t = e.nodeName.toLowerCase();
                                return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                            },
                            selected: function (e) {
                                return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                            },
                            empty: function (e) {
                                for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                                return !0;
                            },
                            parent: function (e) {
                                return !i.pseudos.empty(e);
                            },
                            header: function (e) {
                                return Q.test(e.nodeName);
                            },
                            input: function (e) {
                                return G.test(e.nodeName);
                            },
                            button: function (e) {
                                var t = e.nodeName.toLowerCase();
                                return ("input" === t && "button" === e.type) || "button" === t;
                            },
                            text: function (e) {
                                var t;
                                return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                            },
                            first: ye(function () {
                                return [0];
                            }),
                            last: ye(function (e, t) {
                                return [t - 1];
                            }),
                            eq: ye(function (e, t, n) {
                                return [n < 0 ? n + t : n];
                            }),
                            even: ye(function (e, t) {
                                for (var n = 0; n < t; n += 2) e.push(n);
                                return e;
                            }),
                            odd: ye(function (e, t) {
                                for (var n = 1; n < t; n += 2) e.push(n);
                                return e;
                            }),
                            lt: ye(function (e, t, n) {
                                for (var i = n < 0 ? n + t : n > t ? t : n; --i >= 0; ) e.push(i);
                                return e;
                            }),
                            gt: ye(function (e, t, n) {
                                for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                                return e;
                            }),
                        },
                    }).pseudos.nth = i.pseudos.eq),
                    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                        i.pseudos[t] = fe(t);
                    for (t in { submit: !0, reset: !0 }) i.pseudos[t] = he(t);
                    function me() {}
                    function be(e) {
                        for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
                        return i;
                    }
                    function we(e, t, n) {
                        var i = t.dir,
                            o = t.next,
                            r = o || i,
                            s = n && "parentNode" === r,
                            a = S++;
                        return t.first
                            ? function (t, n, o) {
                                  for (; (t = t[i]); ) if (1 === t.nodeType || s) return e(t, n, o);
                                  return !1;
                              }
                            : function (t, n, l) {
                                  var c,
                                      d,
                                      u,
                                      p = [T, a];
                                  if (l) {
                                      for (; (t = t[i]); ) if ((1 === t.nodeType || s) && e(t, n, l)) return !0;
                                  } else
                                      for (; (t = t[i]); )
                                          if (1 === t.nodeType || s)
                                              if (((d = (u = t[w] || (t[w] = {}))[t.uniqueID] || (u[t.uniqueID] = {})), o && o === t.nodeName.toLowerCase())) t = t[i] || t;
                                              else {
                                                  if ((c = d[r]) && c[0] === T && c[1] === a) return (p[2] = c[2]);
                                                  if (((d[r] = p), (p[2] = e(t, n, l)))) return !0;
                                              }
                                  return !1;
                              };
                    }
                    function xe(e) {
                        return e.length > 1
                            ? function (t, n, i) {
                                  for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
                                  return !0;
                              }
                            : e[0];
                    }
                    function Te(e, t, n, i, o) {
                        for (var r, s = [], a = 0, l = e.length, c = null != t; a < l; a++) (r = e[a]) && ((n && !n(r, i, o)) || (s.push(r), c && t.push(a)));
                        return s;
                    }
                    function Se(e, t, n, i, o, r) {
                        return (
                            i && !i[w] && (i = Se(i)),
                            o && !o[w] && (o = Se(o, r)),
                            ce(function (r, s, a, l) {
                                var c,
                                    d,
                                    u,
                                    p = [],
                                    f = [],
                                    h = s.length,
                                    v =
                                        r ||
                                        (function (e, t, n) {
                                            for (var i = 0, o = t.length; i < o; i++) ae(e, t[i], n);
                                            return n;
                                        })(t || "*", a.nodeType ? [a] : a, []),
                                    y = !e || (!r && t) ? v : Te(v, p, e, a, l),
                                    g = n ? (o || (r ? e : h || i) ? [] : s) : y;
                                if ((n && n(y, g, a, l), i)) for (c = Te(g, f), i(c, [], a, l), d = c.length; d--; ) (u = c[d]) && (g[f[d]] = !(y[f[d]] = u));
                                if (r) {
                                    if (o || e) {
                                        if (o) {
                                            for (c = [], d = g.length; d--; ) (u = g[d]) && c.push((y[d] = u));
                                            o(null, (g = []), c, l);
                                        }
                                        for (d = g.length; d--; ) (u = g[d]) && (c = o ? q(r, u) : p[d]) > -1 && (r[c] = !(s[c] = u));
                                    }
                                } else (g = Te(g === s ? g.splice(h, g.length) : g)), o ? o(null, s, g, l) : M.apply(s, g);
                            })
                        );
                    }
                    function ke(e) {
                        for (
                            var t,
                                n,
                                o,
                                r = e.length,
                                s = i.relative[e[0].type],
                                a = s || i.relative[" "],
                                l = s ? 1 : 0,
                                d = we(
                                    function (e) {
                                        return e === t;
                                    },
                                    a,
                                    !0
                                ),
                                u = we(
                                    function (e) {
                                        return q(t, e) > -1;
                                    },
                                    a,
                                    !0
                                ),
                                p = [
                                    function (e, n, i) {
                                        var o = (!s && (i || n !== c)) || ((t = n).nodeType ? d(e, n, i) : u(e, n, i));
                                        return (t = null), o;
                                    },
                                ];
                            l < r;
                            l++
                        )
                            if ((n = i.relative[e[l].type])) p = [we(xe(p), n)];
                            else {
                                if ((n = i.filter[e[l].type].apply(null, e[l].matches))[w]) {
                                    for (o = ++l; o < r && !i.relative[e[o].type]; o++);
                                    return Se(
                                        l > 1 && xe(p),
                                        l > 1 && be(e.slice(0, l - 1).concat({ value: " " === e[l - 2].type ? "*" : "" })).replace(W, "$1"),
                                        n,
                                        l < o && ke(e.slice(l, o)),
                                        o < r && ke((e = e.slice(o))),
                                        o < r && be(e)
                                    );
                                }
                                p.push(n);
                            }
                        return xe(p);
                    }
                    return (
                        (me.prototype = i.filters = i.pseudos),
                        (i.setFilters = new me()),
                        (s = ae.tokenize = function (e, t) {
                            var n,
                                o,
                                r,
                                s,
                                a,
                                l,
                                c,
                                d = C[e + " "];
                            if (d) return t ? 0 : d.slice(0);
                            for (a = e, l = [], c = i.preFilter; a; ) {
                                for (s in ((n && !(o = F.exec(a))) || (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
                                (n = !1),
                                (o = B.exec(a)) && ((n = o.shift()), r.push({ value: n, type: o[0].replace(W, " ") }), (a = a.slice(n.length))),
                                i.filter))
                                    !(o = V[s].exec(a)) || (c[s] && !(o = c[s](o))) || ((n = o.shift()), r.push({ value: n, type: s, matches: o }), (a = a.slice(n.length)));
                                if (!n) break;
                            }
                            return t ? a.length : a ? ae.error(e) : C(e, l).slice(0);
                        }),
                        (a = ae.compile = function (e, t) {
                            var n,
                                o = [],
                                r = [],
                                a = A[e + " "];
                            if (!a) {
                                for (t || (t = s(e)), n = t.length; n--; ) (a = ke(t[n]))[w] ? o.push(a) : r.push(a);
                                (a = A(
                                    e,
                                    (function (e, t) {
                                        var n = t.length > 0,
                                            o = e.length > 0,
                                            r = function (r, s, a, l, d) {
                                                var u,
                                                    h,
                                                    y,
                                                    g = 0,
                                                    m = "0",
                                                    b = r && [],
                                                    w = [],
                                                    x = c,
                                                    S = r || (o && i.find.TAG("*", d)),
                                                    k = (T += null == x ? 1 : Math.random() || 0.1),
                                                    C = S.length;
                                                for (d && (c = s == f || s || d); m !== C && null != (u = S[m]); m++) {
                                                    if (o && u) {
                                                        for (h = 0, s || u.ownerDocument == f || (p(u), (a = !v)); (y = e[h++]); )
                                                            if (y(u, s || f, a)) {
                                                                l.push(u);
                                                                break;
                                                            }
                                                        d && (T = k);
                                                    }
                                                    n && ((u = !y && u) && g--, r && b.push(u));
                                                }
                                                if (((g += m), n && m !== g)) {
                                                    for (h = 0; (y = t[h++]); ) y(b, w, s, a);
                                                    if (r) {
                                                        if (g > 0) for (; m--; ) b[m] || w[m] || (w[m] = D.call(l));
                                                        w = Te(w);
                                                    }
                                                    M.apply(l, w), d && !r && w.length > 0 && g + t.length > 1 && ae.uniqueSort(l);
                                                }
                                                return d && ((T = k), (c = x)), b;
                                            };
                                        return n ? ce(r) : r;
                                    })(r, o)
                                )).selector = e;
                            }
                            return a;
                        }),
                        (l = ae.select = function (e, t, n, o) {
                            var r,
                                l,
                                c,
                                d,
                                u,
                                p = "function" == typeof e && e,
                                f = !o && s((e = p.selector || e));
                            if (((n = n || []), 1 === f.length)) {
                                if ((l = f[0] = f[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && 9 === t.nodeType && v && i.relative[l[1].type]) {
                                    if (!(t = (i.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
                                    p && (t = t.parentNode), (e = e.slice(l.shift().value.length));
                                }
                                for (r = V.needsContext.test(e) ? 0 : l.length; r-- && ((c = l[r]), !i.relative[(d = c.type)]); )
                                    if ((u = i.find[d]) && (o = u(c.matches[0].replace(te, ne), (ee.test(l[0].type) && ge(t.parentNode)) || t))) {
                                        if ((l.splice(r, 1), !(e = o.length && be(l)))) return M.apply(n, o), n;
                                        break;
                                    }
                            }
                            return (p || a(e, f))(o, t, !v, n, !t || (ee.test(e) && ge(t.parentNode)) || t), n;
                        }),
                        (n.sortStable = w.split("").sort($).join("") === w),
                        (n.detectDuplicates = !!u),
                        p(),
                        (n.sortDetached = de(function (e) {
                            return 1 & e.compareDocumentPosition(f.createElement("fieldset"));
                        })),
                        de(function (e) {
                            return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                        }) ||
                            ue("type|href|height|width", function (e, t, n) {
                                if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                            }),
                        (n.attributes &&
                            de(function (e) {
                                return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                            })) ||
                            ue("value", function (e, t, n) {
                                if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                            }),
                        de(function (e) {
                            return null == e.getAttribute("disabled");
                        }) ||
                            ue(P, function (e, t, n) {
                                var i;
                                if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
                            }),
                        ae
                    );
                })(n);
            (S.find = C), (S.expr = C.selectors), (S.expr[":"] = S.expr.pseudos), (S.uniqueSort = S.unique = C.uniqueSort), (S.text = C.getText), (S.isXMLDoc = C.isXML), (S.contains = C.contains), (S.escapeSelector = C.escape);
            var A = function (e, t, n) {
                    for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                        if (1 === e.nodeType) {
                            if (o && S(e).is(n)) break;
                            i.push(e);
                        }
                    return i;
                },
                j = function (e, t) {
                    for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                    return n;
                },
                $ = S.expr.match.needsContext;
            function E(e, t) {
                return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
            }
            var L = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
            function D(e, t, n) {
                return g(t)
                    ? S.grep(e, function (e, i) {
                          return !!t.call(e, i, e) !== n;
                      })
                    : t.nodeType
                    ? S.grep(e, function (e) {
                          return (e === t) !== n;
                      })
                    : "string" != typeof t
                    ? S.grep(e, function (e) {
                          return d.call(t, e) > -1 !== n;
                      })
                    : S.filter(t, e, n);
            }
            (S.filter = function (e, t, n) {
                var i = t[0];
                return (
                    n && (e = ":not(" + e + ")"),
                    1 === t.length && 1 === i.nodeType
                        ? S.find.matchesSelector(i, e)
                            ? [i]
                            : []
                        : S.find.matches(
                              e,
                              S.grep(t, function (e) {
                                  return 1 === e.nodeType;
                              })
                          )
                );
            }),
                S.fn.extend({
                    find: function (e) {
                        var t,
                            n,
                            i = this.length,
                            o = this;
                        if ("string" != typeof e)
                            return this.pushStack(
                                S(e).filter(function () {
                                    for (t = 0; t < i; t++) if (S.contains(o[t], this)) return !0;
                                })
                            );
                        for (n = this.pushStack([]), t = 0; t < i; t++) S.find(e, o[t], n);
                        return i > 1 ? S.uniqueSort(n) : n;
                    },
                    filter: function (e) {
                        return this.pushStack(D(this, e || [], !1));
                    },
                    not: function (e) {
                        return this.pushStack(D(this, e || [], !0));
                    },
                    is: function (e) {
                        return !!D(this, "string" == typeof e && $.test(e) ? S(e) : e || [], !1).length;
                    },
                });
            var O,
                M = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
            ((S.fn.init = function (e, t, n) {
                var i, o;
                if (!e) return this;
                if (((n = n || O), "string" == typeof e)) {
                    if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : M.exec(e)) || (!i[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                    if (i[1]) {
                        if (((t = t instanceof S ? t[0] : t), S.merge(this, S.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : b, !0)), L.test(i[1]) && S.isPlainObject(t)))
                            for (i in t) g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                        return this;
                    }
                    return (o = b.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this;
                }
                return e.nodeType ? ((this[0] = e), (this.length = 1), this) : g(e) ? (void 0 !== n.ready ? n.ready(e) : e(S)) : S.makeArray(e, this);
            }).prototype = S.fn),
                (O = S(b));
            var H = /^(?:parents|prev(?:Until|All))/,
                q = { children: !0, contents: !0, next: !0, prev: !0 };
            function P(e, t) {
                for (; (e = e[t]) && 1 !== e.nodeType; );
                return e;
            }
            S.fn.extend({
                has: function (e) {
                    var t = S(e, this),
                        n = t.length;
                    return this.filter(function () {
                        for (var e = 0; e < n; e++) if (S.contains(this, t[e])) return !0;
                    });
                },
                closest: function (e, t) {
                    var n,
                        i = 0,
                        o = this.length,
                        r = [],
                        s = "string" != typeof e && S(e);
                    if (!$.test(e))
                        for (; i < o; i++)
                            for (n = this[i]; n && n !== t; n = n.parentNode)
                                if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && S.find.matchesSelector(n, e))) {
                                    r.push(n);
                                    break;
                                }
                    return this.pushStack(r.length > 1 ? S.uniqueSort(r) : r);
                },
                index: function (e) {
                    return e ? ("string" == typeof e ? d.call(S(e), this[0]) : d.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
                },
                add: function (e, t) {
                    return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
                },
                addBack: function (e) {
                    return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
                },
            }),
                S.each(
                    {
                        parent: function (e) {
                            var t = e.parentNode;
                            return t && 11 !== t.nodeType ? t : null;
                        },
                        parents: function (e) {
                            return A(e, "parentNode");
                        },
                        parentsUntil: function (e, t, n) {
                            return A(e, "parentNode", n);
                        },
                        next: function (e) {
                            return P(e, "nextSibling");
                        },
                        prev: function (e) {
                            return P(e, "previousSibling");
                        },
                        nextAll: function (e) {
                            return A(e, "nextSibling");
                        },
                        prevAll: function (e) {
                            return A(e, "previousSibling");
                        },
                        nextUntil: function (e, t, n) {
                            return A(e, "nextSibling", n);
                        },
                        prevUntil: function (e, t, n) {
                            return A(e, "previousSibling", n);
                        },
                        siblings: function (e) {
                            return j((e.parentNode || {}).firstChild, e);
                        },
                        children: function (e) {
                            return j(e.firstChild);
                        },
                        contents: function (e) {
                            return null != e.contentDocument && s(e.contentDocument) ? e.contentDocument : (E(e, "template") && (e = e.content || e), S.merge([], e.childNodes));
                        },
                    },
                    function (e, t) {
                        S.fn[e] = function (n, i) {
                            var o = S.map(this, t, n);
                            return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = S.filter(i, o)), this.length > 1 && (q[e] || S.uniqueSort(o), H.test(e) && o.reverse()), this.pushStack(o);
                        };
                    }
                );
            var N = /[^\x20\t\r\n\f]+/g;
            function I(e) {
                return e;
            }
            function _(e) {
                throw e;
            }
            function z(e, t, n, i) {
                var o;
                try {
                    e && g((o = e.promise)) ? o.call(e).done(t).fail(n) : e && g((o = e.then)) ? o.call(e, t, n) : t.apply(void 0, [e].slice(i));
                } catch (e) {
                    n.apply(void 0, [e]);
                }
            }
            (S.Callbacks = function (e) {
                e =
                    "string" == typeof e
                        ? (function (e) {
                              var t = {};
                              return (
                                  S.each(e.match(N) || [], function (e, n) {
                                      t[n] = !0;
                                  }),
                                  t
                              );
                          })(e)
                        : S.extend({}, e);
                var t,
                    n,
                    i,
                    o,
                    r = [],
                    s = [],
                    a = -1,
                    l = function () {
                        for (o = o || e.once, i = t = !0; s.length; a = -1) for (n = s.shift(); ++a < r.length; ) !1 === r[a].apply(n[0], n[1]) && e.stopOnFalse && ((a = r.length), (n = !1));
                        e.memory || (n = !1), (t = !1), o && (r = n ? [] : "");
                    },
                    c = {
                        add: function () {
                            return (
                                r &&
                                    (n && !t && ((a = r.length - 1), s.push(n)),
                                    (function t(n) {
                                        S.each(n, function (n, i) {
                                            g(i) ? (e.unique && c.has(i)) || r.push(i) : i && i.length && "string" !== T(i) && t(i);
                                        });
                                    })(arguments),
                                    n && !t && l()),
                                this
                            );
                        },
                        remove: function () {
                            return (
                                S.each(arguments, function (e, t) {
                                    for (var n; (n = S.inArray(t, r, n)) > -1; ) r.splice(n, 1), n <= a && a--;
                                }),
                                this
                            );
                        },
                        has: function (e) {
                            return e ? S.inArray(e, r) > -1 : r.length > 0;
                        },
                        empty: function () {
                            return r && (r = []), this;
                        },
                        disable: function () {
                            return (o = s = []), (r = n = ""), this;
                        },
                        disabled: function () {
                            return !r;
                        },
                        lock: function () {
                            return (o = s = []), n || t || (r = n = ""), this;
                        },
                        locked: function () {
                            return !!o;
                        },
                        fireWith: function (e, n) {
                            return o || ((n = [e, (n = n || []).slice ? n.slice() : n]), s.push(n), t || l()), this;
                        },
                        fire: function () {
                            return c.fireWith(this, arguments), this;
                        },
                        fired: function () {
                            return !!i;
                        },
                    };
                return c;
            }),
                S.extend({
                    Deferred: function (e) {
                        var t = [
                                ["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2],
                                ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"],
                                ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"],
                            ],
                            i = "pending",
                            o = {
                                state: function () {
                                    return i;
                                },
                                always: function () {
                                    return r.done(arguments).fail(arguments), this;
                                },
                                catch: function (e) {
                                    return o.then(null, e);
                                },
                                pipe: function () {
                                    var e = arguments;
                                    return S.Deferred(function (n) {
                                        S.each(t, function (t, i) {
                                            var o = g(e[i[4]]) && e[i[4]];
                                            r[i[1]](function () {
                                                var e = o && o.apply(this, arguments);
                                                e && g(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this, o ? [e] : arguments);
                                            });
                                        }),
                                            (e = null);
                                    }).promise();
                                },
                                then: function (e, i, o) {
                                    var r = 0;
                                    function s(e, t, i, o) {
                                        return function () {
                                            var a = this,
                                                l = arguments,
                                                c = function () {
                                                    var n, c;
                                                    if (!(e < r)) {
                                                        if ((n = i.apply(a, l)) === t.promise()) throw new TypeError("Thenable self-resolution");
                                                        (c = n && ("object" == typeof n || "function" == typeof n) && n.then),
                                                            g(c)
                                                                ? o
                                                                    ? c.call(n, s(r, t, I, o), s(r, t, _, o))
                                                                    : (r++, c.call(n, s(r, t, I, o), s(r, t, _, o), s(r, t, I, t.notifyWith)))
                                                                : (i !== I && ((a = void 0), (l = [n])), (o || t.resolveWith)(a, l));
                                                    }
                                                },
                                                d = o
                                                    ? c
                                                    : function () {
                                                          try {
                                                              c();
                                                          } catch (n) {
                                                              S.Deferred.exceptionHook && S.Deferred.exceptionHook(n, d.stackTrace), e + 1 >= r && (i !== _ && ((a = void 0), (l = [n])), t.rejectWith(a, l));
                                                          }
                                                      };
                                            e ? d() : (S.Deferred.getStackHook && (d.stackTrace = S.Deferred.getStackHook()), n.setTimeout(d));
                                        };
                                    }
                                    return S.Deferred(function (n) {
                                        t[0][3].add(s(0, n, g(o) ? o : I, n.notifyWith)), t[1][3].add(s(0, n, g(e) ? e : I)), t[2][3].add(s(0, n, g(i) ? i : _));
                                    }).promise();
                                },
                                promise: function (e) {
                                    return null != e ? S.extend(e, o) : o;
                                },
                            },
                            r = {};
                        return (
                            S.each(t, function (e, n) {
                                var s = n[2],
                                    a = n[5];
                                (o[n[1]] = s.add),
                                    a &&
                                        s.add(
                                            function () {
                                                i = a;
                                            },
                                            t[3 - e][2].disable,
                                            t[3 - e][3].disable,
                                            t[0][2].lock,
                                            t[0][3].lock
                                        ),
                                    s.add(n[3].fire),
                                    (r[n[0]] = function () {
                                        return r[n[0] + "With"](this === r ? void 0 : this, arguments), this;
                                    }),
                                    (r[n[0] + "With"] = s.fireWith);
                            }),
                            o.promise(r),
                            e && e.call(r, r),
                            r
                        );
                    },
                    when: function (e) {
                        var t = arguments.length,
                            n = t,
                            i = Array(n),
                            o = a.call(arguments),
                            r = S.Deferred(),
                            s = function (e) {
                                return function (n) {
                                    (i[e] = this), (o[e] = arguments.length > 1 ? a.call(arguments) : n), --t || r.resolveWith(i, o);
                                };
                            };
                        if (t <= 1 && (z(e, r.done(s(n)).resolve, r.reject, !t), "pending" === r.state() || g(o[n] && o[n].then))) return r.then();
                        for (; n--; ) z(o[n], s(n), r.reject);
                        return r.promise();
                    },
                });
            var R = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
            (S.Deferred.exceptionHook = function (e, t) {
                n.console && n.console.warn && e && R.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
            }),
                (S.readyException = function (e) {
                    n.setTimeout(function () {
                        throw e;
                    });
                });
            var W = S.Deferred();
            function F() {
                b.removeEventListener("DOMContentLoaded", F), n.removeEventListener("load", F), S.ready();
            }
            (S.fn.ready = function (e) {
                return (
                    W.then(e).catch(function (e) {
                        S.readyException(e);
                    }),
                    this
                );
            }),
                S.extend({
                    isReady: !1,
                    readyWait: 1,
                    ready: function (e) {
                        (!0 === e ? --S.readyWait : S.isReady) || ((S.isReady = !0), (!0 !== e && --S.readyWait > 0) || W.resolveWith(b, [S]));
                    },
                }),
                (S.ready.then = W.then),
                "complete" === b.readyState || ("loading" !== b.readyState && !b.documentElement.doScroll) ? n.setTimeout(S.ready) : (b.addEventListener("DOMContentLoaded", F), n.addEventListener("load", F));
            var B = function (e, t, n, i, o, r, s) {
                    var a = 0,
                        l = e.length,
                        c = null == n;
                    if ("object" === T(n)) for (a in ((o = !0), n)) B(e, t, a, n[a], !0, r, s);
                    else if (
                        void 0 !== i &&
                        ((o = !0),
                        g(i) || (s = !0),
                        c &&
                            (s
                                ? (t.call(e, i), (t = null))
                                : ((c = t),
                                  (t = function (e, t, n) {
                                      return c.call(S(e), n);
                                  }))),
                        t)
                    )
                        for (; a < l; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
                    return o ? e : c ? t.call(e) : l ? t(e[0], n) : r;
                },
                U = /^-ms-/,
                X = /-([a-z])/g;
            function Y(e, t) {
                return t.toUpperCase();
            }
            function V(e) {
                return e.replace(U, "ms-").replace(X, Y);
            }
            var J = function (e) {
                return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
            };
            function G() {
                this.expando = S.expando + G.uid++;
            }
            (G.uid = 1),
                (G.prototype = {
                    cache: function (e) {
                        var t = e[this.expando];
                        return t || ((t = {}), J(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
                    },
                    set: function (e, t, n) {
                        var i,
                            o = this.cache(e);
                        if ("string" == typeof t) o[V(t)] = n;
                        else for (i in t) o[V(i)] = t[i];
                        return o;
                    },
                    get: function (e, t) {
                        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][V(t)];
                    },
                    access: function (e, t, n) {
                        return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
                    },
                    remove: function (e, t) {
                        var n,
                            i = e[this.expando];
                        if (void 0 !== i) {
                            if (void 0 !== t) {
                                n = (t = Array.isArray(t) ? t.map(V) : (t = V(t)) in i ? [t] : t.match(N) || []).length;
                                for (; n--; ) delete i[t[n]];
                            }
                            (void 0 === t || S.isEmptyObject(i)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                        }
                    },
                    hasData: function (e) {
                        var t = e[this.expando];
                        return void 0 !== t && !S.isEmptyObject(t);
                    },
                });
            var Q = new G(),
                K = new G(),
                Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                ee = /[A-Z]/g;
            function te(e, t, n) {
                var i;
                if (void 0 === n && 1 === e.nodeType)
                    if (((i = "data-" + t.replace(ee, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(i)))) {
                        try {
                            n = (function (e) {
                                return "true" === e || ("false" !== e && ("null" === e ? null : e === +e + "" ? +e : Z.test(e) ? JSON.parse(e) : e));
                            })(n);
                        } catch (e) {}
                        K.set(e, t, n);
                    } else n = void 0;
                return n;
            }
            S.extend({
                hasData: function (e) {
                    return K.hasData(e) || Q.hasData(e);
                },
                data: function (e, t, n) {
                    return K.access(e, t, n);
                },
                removeData: function (e, t) {
                    K.remove(e, t);
                },
                _data: function (e, t, n) {
                    return Q.access(e, t, n);
                },
                _removeData: function (e, t) {
                    Q.remove(e, t);
                },
            }),
                S.fn.extend({
                    data: function (e, t) {
                        var n,
                            i,
                            o,
                            r = this[0],
                            s = r && r.attributes;
                        if (void 0 === e) {
                            if (this.length && ((o = K.get(r)), 1 === r.nodeType && !Q.get(r, "hasDataAttrs"))) {
                                for (n = s.length; n--; ) s[n] && 0 === (i = s[n].name).indexOf("data-") && ((i = V(i.slice(5))), te(r, i, o[i]));
                                Q.set(r, "hasDataAttrs", !0);
                            }
                            return o;
                        }
                        return "object" == typeof e
                            ? this.each(function () {
                                  K.set(this, e);
                              })
                            : B(
                                  this,
                                  function (t) {
                                      var n;
                                      if (r && void 0 === t) return void 0 !== (n = K.get(r, e)) || void 0 !== (n = te(r, e)) ? n : void 0;
                                      this.each(function () {
                                          K.set(this, e, t);
                                      });
                                  },
                                  null,
                                  t,
                                  arguments.length > 1,
                                  null,
                                  !0
                              );
                    },
                    removeData: function (e) {
                        return this.each(function () {
                            K.remove(this, e);
                        });
                    },
                }),
                S.extend({
                    queue: function (e, t, n) {
                        var i;
                        if (e) return (t = (t || "fx") + "queue"), (i = Q.get(e, t)), n && (!i || Array.isArray(n) ? (i = Q.access(e, t, S.makeArray(n))) : i.push(n)), i || [];
                    },
                    dequeue: function (e, t) {
                        t = t || "fx";
                        var n = S.queue(e, t),
                            i = n.length,
                            o = n.shift(),
                            r = S._queueHooks(e, t);
                        "inprogress" === o && ((o = n.shift()), i--),
                            o &&
                                ("fx" === t && n.unshift("inprogress"),
                                delete r.stop,
                                o.call(
                                    e,
                                    function () {
                                        S.dequeue(e, t);
                                    },
                                    r
                                )),
                            !i && r && r.empty.fire();
                    },
                    _queueHooks: function (e, t) {
                        var n = t + "queueHooks";
                        return (
                            Q.get(e, n) ||
                            Q.access(e, n, {
                                empty: S.Callbacks("once memory").add(function () {
                                    Q.remove(e, [t + "queue", n]);
                                }),
                            })
                        );
                    },
                }),
                S.fn.extend({
                    queue: function (e, t) {
                        var n = 2;
                        return (
                            "string" != typeof e && ((t = e), (e = "fx"), n--),
                            arguments.length < n
                                ? S.queue(this[0], e)
                                : void 0 === t
                                ? this
                                : this.each(function () {
                                      var n = S.queue(this, e, t);
                                      S._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && S.dequeue(this, e);
                                  })
                        );
                    },
                    dequeue: function (e) {
                        return this.each(function () {
                            S.dequeue(this, e);
                        });
                    },
                    clearQueue: function (e) {
                        return this.queue(e || "fx", []);
                    },
                    promise: function (e, t) {
                        var n,
                            i = 1,
                            o = S.Deferred(),
                            r = this,
                            s = this.length,
                            a = function () {
                                --i || o.resolveWith(r, [r]);
                            };
                        for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; s--; ) (n = Q.get(r[s], e + "queueHooks")) && n.empty && (i++, n.empty.add(a));
                        return a(), o.promise(t);
                    },
                });
            var ne = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                ie = new RegExp("^(?:([+-])=|)(" + ne + ")([a-z%]*)$", "i"),
                oe = ["Top", "Right", "Bottom", "Left"],
                re = b.documentElement,
                se = function (e) {
                    return S.contains(e.ownerDocument, e);
                },
                ae = { composed: !0 };
            re.getRootNode &&
                (se = function (e) {
                    return S.contains(e.ownerDocument, e) || e.getRootNode(ae) === e.ownerDocument;
                });
            var le = function (e, t) {
                return "none" === (e = t || e).style.display || ("" === e.style.display && se(e) && "none" === S.css(e, "display"));
            };
            function ce(e, t, n, i) {
                var o,
                    r,
                    s = 20,
                    a = i
                        ? function () {
                              return i.cur();
                          }
                        : function () {
                              return S.css(e, t, "");
                          },
                    l = a(),
                    c = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
                    d = e.nodeType && (S.cssNumber[t] || ("px" !== c && +l)) && ie.exec(S.css(e, t));
                if (d && d[3] !== c) {
                    for (l /= 2, c = c || d[3], d = +l || 1; s--; ) S.style(e, t, d + c), (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0), (d /= r);
                    (d *= 2), S.style(e, t, d + c), (n = n || []);
                }
                return n && ((d = +d || +l || 0), (o = n[1] ? d + (n[1] + 1) * n[2] : +n[2]), i && ((i.unit = c), (i.start = d), (i.end = o))), o;
            }
            var de = {};
            function ue(e) {
                var t,
                    n = e.ownerDocument,
                    i = e.nodeName,
                    o = de[i];
                return o || ((t = n.body.appendChild(n.createElement(i))), (o = S.css(t, "display")), t.parentNode.removeChild(t), "none" === o && (o = "block"), (de[i] = o), o);
            }
            function pe(e, t) {
                for (var n, i, o = [], r = 0, s = e.length; r < s; r++)
                    (i = e[r]).style &&
                        ((n = i.style.display),
                        t ? ("none" === n && ((o[r] = Q.get(i, "display") || null), o[r] || (i.style.display = "")), "" === i.style.display && le(i) && (o[r] = ue(i))) : "none" !== n && ((o[r] = "none"), Q.set(i, "display", n)));
                for (r = 0; r < s; r++) null != o[r] && (e[r].style.display = o[r]);
                return e;
            }
            S.fn.extend({
                show: function () {
                    return pe(this, !0);
                },
                hide: function () {
                    return pe(this);
                },
                toggle: function (e) {
                    return "boolean" == typeof e
                        ? e
                            ? this.show()
                            : this.hide()
                        : this.each(function () {
                              le(this) ? S(this).show() : S(this).hide();
                          });
                },
            });
            var fe,
                he,
                ve = /^(?:checkbox|radio)$/i,
                ye = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
                ge = /^$|^module$|\/(?:java|ecma)script/i;
            (fe = b.createDocumentFragment().appendChild(b.createElement("div"))),
                (he = b.createElement("input")).setAttribute("type", "radio"),
                he.setAttribute("checked", "checked"),
                he.setAttribute("name", "t"),
                fe.appendChild(he),
                (y.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked),
                (fe.innerHTML = "<textarea>x</textarea>"),
                (y.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue),
                (fe.innerHTML = "<option></option>"),
                (y.option = !!fe.lastChild);
            var me = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
            function be(e, t) {
                var n;
                return (n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && E(e, t)) ? S.merge([e], n) : n;
            }
            function we(e, t) {
                for (var n = 0, i = e.length; n < i; n++) Q.set(e[n], "globalEval", !t || Q.get(t[n], "globalEval"));
            }
            (me.tbody = me.tfoot = me.colgroup = me.caption = me.thead), (me.th = me.td), y.option || (me.optgroup = me.option = [1, "<select multiple='multiple'>", "</select>"]);
            var xe = /<|&#?\w+;/;
            function Te(e, t, n, i, o) {
                for (var r, s, a, l, c, d, u = t.createDocumentFragment(), p = [], f = 0, h = e.length; f < h; f++)
                    if ((r = e[f]) || 0 === r)
                        if ("object" === T(r)) S.merge(p, r.nodeType ? [r] : r);
                        else if (xe.test(r)) {
                            for (s = s || u.appendChild(t.createElement("div")), a = (ye.exec(r) || ["", ""])[1].toLowerCase(), l = me[a] || me._default, s.innerHTML = l[1] + S.htmlPrefilter(r) + l[2], d = l[0]; d--; ) s = s.lastChild;
                            S.merge(p, s.childNodes), ((s = u.firstChild).textContent = "");
                        } else p.push(t.createTextNode(r));
                for (u.textContent = "", f = 0; (r = p[f++]); )
                    if (i && S.inArray(r, i) > -1) o && o.push(r);
                    else if (((c = se(r)), (s = be(u.appendChild(r), "script")), c && we(s), n)) for (d = 0; (r = s[d++]); ) ge.test(r.type || "") && n.push(r);
                return u;
            }
            var Se = /^([^.]*)(?:\.(.+)|)/;
            function ke() {
                return !0;
            }
            function Ce() {
                return !1;
            }
            function Ae(e, t) {
                return (
                    (e ===
                        (function () {
                            try {
                                return b.activeElement;
                            } catch (e) {}
                        })()) ==
                    ("focus" === t)
                );
            }
            function je(e, t, n, i, o, r) {
                var s, a;
                if ("object" == typeof t) {
                    for (a in ("string" != typeof n && ((i = i || n), (n = void 0)), t)) je(e, a, n, i, t[a], r);
                    return e;
                }
                if ((null == i && null == o ? ((o = n), (i = n = void 0)) : null == o && ("string" == typeof n ? ((o = i), (i = void 0)) : ((o = i), (i = n), (n = void 0))), !1 === o)) o = Ce;
                else if (!o) return e;
                return (
                    1 === r &&
                        ((s = o),
                        ((o = function (e) {
                            return S().off(e), s.apply(this, arguments);
                        }).guid = s.guid || (s.guid = S.guid++))),
                    e.each(function () {
                        S.event.add(this, t, o, i, n);
                    })
                );
            }
            function $e(e, t, n) {
                n
                    ? (Q.set(e, t, !1),
                      S.event.add(e, t, {
                          namespace: !1,
                          handler: function (e) {
                              var i,
                                  o,
                                  r = Q.get(this, t);
                              if (1 & e.isTrigger && this[t]) {
                                  if (r.length) (S.event.special[t] || {}).delegateType && e.stopPropagation();
                                  else if (((r = a.call(arguments)), Q.set(this, t, r), (i = n(this, t)), this[t](), r !== (o = Q.get(this, t)) || i ? Q.set(this, t, !1) : (o = {}), r !== o))
                                      return e.stopImmediatePropagation(), e.preventDefault(), o && o.value;
                              } else r.length && (Q.set(this, t, { value: S.event.trigger(S.extend(r[0], S.Event.prototype), r.slice(1), this) }), e.stopImmediatePropagation());
                          },
                      }))
                    : void 0 === Q.get(e, t) && S.event.add(e, t, ke);
            }
            (S.event = {
                global: {},
                add: function (e, t, n, i, o) {
                    var r,
                        s,
                        a,
                        l,
                        c,
                        d,
                        u,
                        p,
                        f,
                        h,
                        v,
                        y = Q.get(e);
                    if (J(e))
                        for (
                            n.handler && ((n = (r = n).handler), (o = r.selector)),
                                o && S.find.matchesSelector(re, o),
                                n.guid || (n.guid = S.guid++),
                                (l = y.events) || (l = y.events = Object.create(null)),
                                (s = y.handle) ||
                                    (s = y.handle = function (t) {
                                        return void 0 !== S && S.event.triggered !== t.type ? S.event.dispatch.apply(e, arguments) : void 0;
                                    }),
                                c = (t = (t || "").match(N) || [""]).length;
                            c--;

                        )
                            (f = v = (a = Se.exec(t[c]) || [])[1]),
                                (h = (a[2] || "").split(".").sort()),
                                f &&
                                    ((u = S.event.special[f] || {}),
                                    (f = (o ? u.delegateType : u.bindType) || f),
                                    (u = S.event.special[f] || {}),
                                    (d = S.extend({ type: f, origType: v, data: i, handler: n, guid: n.guid, selector: o, needsContext: o && S.expr.match.needsContext.test(o), namespace: h.join(".") }, r)),
                                    (p = l[f]) || (((p = l[f] = []).delegateCount = 0), (u.setup && !1 !== u.setup.call(e, i, h, s)) || (e.addEventListener && e.addEventListener(f, s))),
                                    u.add && (u.add.call(e, d), d.handler.guid || (d.handler.guid = n.guid)),
                                    o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                                    (S.event.global[f] = !0));
                },
                remove: function (e, t, n, i, o) {
                    var r,
                        s,
                        a,
                        l,
                        c,
                        d,
                        u,
                        p,
                        f,
                        h,
                        v,
                        y = Q.hasData(e) && Q.get(e);
                    if (y && (l = y.events)) {
                        for (c = (t = (t || "").match(N) || [""]).length; c--; )
                            if (((f = v = (a = Se.exec(t[c]) || [])[1]), (h = (a[2] || "").split(".").sort()), f)) {
                                for (u = S.event.special[f] || {}, p = l[(f = (i ? u.delegateType : u.bindType) || f)] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--; )
                                    (d = p[r]),
                                        (!o && v !== d.origType) ||
                                            (n && n.guid !== d.guid) ||
                                            (a && !a.test(d.namespace)) ||
                                            (i && i !== d.selector && ("**" !== i || !d.selector)) ||
                                            (p.splice(r, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                                s && !p.length && ((u.teardown && !1 !== u.teardown.call(e, h, y.handle)) || S.removeEvent(e, f, y.handle), delete l[f]);
                            } else for (f in l) S.event.remove(e, f + t[c], n, i, !0);
                        S.isEmptyObject(l) && Q.remove(e, "handle events");
                    }
                },
                dispatch: function (e) {
                    var t,
                        n,
                        i,
                        o,
                        r,
                        s,
                        a = new Array(arguments.length),
                        l = S.event.fix(e),
                        c = (Q.get(this, "events") || Object.create(null))[l.type] || [],
                        d = S.event.special[l.type] || {};
                    for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
                    if (((l.delegateTarget = this), !d.preDispatch || !1 !== d.preDispatch.call(this, l))) {
                        for (s = S.event.handlers.call(this, l, c), t = 0; (o = s[t++]) && !l.isPropagationStopped(); )
                            for (l.currentTarget = o.elem, n = 0; (r = o.handlers[n++]) && !l.isImmediatePropagationStopped(); )
                                (l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace)) ||
                                    ((l.handleObj = r), (l.data = r.data), void 0 !== (i = ((S.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a)) && !1 === (l.result = i) && (l.preventDefault(), l.stopPropagation()));
                        return d.postDispatch && d.postDispatch.call(this, l), l.result;
                    }
                },
                handlers: function (e, t) {
                    var n,
                        i,
                        o,
                        r,
                        s,
                        a = [],
                        l = t.delegateCount,
                        c = e.target;
                    if (l && c.nodeType && !("click" === e.type && e.button >= 1))
                        for (; c !== this; c = c.parentNode || this)
                            if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                                for (r = [], s = {}, n = 0; n < l; n++) void 0 === s[(o = (i = t[n]).selector + " ")] && (s[o] = i.needsContext ? S(o, this).index(c) > -1 : S.find(o, this, null, [c]).length), s[o] && r.push(i);
                                r.length && a.push({ elem: c, handlers: r });
                            }
                    return (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a;
                },
                addProp: function (e, t) {
                    Object.defineProperty(S.Event.prototype, e, {
                        enumerable: !0,
                        configurable: !0,
                        get: g(t)
                            ? function () {
                                  if (this.originalEvent) return t(this.originalEvent);
                              }
                            : function () {
                                  if (this.originalEvent) return this.originalEvent[e];
                              },
                        set: function (t) {
                            Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                        },
                    });
                },
                fix: function (e) {
                    return e[S.expando] ? e : new S.Event(e);
                },
                special: {
                    load: { noBubble: !0 },
                    click: {
                        setup: function (e) {
                            var t = this || e;
                            return ve.test(t.type) && t.click && E(t, "input") && $e(t, "click", ke), !1;
                        },
                        trigger: function (e) {
                            var t = this || e;
                            return ve.test(t.type) && t.click && E(t, "input") && $e(t, "click"), !0;
                        },
                        _default: function (e) {
                            var t = e.target;
                            return (ve.test(t.type) && t.click && E(t, "input") && Q.get(t, "click")) || E(t, "a");
                        },
                    },
                    beforeunload: {
                        postDispatch: function (e) {
                            void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                        },
                    },
                },
            }),
                (S.removeEvent = function (e, t, n) {
                    e.removeEventListener && e.removeEventListener(t, n);
                }),
                (S.Event = function (e, t) {
                    if (!(this instanceof S.Event)) return new S.Event(e, t);
                    e && e.type
                        ? ((this.originalEvent = e),
                          (this.type = e.type),
                          (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? ke : Ce),
                          (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                          (this.currentTarget = e.currentTarget),
                          (this.relatedTarget = e.relatedTarget))
                        : (this.type = e),
                        t && S.extend(this, t),
                        (this.timeStamp = (e && e.timeStamp) || Date.now()),
                        (this[S.expando] = !0);
                }),
                (S.Event.prototype = {
                    constructor: S.Event,
                    isDefaultPrevented: Ce,
                    isPropagationStopped: Ce,
                    isImmediatePropagationStopped: Ce,
                    isSimulated: !1,
                    preventDefault: function () {
                        var e = this.originalEvent;
                        (this.isDefaultPrevented = ke), e && !this.isSimulated && e.preventDefault();
                    },
                    stopPropagation: function () {
                        var e = this.originalEvent;
                        (this.isPropagationStopped = ke), e && !this.isSimulated && e.stopPropagation();
                    },
                    stopImmediatePropagation: function () {
                        var e = this.originalEvent;
                        (this.isImmediatePropagationStopped = ke), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
                    },
                }),
                S.each(
                    {
                        altKey: !0,
                        bubbles: !0,
                        cancelable: !0,
                        changedTouches: !0,
                        ctrlKey: !0,
                        detail: !0,
                        eventPhase: !0,
                        metaKey: !0,
                        pageX: !0,
                        pageY: !0,
                        shiftKey: !0,
                        view: !0,
                        char: !0,
                        code: !0,
                        charCode: !0,
                        key: !0,
                        keyCode: !0,
                        button: !0,
                        buttons: !0,
                        clientX: !0,
                        clientY: !0,
                        offsetX: !0,
                        offsetY: !0,
                        pointerId: !0,
                        pointerType: !0,
                        screenX: !0,
                        screenY: !0,
                        targetTouches: !0,
                        toElement: !0,
                        touches: !0,
                        which: !0,
                    },
                    S.event.addProp
                ),
                S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                    S.event.special[e] = {
                        setup: function () {
                            return $e(this, e, Ae), !1;
                        },
                        trigger: function () {
                            return $e(this, e), !0;
                        },
                        _default: function () {
                            return !0;
                        },
                        delegateType: t,
                    };
                }),
                S.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
                    S.event.special[e] = {
                        delegateType: t,
                        bindType: t,
                        handle: function (e) {
                            var n,
                                i = this,
                                o = e.relatedTarget,
                                r = e.handleObj;
                            return (o && (o === i || S.contains(i, o))) || ((e.type = r.origType), (n = r.handler.apply(this, arguments)), (e.type = t)), n;
                        },
                    };
                }),
                S.fn.extend({
                    on: function (e, t, n, i) {
                        return je(this, e, t, n, i);
                    },
                    one: function (e, t, n, i) {
                        return je(this, e, t, n, i, 1);
                    },
                    off: function (e, t, n) {
                        var i, o;
                        if (e && e.preventDefault && e.handleObj) return (i = e.handleObj), S(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                        if ("object" == typeof e) {
                            for (o in e) this.off(o, t, e[o]);
                            return this;
                        }
                        return (
                            (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                            !1 === n && (n = Ce),
                            this.each(function () {
                                S.event.remove(this, e, n, t);
                            })
                        );
                    },
                });
            var Ee = /<script|<style|<link/i,
                Le = /checked\s*(?:[^=]|=\s*.checked.)/i,
                De = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
            function Oe(e, t) {
                return (E(e, "table") && E(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0]) || e;
            }
            function Me(e) {
                return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
            }
            function He(e) {
                return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
            }
            function qe(e, t) {
                var n, i, o, r, s, a;
                if (1 === t.nodeType) {
                    if (Q.hasData(e) && (a = Q.get(e).events)) for (o in (Q.remove(t, "handle events"), a)) for (n = 0, i = a[o].length; n < i; n++) S.event.add(t, o, a[o][n]);
                    K.hasData(e) && ((r = K.access(e)), (s = S.extend({}, r)), K.set(t, s));
                }
            }
            function Pe(e, t) {
                var n = t.nodeName.toLowerCase();
                "input" === n && ve.test(e.type) ? (t.checked = e.checked) : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue);
            }
            function Ne(e, t, n, i) {
                t = l(t);
                var o,
                    r,
                    s,
                    a,
                    c,
                    d,
                    u = 0,
                    p = e.length,
                    f = p - 1,
                    h = t[0],
                    v = g(h);
                if (v || (p > 1 && "string" == typeof h && !y.checkClone && Le.test(h)))
                    return e.each(function (o) {
                        var r = e.eq(o);
                        v && (t[0] = h.call(this, o, r.html())), Ne(r, t, n, i);
                    });
                if (p && ((r = (o = Te(t, e[0].ownerDocument, !1, e, i)).firstChild), 1 === o.childNodes.length && (o = r), r || i)) {
                    for (a = (s = S.map(be(o, "script"), Me)).length; u < p; u++) (c = o), u !== f && ((c = S.clone(c, !0, !0)), a && S.merge(s, be(c, "script"))), n.call(e[u], c, u);
                    if (a)
                        for (d = s[s.length - 1].ownerDocument, S.map(s, He), u = 0; u < a; u++)
                            (c = s[u]),
                                ge.test(c.type || "") &&
                                    !Q.access(c, "globalEval") &&
                                    S.contains(d, c) &&
                                    (c.src && "module" !== (c.type || "").toLowerCase() ? S._evalUrl && !c.noModule && S._evalUrl(c.src, { nonce: c.nonce || c.getAttribute("nonce") }, d) : x(c.textContent.replace(De, ""), c, d));
                }
                return e;
            }
            function Ie(e, t, n) {
                for (var i, o = t ? S.filter(t, e) : e, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || S.cleanData(be(i)), i.parentNode && (n && se(i) && we(be(i, "script")), i.parentNode.removeChild(i));
                return e;
            }
            S.extend({
                htmlPrefilter: function (e) {
                    return e;
                },
                clone: function (e, t, n) {
                    var i,
                        o,
                        r,
                        s,
                        a = e.cloneNode(!0),
                        l = se(e);
                    if (!(y.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || S.isXMLDoc(e))) for (s = be(a), i = 0, o = (r = be(e)).length; i < o; i++) Pe(r[i], s[i]);
                    if (t)
                        if (n) for (r = r || be(e), s = s || be(a), i = 0, o = r.length; i < o; i++) qe(r[i], s[i]);
                        else qe(e, a);
                    return (s = be(a, "script")).length > 0 && we(s, !l && be(e, "script")), a;
                },
                cleanData: function (e) {
                    for (var t, n, i, o = S.event.special, r = 0; void 0 !== (n = e[r]); r++)
                        if (J(n)) {
                            if ((t = n[Q.expando])) {
                                if (t.events) for (i in t.events) o[i] ? S.event.remove(n, i) : S.removeEvent(n, i, t.handle);
                                n[Q.expando] = void 0;
                            }
                            n[K.expando] && (n[K.expando] = void 0);
                        }
                },
            }),
                S.fn.extend({
                    detach: function (e) {
                        return Ie(this, e, !0);
                    },
                    remove: function (e) {
                        return Ie(this, e);
                    },
                    text: function (e) {
                        return B(
                            this,
                            function (e) {
                                return void 0 === e
                                    ? S.text(this)
                                    : this.empty().each(function () {
                                          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                                      });
                            },
                            null,
                            e,
                            arguments.length
                        );
                    },
                    append: function () {
                        return Ne(this, arguments, function (e) {
                            (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Oe(this, e).appendChild(e);
                        });
                    },
                    prepend: function () {
                        return Ne(this, arguments, function (e) {
                            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                var t = Oe(this, e);
                                t.insertBefore(e, t.firstChild);
                            }
                        });
                    },
                    before: function () {
                        return Ne(this, arguments, function (e) {
                            this.parentNode && this.parentNode.insertBefore(e, this);
                        });
                    },
                    after: function () {
                        return Ne(this, arguments, function (e) {
                            this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                        });
                    },
                    empty: function () {
                        for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (S.cleanData(be(e, !1)), (e.textContent = ""));
                        return this;
                    },
                    clone: function (e, t) {
                        return (
                            (e = null != e && e),
                            (t = null == t ? e : t),
                            this.map(function () {
                                return S.clone(this, e, t);
                            })
                        );
                    },
                    html: function (e) {
                        return B(
                            this,
                            function (e) {
                                var t = this[0] || {},
                                    n = 0,
                                    i = this.length;
                                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                                if ("string" == typeof e && !Ee.test(e) && !me[(ye.exec(e) || ["", ""])[1].toLowerCase()]) {
                                    e = S.htmlPrefilter(e);
                                    try {
                                        for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (S.cleanData(be(t, !1)), (t.innerHTML = e));
                                        t = 0;
                                    } catch (e) {}
                                }
                                t && this.empty().append(e);
                            },
                            null,
                            e,
                            arguments.length
                        );
                    },
                    replaceWith: function () {
                        var e = [];
                        return Ne(
                            this,
                            arguments,
                            function (t) {
                                var n = this.parentNode;
                                S.inArray(this, e) < 0 && (S.cleanData(be(this)), n && n.replaceChild(t, this));
                            },
                            e
                        );
                    },
                }),
                S.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
                    S.fn[e] = function (e) {
                        for (var n, i = [], o = S(e), r = o.length - 1, s = 0; s <= r; s++) (n = s === r ? this : this.clone(!0)), S(o[s])[t](n), c.apply(i, n.get());
                        return this.pushStack(i);
                    };
                });
            var _e = new RegExp("^(" + ne + ")(?!px)[a-z%]+$", "i"),
                ze = function (e) {
                    var t = e.ownerDocument.defaultView;
                    return (t && t.opener) || (t = n), t.getComputedStyle(e);
                },
                Re = function (e, t, n) {
                    var i,
                        o,
                        r = {};
                    for (o in t) (r[o] = e.style[o]), (e.style[o] = t[o]);
                    for (o in ((i = n.call(e)), t)) e.style[o] = r[o];
                    return i;
                },
                We = new RegExp(oe.join("|"), "i");
            function Fe(e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a = e.style;
                return (
                    (n = n || ze(e)) &&
                        ("" !== (s = n.getPropertyValue(t) || n[t]) || se(e) || (s = S.style(e, t)),
                        !y.pixelBoxStyles() && _e.test(s) && We.test(t) && ((i = a.width), (o = a.minWidth), (r = a.maxWidth), (a.minWidth = a.maxWidth = a.width = s), (s = n.width), (a.width = i), (a.minWidth = o), (a.maxWidth = r))),
                    void 0 !== s ? s + "" : s
                );
            }
            function Be(e, t) {
                return {
                    get: function () {
                        if (!e()) return (this.get = t).apply(this, arguments);
                        delete this.get;
                    },
                };
            }
            !(function () {
                function e() {
                    if (d) {
                        (c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                            (d.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                            re.appendChild(c).appendChild(d);
                        var e = n.getComputedStyle(d);
                        (i = "1%" !== e.top),
                            (l = 12 === t(e.marginLeft)),
                            (d.style.right = "60%"),
                            (s = 36 === t(e.right)),
                            (o = 36 === t(e.width)),
                            (d.style.position = "absolute"),
                            (r = 12 === t(d.offsetWidth / 3)),
                            re.removeChild(c),
                            (d = null);
                    }
                }
                function t(e) {
                    return Math.round(parseFloat(e));
                }
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c = b.createElement("div"),
                    d = b.createElement("div");
                d.style &&
                    ((d.style.backgroundClip = "content-box"),
                    (d.cloneNode(!0).style.backgroundClip = ""),
                    (y.clearCloneStyle = "content-box" === d.style.backgroundClip),
                    S.extend(y, {
                        boxSizingReliable: function () {
                            return e(), o;
                        },
                        pixelBoxStyles: function () {
                            return e(), s;
                        },
                        pixelPosition: function () {
                            return e(), i;
                        },
                        reliableMarginLeft: function () {
                            return e(), l;
                        },
                        scrollboxSize: function () {
                            return e(), r;
                        },
                        reliableTrDimensions: function () {
                            var e, t, i, o;
                            return (
                                null == a &&
                                    ((e = b.createElement("table")),
                                    (t = b.createElement("tr")),
                                    (i = b.createElement("div")),
                                    (e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate"),
                                    (t.style.cssText = "border:1px solid"),
                                    (t.style.height = "1px"),
                                    (i.style.height = "9px"),
                                    (i.style.display = "block"),
                                    re.appendChild(e).appendChild(t).appendChild(i),
                                    (o = n.getComputedStyle(t)),
                                    (a = parseInt(o.height, 10) + parseInt(o.borderTopWidth, 10) + parseInt(o.borderBottomWidth, 10) === t.offsetHeight),
                                    re.removeChild(e)),
                                a
                            );
                        },
                    }));
            })();
            var Ue = ["Webkit", "Moz", "ms"],
                Xe = b.createElement("div").style,
                Ye = {};
            function Ve(e) {
                var t = S.cssProps[e] || Ye[e];
                return (
                    t ||
                    (e in Xe
                        ? e
                        : (Ye[e] =
                              (function (e) {
                                  for (var t = e[0].toUpperCase() + e.slice(1), n = Ue.length; n--; ) if ((e = Ue[n] + t) in Xe) return e;
                              })(e) || e))
                );
            }
            var Je = /^(none|table(?!-c[ea]).+)/,
                Ge = /^--/,
                Qe = { position: "absolute", visibility: "hidden", display: "block" },
                Ke = { letterSpacing: "0", fontWeight: "400" };
            function Ze(e, t, n) {
                var i = ie.exec(t);
                return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
            }
            function et(e, t, n, i, o, r) {
                var s = "width" === t ? 1 : 0,
                    a = 0,
                    l = 0;
                if (n === (i ? "border" : "content")) return 0;
                for (; s < 4; s += 2)
                    "margin" === n && (l += S.css(e, n + oe[s], !0, o)),
                        i
                            ? ("content" === n && (l -= S.css(e, "padding" + oe[s], !0, o)), "margin" !== n && (l -= S.css(e, "border" + oe[s] + "Width", !0, o)))
                            : ((l += S.css(e, "padding" + oe[s], !0, o)), "padding" !== n ? (l += S.css(e, "border" + oe[s] + "Width", !0, o)) : (a += S.css(e, "border" + oe[s] + "Width", !0, o)));
                return !i && r >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5)) || 0), l;
            }
            function tt(e, t, n) {
                var i = ze(e),
                    o = (!y.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, i),
                    r = o,
                    s = Fe(e, t, i),
                    a = "offset" + t[0].toUpperCase() + t.slice(1);
                if (_e.test(s)) {
                    if (!n) return s;
                    s = "auto";
                }
                return (
                    ((!y.boxSizingReliable() && o) || (!y.reliableTrDimensions() && E(e, "tr")) || "auto" === s || (!parseFloat(s) && "inline" === S.css(e, "display", !1, i))) &&
                        e.getClientRects().length &&
                        ((o = "border-box" === S.css(e, "boxSizing", !1, i)), (r = a in e) && (s = e[a])),
                    (s = parseFloat(s) || 0) + et(e, t, n || (o ? "border" : "content"), r, i, s) + "px"
                );
            }
            function nt(e, t, n, i, o) {
                return new nt.prototype.init(e, t, n, i, o);
            }
            S.extend({
                cssHooks: {
                    opacity: {
                        get: function (e, t) {
                            if (t) {
                                var n = Fe(e, "opacity");
                                return "" === n ? "1" : n;
                            }
                        },
                    },
                },
                cssNumber: {
                    animationIterationCount: !0,
                    columnCount: !0,
                    fillOpacity: !0,
                    flexGrow: !0,
                    flexShrink: !0,
                    fontWeight: !0,
                    gridArea: !0,
                    gridColumn: !0,
                    gridColumnEnd: !0,
                    gridColumnStart: !0,
                    gridRow: !0,
                    gridRowEnd: !0,
                    gridRowStart: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0,
                },
                cssProps: {},
                style: function (e, t, n, i) {
                    if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                        var o,
                            r,
                            s,
                            a = V(t),
                            l = Ge.test(t),
                            c = e.style;
                        if ((l || (t = Ve(a)), (s = S.cssHooks[t] || S.cssHooks[a]), void 0 === n)) return s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : c[t];
                        "string" === (r = typeof n) && (o = ie.exec(n)) && o[1] && ((n = ce(e, t, o)), (r = "number")),
                            null != n &&
                                n == n &&
                                ("number" !== r || l || (n += (o && o[3]) || (S.cssNumber[a] ? "" : "px")),
                                y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                                (s && "set" in s && void 0 === (n = s.set(e, n, i))) || (l ? c.setProperty(t, n) : (c[t] = n)));
                    }
                },
                css: function (e, t, n, i) {
                    var o,
                        r,
                        s,
                        a = V(t);
                    return (
                        Ge.test(t) || (t = Ve(a)),
                        (s = S.cssHooks[t] || S.cssHooks[a]) && "get" in s && (o = s.get(e, !0, n)),
                        void 0 === o && (o = Fe(e, t, i)),
                        "normal" === o && t in Ke && (o = Ke[t]),
                        "" === n || n ? ((r = parseFloat(o)), !0 === n || isFinite(r) ? r || 0 : o) : o
                    );
                },
            }),
                S.each(["height", "width"], function (e, t) {
                    S.cssHooks[t] = {
                        get: function (e, n, i) {
                            if (n)
                                return !Je.test(S.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                                    ? tt(e, t, i)
                                    : Re(e, Qe, function () {
                                          return tt(e, t, i);
                                      });
                        },
                        set: function (e, n, i) {
                            var o,
                                r = ze(e),
                                s = !y.scrollboxSize() && "absolute" === r.position,
                                a = (s || i) && "border-box" === S.css(e, "boxSizing", !1, r),
                                l = i ? et(e, t, i, a, r) : 0;
                            return (
                                a && s && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(r[t]) - et(e, t, "border", !1, r) - 0.5)),
                                l && (o = ie.exec(n)) && "px" !== (o[3] || "px") && ((e.style[t] = n), (n = S.css(e, t))),
                                Ze(0, n, l)
                            );
                        },
                    };
                }),
                (S.cssHooks.marginLeft = Be(y.reliableMarginLeft, function (e, t) {
                    if (t)
                        return (
                            (parseFloat(Fe(e, "marginLeft")) ||
                                e.getBoundingClientRect().left -
                                    Re(e, { marginLeft: 0 }, function () {
                                        return e.getBoundingClientRect().left;
                                    })) + "px"
                        );
                })),
                S.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                    (S.cssHooks[e + t] = {
                        expand: function (n) {
                            for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) o[e + oe[i] + t] = r[i] || r[i - 2] || r[0];
                            return o;
                        },
                    }),
                        "margin" !== e && (S.cssHooks[e + t].set = Ze);
                }),
                S.fn.extend({
                    css: function (e, t) {
                        return B(
                            this,
                            function (e, t, n) {
                                var i,
                                    o,
                                    r = {},
                                    s = 0;
                                if (Array.isArray(t)) {
                                    for (i = ze(e), o = t.length; s < o; s++) r[t[s]] = S.css(e, t[s], !1, i);
                                    return r;
                                }
                                return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
                            },
                            e,
                            t,
                            arguments.length > 1
                        );
                    },
                }),
                (S.Tween = nt),
                (nt.prototype = {
                    constructor: nt,
                    init: function (e, t, n, i, o, r) {
                        (this.elem = e), (this.prop = n), (this.easing = o || S.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = i), (this.unit = r || (S.cssNumber[n] ? "" : "px"));
                    },
                    cur: function () {
                        var e = nt.propHooks[this.prop];
                        return e && e.get ? e.get(this) : nt.propHooks._default.get(this);
                    },
                    run: function (e) {
                        var t,
                            n = nt.propHooks[this.prop];
                        return (
                            this.options.duration ? (this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                            (this.now = (this.end - this.start) * t + this.start),
                            this.options.step && this.options.step.call(this.elem, this.now, this),
                            n && n.set ? n.set(this) : nt.propHooks._default.set(this),
                            this
                        );
                    },
                }),
                (nt.prototype.init.prototype = nt.prototype),
                (nt.propHooks = {
                    _default: {
                        get: function (e) {
                            var t;
                            return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = S.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                        },
                        set: function (e) {
                            S.fx.step[e.prop] ? S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (!S.cssHooks[e.prop] && null == e.elem.style[Ve(e.prop)]) ? (e.elem[e.prop] = e.now) : S.style(e.elem, e.prop, e.now + e.unit);
                        },
                    },
                }),
                (nt.propHooks.scrollTop = nt.propHooks.scrollLeft = {
                    set: function (e) {
                        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                    },
                }),
                (S.easing = {
                    linear: function (e) {
                        return e;
                    },
                    swing: function (e) {
                        return 0.5 - Math.cos(e * Math.PI) / 2;
                    },
                    _default: "swing",
                }),
                (S.fx = nt.prototype.init),
                (S.fx.step = {});
            var it,
                ot,
                rt = /^(?:toggle|show|hide)$/,
                st = /queueHooks$/;
            function at() {
                ot && (!1 === b.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(at) : n.setTimeout(at, S.fx.interval), S.fx.tick());
            }
            function lt() {
                return (
                    n.setTimeout(function () {
                        it = void 0;
                    }),
                    (it = Date.now())
                );
            }
            function ct(e, t) {
                var n,
                    i = 0,
                    o = { height: e };
                for (t = t ? 1 : 0; i < 4; i += 2 - t) o["margin" + (n = oe[i])] = o["padding" + n] = e;
                return t && (o.opacity = o.width = e), o;
            }
            function dt(e, t, n) {
                for (var i, o = (ut.tweeners[t] || []).concat(ut.tweeners["*"]), r = 0, s = o.length; r < s; r++) if ((i = o[r].call(n, t, e))) return i;
            }
            function ut(e, t, n) {
                var i,
                    o,
                    r = 0,
                    s = ut.prefilters.length,
                    a = S.Deferred().always(function () {
                        delete l.elem;
                    }),
                    l = function () {
                        if (o) return !1;
                        for (var t = it || lt(), n = Math.max(0, c.startTime + c.duration - t), i = 1 - (n / c.duration || 0), r = 0, s = c.tweens.length; r < s; r++) c.tweens[r].run(i);
                        return a.notifyWith(e, [c, i, n]), i < 1 && s ? n : (s || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1);
                    },
                    c = a.promise({
                        elem: e,
                        props: S.extend({}, t),
                        opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, n),
                        originalProperties: t,
                        originalOptions: n,
                        startTime: it || lt(),
                        duration: n.duration,
                        tweens: [],
                        createTween: function (t, n) {
                            var i = S.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                            return c.tweens.push(i), i;
                        },
                        stop: function (t) {
                            var n = 0,
                                i = t ? c.tweens.length : 0;
                            if (o) return this;
                            for (o = !0; n < i; n++) c.tweens[n].run(1);
                            return t ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]), this;
                        },
                    }),
                    d = c.props;
                for (
                    !(function (e, t) {
                        var n, i, o, r, s;
                        for (n in e)
                            if (((o = t[(i = V(n))]), (r = e[n]), Array.isArray(r) && ((o = r[1]), (r = e[n] = r[0])), n !== i && ((e[i] = r), delete e[n]), (s = S.cssHooks[i]) && ("expand" in s)))
                                for (n in ((r = s.expand(r)), delete e[i], r)) (n in e) || ((e[n] = r[n]), (t[n] = o));
                            else t[i] = o;
                    })(d, c.opts.specialEasing);
                    r < s;
                    r++
                )
                    if ((i = ut.prefilters[r].call(c, e, d, c.opts))) return g(i.stop) && (S._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
                return (
                    S.map(d, dt, c),
                    g(c.opts.start) && c.opts.start.call(e, c),
                    c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
                    S.fx.timer(S.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
                    c
                );
            }
            (S.Animation = S.extend(ut, {
                tweeners: {
                    "*": [
                        function (e, t) {
                            var n = this.createTween(e, t);
                            return ce(n.elem, e, ie.exec(t), n), n;
                        },
                    ],
                },
                tweener: function (e, t) {
                    g(e) ? ((t = e), (e = ["*"])) : (e = e.match(N));
                    for (var n, i = 0, o = e.length; i < o; i++) (n = e[i]), (ut.tweeners[n] = ut.tweeners[n] || []), ut.tweeners[n].unshift(t);
                },
                prefilters: [
                    function (e, t, n) {
                        var i,
                            o,
                            r,
                            s,
                            a,
                            l,
                            c,
                            d,
                            u = "width" in t || "height" in t,
                            p = this,
                            f = {},
                            h = e.style,
                            v = e.nodeType && le(e),
                            y = Q.get(e, "fxshow");
                        for (i in (n.queue ||
                            (null == (s = S._queueHooks(e, "fx")).unqueued &&
                                ((s.unqueued = 0),
                                (a = s.empty.fire),
                                (s.empty.fire = function () {
                                    s.unqueued || a();
                                })),
                            s.unqueued++,
                            p.always(function () {
                                p.always(function () {
                                    s.unqueued--, S.queue(e, "fx").length || s.empty.fire();
                                });
                            })),
                        t))
                            if (((o = t[i]), rt.test(o))) {
                                if ((delete t[i], (r = r || "toggle" === o), o === (v ? "hide" : "show"))) {
                                    if ("show" !== o || !y || void 0 === y[i]) continue;
                                    v = !0;
                                }
                                f[i] = (y && y[i]) || S.style(e, i);
                            }
                        if ((l = !S.isEmptyObject(t)) || !S.isEmptyObject(f))
                            for (i in (u &&
                                1 === e.nodeType &&
                                ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                                null == (c = y && y.display) && (c = Q.get(e, "display")),
                                "none" === (d = S.css(e, "display")) && (c ? (d = c) : (pe([e], !0), (c = e.style.display || c), (d = S.css(e, "display")), pe([e]))),
                                ("inline" === d || ("inline-block" === d && null != c)) &&
                                    "none" === S.css(e, "float") &&
                                    (l ||
                                        (p.done(function () {
                                            h.display = c;
                                        }),
                                        null == c && ((d = h.display), (c = "none" === d ? "" : d))),
                                    (h.display = "inline-block"))),
                            n.overflow &&
                                ((h.overflow = "hidden"),
                                p.always(function () {
                                    (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                                })),
                            (l = !1),
                            f))
                                l ||
                                    (y ? "hidden" in y && (v = y.hidden) : (y = Q.access(e, "fxshow", { display: c })),
                                    r && (y.hidden = !v),
                                    v && pe([e], !0),
                                    p.done(function () {
                                        for (i in (v || pe([e]), Q.remove(e, "fxshow"), f)) S.style(e, i, f[i]);
                                    })),
                                    (l = dt(v ? y[i] : 0, i, p)),
                                    i in y || ((y[i] = l.start), v && ((l.end = l.start), (l.start = 0)));
                    },
                ],
                prefilter: function (e, t) {
                    t ? ut.prefilters.unshift(e) : ut.prefilters.push(e);
                },
            })),
                (S.speed = function (e, t, n) {
                    var i = e && "object" == typeof e ? S.extend({}, e) : { complete: n || (!n && t) || (g(e) && e), duration: e, easing: (n && t) || (t && !g(t) && t) };
                    return (
                        S.fx.off ? (i.duration = 0) : "number" != typeof i.duration && (i.duration in S.fx.speeds ? (i.duration = S.fx.speeds[i.duration]) : (i.duration = S.fx.speeds._default)),
                        (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                        (i.old = i.complete),
                        (i.complete = function () {
                            g(i.old) && i.old.call(this), i.queue && S.dequeue(this, i.queue);
                        }),
                        i
                    );
                }),
                S.fn.extend({
                    fadeTo: function (e, t, n, i) {
                        return this.filter(le).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
                    },
                    animate: function (e, t, n, i) {
                        var o = S.isEmptyObject(e),
                            r = S.speed(t, n, i),
                            s = function () {
                                var t = ut(this, S.extend({}, e), r);
                                (o || Q.get(this, "finish")) && t.stop(!0);
                            };
                        return (s.finish = s), o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s);
                    },
                    stop: function (e, t, n) {
                        var i = function (e) {
                            var t = e.stop;
                            delete e.stop, t(n);
                        };
                        return (
                            "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                            t && this.queue(e || "fx", []),
                            this.each(function () {
                                var t = !0,
                                    o = null != e && e + "queueHooks",
                                    r = S.timers,
                                    s = Q.get(this);
                                if (o) s[o] && s[o].stop && i(s[o]);
                                else for (o in s) s[o] && s[o].stop && st.test(o) && i(s[o]);
                                for (o = r.length; o--; ) r[o].elem !== this || (null != e && r[o].queue !== e) || (r[o].anim.stop(n), (t = !1), r.splice(o, 1));
                                (!t && n) || S.dequeue(this, e);
                            })
                        );
                    },
                    finish: function (e) {
                        return (
                            !1 !== e && (e = e || "fx"),
                            this.each(function () {
                                var t,
                                    n = Q.get(this),
                                    i = n[e + "queue"],
                                    o = n[e + "queueHooks"],
                                    r = S.timers,
                                    s = i ? i.length : 0;
                                for (n.finish = !0, S.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--; ) r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
                                for (t = 0; t < s; t++) i[t] && i[t].finish && i[t].finish.call(this);
                                delete n.finish;
                            })
                        );
                    },
                }),
                S.each(["toggle", "show", "hide"], function (e, t) {
                    var n = S.fn[t];
                    S.fn[t] = function (e, i, o) {
                        return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ct(t, !0), e, i, o);
                    };
                }),
                S.each({ slideDown: ct("show"), slideUp: ct("hide"), slideToggle: ct("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
                    S.fn[e] = function (e, n, i) {
                        return this.animate(t, e, n, i);
                    };
                }),
                (S.timers = []),
                (S.fx.tick = function () {
                    var e,
                        t = 0,
                        n = S.timers;
                    for (it = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
                    n.length || S.fx.stop(), (it = void 0);
                }),
                (S.fx.timer = function (e) {
                    S.timers.push(e), S.fx.start();
                }),
                (S.fx.interval = 13),
                (S.fx.start = function () {
                    ot || ((ot = !0), at());
                }),
                (S.fx.stop = function () {
                    ot = null;
                }),
                (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
                (S.fn.delay = function (e, t) {
                    return (
                        (e = (S.fx && S.fx.speeds[e]) || e),
                        (t = t || "fx"),
                        this.queue(t, function (t, i) {
                            var o = n.setTimeout(t, e);
                            i.stop = function () {
                                n.clearTimeout(o);
                            };
                        })
                    );
                }),
                (function () {
                    var e = b.createElement("input"),
                        t = b.createElement("select").appendChild(b.createElement("option"));
                    (e.type = "checkbox"), (y.checkOn = "" !== e.value), (y.optSelected = t.selected), ((e = b.createElement("input")).value = "t"), (e.type = "radio"), (y.radioValue = "t" === e.value);
                })();
            var pt,
                ft = S.expr.attrHandle;
            S.fn.extend({
                attr: function (e, t) {
                    return B(this, S.attr, e, t, arguments.length > 1);
                },
                removeAttr: function (e) {
                    return this.each(function () {
                        S.removeAttr(this, e);
                    });
                },
            }),
                S.extend({
                    attr: function (e, t, n) {
                        var i,
                            o,
                            r = e.nodeType;
                        if (3 !== r && 8 !== r && 2 !== r)
                            return void 0 === e.getAttribute
                                ? S.prop(e, t, n)
                                : ((1 === r && S.isXMLDoc(e)) || (o = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? pt : void 0)),
                                  void 0 !== n
                                      ? null === n
                                          ? void S.removeAttr(e, t)
                                          : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                          ? i
                                          : (e.setAttribute(t, n + ""), n)
                                      : o && "get" in o && null !== (i = o.get(e, t))
                                      ? i
                                      : null == (i = S.find.attr(e, t))
                                      ? void 0
                                      : i);
                    },
                    attrHooks: {
                        type: {
                            set: function (e, t) {
                                if (!y.radioValue && "radio" === t && E(e, "input")) {
                                    var n = e.value;
                                    return e.setAttribute("type", t), n && (e.value = n), t;
                                }
                            },
                        },
                    },
                    removeAttr: function (e, t) {
                        var n,
                            i = 0,
                            o = t && t.match(N);
                        if (o && 1 === e.nodeType) for (; (n = o[i++]); ) e.removeAttribute(n);
                    },
                }),
                (pt = {
                    set: function (e, t, n) {
                        return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
                    },
                }),
                S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
                    var n = ft[t] || S.find.attr;
                    ft[t] = function (e, t, i) {
                        var o,
                            r,
                            s = t.toLowerCase();
                        return i || ((r = ft[s]), (ft[s] = o), (o = null != n(e, t, i) ? s : null), (ft[s] = r)), o;
                    };
                });
            var ht = /^(?:input|select|textarea|button)$/i,
                vt = /^(?:a|area)$/i;
            function yt(e) {
                return (e.match(N) || []).join(" ");
            }
            function gt(e) {
                return (e.getAttribute && e.getAttribute("class")) || "";
            }
            function mt(e) {
                return Array.isArray(e) ? e : ("string" == typeof e && e.match(N)) || [];
            }
            S.fn.extend({
                prop: function (e, t) {
                    return B(this, S.prop, e, t, arguments.length > 1);
                },
                removeProp: function (e) {
                    return this.each(function () {
                        delete this[S.propFix[e] || e];
                    });
                },
            }),
                S.extend({
                    prop: function (e, t, n) {
                        var i,
                            o,
                            r = e.nodeType;
                        if (3 !== r && 8 !== r && 2 !== r)
                            return (
                                (1 === r && S.isXMLDoc(e)) || ((t = S.propFix[t] || t), (o = S.propHooks[t])),
                                void 0 !== n ? (o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e[t] = n)) : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
                            );
                    },
                    propHooks: {
                        tabIndex: {
                            get: function (e) {
                                var t = S.find.attr(e, "tabindex");
                                return t ? parseInt(t, 10) : ht.test(e.nodeName) || (vt.test(e.nodeName) && e.href) ? 0 : -1;
                            },
                        },
                    },
                    propFix: { for: "htmlFor", class: "className" },
                }),
                y.optSelected ||
                    (S.propHooks.selected = {
                        get: function (e) {
                            var t = e.parentNode;
                            return t && t.parentNode && t.parentNode.selectedIndex, null;
                        },
                        set: function (e) {
                            var t = e.parentNode;
                            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                        },
                    }),
                S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                    S.propFix[this.toLowerCase()] = this;
                }),
                S.fn.extend({
                    addClass: function (e) {
                        var t,
                            n,
                            i,
                            o,
                            r,
                            s,
                            a,
                            l = 0;
                        if (g(e))
                            return this.each(function (t) {
                                S(this).addClass(e.call(this, t, gt(this)));
                            });
                        if ((t = mt(e)).length)
                            for (; (n = this[l++]); )
                                if (((o = gt(n)), (i = 1 === n.nodeType && " " + yt(o) + " "))) {
                                    for (s = 0; (r = t[s++]); ) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                                    o !== (a = yt(i)) && n.setAttribute("class", a);
                                }
                        return this;
                    },
                    removeClass: function (e) {
                        var t,
                            n,
                            i,
                            o,
                            r,
                            s,
                            a,
                            l = 0;
                        if (g(e))
                            return this.each(function (t) {
                                S(this).removeClass(e.call(this, t, gt(this)));
                            });
                        if (!arguments.length) return this.attr("class", "");
                        if ((t = mt(e)).length)
                            for (; (n = this[l++]); )
                                if (((o = gt(n)), (i = 1 === n.nodeType && " " + yt(o) + " "))) {
                                    for (s = 0; (r = t[s++]); ) for (; i.indexOf(" " + r + " ") > -1; ) i = i.replace(" " + r + " ", " ");
                                    o !== (a = yt(i)) && n.setAttribute("class", a);
                                }
                        return this;
                    },
                    toggleClass: function (e, t) {
                        var n = typeof e,
                            i = "string" === n || Array.isArray(e);
                        return "boolean" == typeof t && i
                            ? t
                                ? this.addClass(e)
                                : this.removeClass(e)
                            : g(e)
                            ? this.each(function (n) {
                                  S(this).toggleClass(e.call(this, n, gt(this), t), t);
                              })
                            : this.each(function () {
                                  var t, o, r, s;
                                  if (i) for (o = 0, r = S(this), s = mt(e); (t = s[o++]); ) r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
                                  else (void 0 !== e && "boolean" !== n) || ((t = gt(this)) && Q.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Q.get(this, "__className__") || ""));
                              });
                    },
                    hasClass: function (e) {
                        var t,
                            n,
                            i = 0;
                        for (t = " " + e + " "; (n = this[i++]); ) if (1 === n.nodeType && (" " + yt(gt(n)) + " ").indexOf(t) > -1) return !0;
                        return !1;
                    },
                });
            var bt = /\r/g;
            S.fn.extend({
                val: function (e) {
                    var t,
                        n,
                        i,
                        o = this[0];
                    return arguments.length
                        ? ((i = g(e)),
                          this.each(function (n) {
                              var o;
                              1 === this.nodeType &&
                                  (null == (o = i ? e.call(this, n, S(this).val()) : e)
                                      ? (o = "")
                                      : "number" == typeof o
                                      ? (o += "")
                                      : Array.isArray(o) &&
                                        (o = S.map(o, function (e) {
                                            return null == e ? "" : e + "";
                                        })),
                                  ((t = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value")) || (this.value = o));
                          }))
                        : o
                        ? (t = S.valHooks[o.type] || S.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value"))
                            ? n
                            : "string" == typeof (n = o.value)
                            ? n.replace(bt, "")
                            : null == n
                            ? ""
                            : n
                        : void 0;
                },
            }),
                S.extend({
                    valHooks: {
                        option: {
                            get: function (e) {
                                var t = S.find.attr(e, "value");
                                return null != t ? t : yt(S.text(e));
                            },
                        },
                        select: {
                            get: function (e) {
                                var t,
                                    n,
                                    i,
                                    o = e.options,
                                    r = e.selectedIndex,
                                    s = "select-one" === e.type,
                                    a = s ? null : [],
                                    l = s ? r + 1 : o.length;
                                for (i = r < 0 ? l : s ? r : 0; i < l; i++)
                                    if (((n = o[i]).selected || i === r) && !n.disabled && (!n.parentNode.disabled || !E(n.parentNode, "optgroup"))) {
                                        if (((t = S(n).val()), s)) return t;
                                        a.push(t);
                                    }
                                return a;
                            },
                            set: function (e, t) {
                                for (var n, i, o = e.options, r = S.makeArray(t), s = o.length; s--; ) ((i = o[s]).selected = S.inArray(S.valHooks.option.get(i), r) > -1) && (n = !0);
                                return n || (e.selectedIndex = -1), r;
                            },
                        },
                    },
                }),
                S.each(["radio", "checkbox"], function () {
                    (S.valHooks[this] = {
                        set: function (e, t) {
                            if (Array.isArray(t)) return (e.checked = S.inArray(S(e).val(), t) > -1);
                        },
                    }),
                        y.checkOn ||
                            (S.valHooks[this].get = function (e) {
                                return null === e.getAttribute("value") ? "on" : e.value;
                            });
                }),
                (y.focusin = "onfocusin" in n);
            var wt = /^(?:focusinfocus|focusoutblur)$/,
                xt = function (e) {
                    e.stopPropagation();
                };
            S.extend(S.event, {
                trigger: function (e, t, i, o) {
                    var r,
                        s,
                        a,
                        l,
                        c,
                        d,
                        u,
                        p,
                        h = [i || b],
                        v = f.call(e, "type") ? e.type : e,
                        y = f.call(e, "namespace") ? e.namespace.split(".") : [];
                    if (
                        ((s = p = a = i = i || b),
                        3 !== i.nodeType &&
                            8 !== i.nodeType &&
                            !wt.test(v + S.event.triggered) &&
                            (v.indexOf(".") > -1 && ((y = v.split(".")), (v = y.shift()), y.sort()),
                            (c = v.indexOf(":") < 0 && "on" + v),
                            ((e = e[S.expando] ? e : new S.Event(v, "object" == typeof e && e)).isTrigger = o ? 2 : 3),
                            (e.namespace = y.join(".")),
                            (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + y.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                            (e.result = void 0),
                            e.target || (e.target = i),
                            (t = null == t ? [e] : S.makeArray(t, [e])),
                            (u = S.event.special[v] || {}),
                            o || !u.trigger || !1 !== u.trigger.apply(i, t)))
                    ) {
                        if (!o && !u.noBubble && !m(i)) {
                            for (l = u.delegateType || v, wt.test(l + v) || (s = s.parentNode); s; s = s.parentNode) h.push(s), (a = s);
                            a === (i.ownerDocument || b) && h.push(a.defaultView || a.parentWindow || n);
                        }
                        for (r = 0; (s = h[r++]) && !e.isPropagationStopped(); )
                            (p = s),
                                (e.type = r > 1 ? l : u.bindType || v),
                                (d = (Q.get(s, "events") || Object.create(null))[e.type] && Q.get(s, "handle")) && d.apply(s, t),
                                (d = c && s[c]) && d.apply && J(s) && ((e.result = d.apply(s, t)), !1 === e.result && e.preventDefault());
                        return (
                            (e.type = v),
                            o ||
                                e.isDefaultPrevented() ||
                                (u._default && !1 !== u._default.apply(h.pop(), t)) ||
                                !J(i) ||
                                (c &&
                                    g(i[v]) &&
                                    !m(i) &&
                                    ((a = i[c]) && (i[c] = null),
                                    (S.event.triggered = v),
                                    e.isPropagationStopped() && p.addEventListener(v, xt),
                                    i[v](),
                                    e.isPropagationStopped() && p.removeEventListener(v, xt),
                                    (S.event.triggered = void 0),
                                    a && (i[c] = a))),
                            e.result
                        );
                    }
                },
                simulate: function (e, t, n) {
                    var i = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
                    S.event.trigger(i, null, t);
                },
            }),
                S.fn.extend({
                    trigger: function (e, t) {
                        return this.each(function () {
                            S.event.trigger(e, t, this);
                        });
                    },
                    triggerHandler: function (e, t) {
                        var n = this[0];
                        if (n) return S.event.trigger(e, t, n, !0);
                    },
                }),
                y.focusin ||
                    S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                        var n = function (e) {
                            S.event.simulate(t, e.target, S.event.fix(e));
                        };
                        S.event.special[t] = {
                            setup: function () {
                                var i = this.ownerDocument || this.document || this,
                                    o = Q.access(i, t);
                                o || i.addEventListener(e, n, !0), Q.access(i, t, (o || 0) + 1);
                            },
                            teardown: function () {
                                var i = this.ownerDocument || this.document || this,
                                    o = Q.access(i, t) - 1;
                                o ? Q.access(i, t, o) : (i.removeEventListener(e, n, !0), Q.remove(i, t));
                            },
                        };
                    });
            var Tt = n.location,
                St = { guid: Date.now() },
                kt = /\?/;
            S.parseXML = function (e) {
                var t, i;
                if (!e || "string" != typeof e) return null;
                try {
                    t = new n.DOMParser().parseFromString(e, "text/xml");
                } catch (e) {}
                return (
                    (i = t && t.getElementsByTagName("parsererror")[0]),
                    (t && !i) ||
                        S.error(
                            "Invalid XML: " +
                                (i
                                    ? S.map(i.childNodes, function (e) {
                                          return e.textContent;
                                      }).join("\n")
                                    : e)
                        ),
                    t
                );
            };
            var Ct = /\[\]$/,
                At = /\r?\n/g,
                jt = /^(?:submit|button|image|reset|file)$/i,
                $t = /^(?:input|select|textarea|keygen)/i;
            function Et(e, t, n, i) {
                var o;
                if (Array.isArray(t))
                    S.each(t, function (t, o) {
                        n || Ct.test(e) ? i(e, o) : Et(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, n, i);
                    });
                else if (n || "object" !== T(t)) i(e, t);
                else for (o in t) Et(e + "[" + o + "]", t[o], n, i);
            }
            (S.param = function (e, t) {
                var n,
                    i = [],
                    o = function (e, t) {
                        var n = g(t) ? t() : t;
                        i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
                    };
                if (null == e) return "";
                if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
                    S.each(e, function () {
                        o(this.name, this.value);
                    });
                else for (n in e) Et(n, e[n], t, o);
                return i.join("&");
            }),
                S.fn.extend({
                    serialize: function () {
                        return S.param(this.serializeArray());
                    },
                    serializeArray: function () {
                        return this.map(function () {
                            var e = S.prop(this, "elements");
                            return e ? S.makeArray(e) : this;
                        })
                            .filter(function () {
                                var e = this.type;
                                return this.name && !S(this).is(":disabled") && $t.test(this.nodeName) && !jt.test(e) && (this.checked || !ve.test(e));
                            })
                            .map(function (e, t) {
                                var n = S(this).val();
                                return null == n
                                    ? null
                                    : Array.isArray(n)
                                    ? S.map(n, function (e) {
                                          return { name: t.name, value: e.replace(At, "\r\n") };
                                      })
                                    : { name: t.name, value: n.replace(At, "\r\n") };
                            })
                            .get();
                    },
                });
            var Lt = /%20/g,
                Dt = /#.*$/,
                Ot = /([?&])_=[^&]*/,
                Mt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                Ht = /^(?:GET|HEAD)$/,
                qt = /^\/\//,
                Pt = {},
                Nt = {},
                It = "*/".concat("*"),
                _t = b.createElement("a");
            function zt(e) {
                return function (t, n) {
                    "string" != typeof t && ((n = t), (t = "*"));
                    var i,
                        o = 0,
                        r = t.toLowerCase().match(N) || [];
                    if (g(n)) for (; (i = r[o++]); ) "+" === i[0] ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
                };
            }
            function Rt(e, t, n, i) {
                var o = {},
                    r = e === Nt;
                function s(a) {
                    var l;
                    return (
                        (o[a] = !0),
                        S.each(e[a] || [], function (e, a) {
                            var c = a(t, n, i);
                            return "string" != typeof c || r || o[c] ? (r ? !(l = c) : void 0) : (t.dataTypes.unshift(c), s(c), !1);
                        }),
                        l
                    );
                }
                return s(t.dataTypes[0]) || (!o["*"] && s("*"));
            }
            function Wt(e, t) {
                var n,
                    i,
                    o = S.ajaxSettings.flatOptions || {};
                for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
                return i && S.extend(!0, e, i), e;
            }
            (_t.href = Tt.href),
                S.extend({
                    active: 0,
                    lastModified: {},
                    etag: {},
                    ajaxSettings: {
                        url: Tt.href,
                        type: "GET",
                        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
                        global: !0,
                        processData: !0,
                        async: !0,
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        accepts: { "*": It, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                        responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                        converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": S.parseXML },
                        flatOptions: { url: !0, context: !0 },
                    },
                    ajaxSetup: function (e, t) {
                        return t ? Wt(Wt(e, S.ajaxSettings), t) : Wt(S.ajaxSettings, e);
                    },
                    ajaxPrefilter: zt(Pt),
                    ajaxTransport: zt(Nt),
                    ajax: function (e, t) {
                        "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                        var i,
                            o,
                            r,
                            s,
                            a,
                            l,
                            c,
                            d,
                            u,
                            p,
                            f = S.ajaxSetup({}, t),
                            h = f.context || f,
                            v = f.context && (h.nodeType || h.jquery) ? S(h) : S.event,
                            y = S.Deferred(),
                            g = S.Callbacks("once memory"),
                            m = f.statusCode || {},
                            w = {},
                            x = {},
                            T = "canceled",
                            k = {
                                readyState: 0,
                                getResponseHeader: function (e) {
                                    var t;
                                    if (c) {
                                        if (!s) for (s = {}; (t = Mt.exec(r)); ) s[t[1].toLowerCase() + " "] = (s[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                        t = s[e.toLowerCase() + " "];
                                    }
                                    return null == t ? null : t.join(", ");
                                },
                                getAllResponseHeaders: function () {
                                    return c ? r : null;
                                },
                                setRequestHeader: function (e, t) {
                                    return null == c && ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e), (w[e] = t)), this;
                                },
                                overrideMimeType: function (e) {
                                    return null == c && (f.mimeType = e), this;
                                },
                                statusCode: function (e) {
                                    var t;
                                    if (e)
                                        if (c) k.always(e[k.status]);
                                        else for (t in e) m[t] = [m[t], e[t]];
                                    return this;
                                },
                                abort: function (e) {
                                    var t = e || T;
                                    return i && i.abort(t), C(0, t), this;
                                },
                            };
                        if (
                            (y.promise(k),
                            (f.url = ((e || f.url || Tt.href) + "").replace(qt, Tt.protocol + "//")),
                            (f.type = t.method || t.type || f.method || f.type),
                            (f.dataTypes = (f.dataType || "*").toLowerCase().match(N) || [""]),
                            null == f.crossDomain)
                        ) {
                            l = b.createElement("a");
                            try {
                                (l.href = f.url), (l.href = l.href), (f.crossDomain = _t.protocol + "//" + _t.host != l.protocol + "//" + l.host);
                            } catch (e) {
                                f.crossDomain = !0;
                            }
                        }
                        if ((f.data && f.processData && "string" != typeof f.data && (f.data = S.param(f.data, f.traditional)), Rt(Pt, f, t, k), c)) return k;
                        for (u in ((d = S.event && f.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
                        (f.type = f.type.toUpperCase()),
                        (f.hasContent = !Ht.test(f.type)),
                        (o = f.url.replace(Dt, "")),
                        f.hasContent
                            ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(Lt, "+"))
                            : ((p = f.url.slice(o.length)),
                              f.data && (f.processData || "string" == typeof f.data) && ((o += (kt.test(o) ? "&" : "?") + f.data), delete f.data),
                              !1 === f.cache && ((o = o.replace(Ot, "$1")), (p = (kt.test(o) ? "&" : "?") + "_=" + St.guid++ + p)),
                              (f.url = o + p)),
                        f.ifModified && (S.lastModified[o] && k.setRequestHeader("If-Modified-Since", S.lastModified[o]), S.etag[o] && k.setRequestHeader("If-None-Match", S.etag[o])),
                        ((f.data && f.hasContent && !1 !== f.contentType) || t.contentType) && k.setRequestHeader("Content-Type", f.contentType),
                        k.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + It + "; q=0.01" : "") : f.accepts["*"]),
                        f.headers))
                            k.setRequestHeader(u, f.headers[u]);
                        if (f.beforeSend && (!1 === f.beforeSend.call(h, k, f) || c)) return k.abort();
                        if (((T = "abort"), g.add(f.complete), k.done(f.success), k.fail(f.error), (i = Rt(Nt, f, t, k)))) {
                            if (((k.readyState = 1), d && v.trigger("ajaxSend", [k, f]), c)) return k;
                            f.async &&
                                f.timeout > 0 &&
                                (a = n.setTimeout(function () {
                                    k.abort("timeout");
                                }, f.timeout));
                            try {
                                (c = !1), i.send(w, C);
                            } catch (e) {
                                if (c) throw e;
                                C(-1, e);
                            }
                        } else C(-1, "No Transport");
                        function C(e, t, s, l) {
                            var u,
                                p,
                                b,
                                w,
                                x,
                                T = t;
                            c ||
                                ((c = !0),
                                a && n.clearTimeout(a),
                                (i = void 0),
                                (r = l || ""),
                                (k.readyState = e > 0 ? 4 : 0),
                                (u = (e >= 200 && e < 300) || 304 === e),
                                s &&
                                    (w = (function (e, t, n) {
                                        for (var i, o, r, s, a = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                                        if (i)
                                            for (o in a)
                                                if (a[o] && a[o].test(i)) {
                                                    l.unshift(o);
                                                    break;
                                                }
                                        if (l[0] in n) r = l[0];
                                        else {
                                            for (o in n) {
                                                if (!l[0] || e.converters[o + " " + l[0]]) {
                                                    r = o;
                                                    break;
                                                }
                                                s || (s = o);
                                            }
                                            r = r || s;
                                        }
                                        if (r) return r !== l[0] && l.unshift(r), n[r];
                                    })(f, k, s)),
                                !u && S.inArray("script", f.dataTypes) > -1 && S.inArray("json", f.dataTypes) < 0 && (f.converters["text script"] = function () {}),
                                (w = (function (e, t, n, i) {
                                    var o,
                                        r,
                                        s,
                                        a,
                                        l,
                                        c = {},
                                        d = e.dataTypes.slice();
                                    if (d[1]) for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
                                    for (r = d.shift(); r; )
                                        if ((e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = r), (r = d.shift())))
                                            if ("*" === r) r = l;
                                            else if ("*" !== l && l !== r) {
                                                if (!(s = c[l + " " + r] || c["* " + r]))
                                                    for (o in c)
                                                        if ((a = o.split(" "))[1] === r && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
                                                            !0 === s ? (s = c[o]) : !0 !== c[o] && ((r = a[0]), d.unshift(a[1]));
                                                            break;
                                                        }
                                                if (!0 !== s)
                                                    if (s && e.throws) t = s(t);
                                                    else
                                                        try {
                                                            t = s(t);
                                                        } catch (e) {
                                                            return { state: "parsererror", error: s ? e : "No conversion from " + l + " to " + r };
                                                        }
                                            }
                                    return { state: "success", data: t };
                                })(f, w, k, u)),
                                u
                                    ? (f.ifModified && ((x = k.getResponseHeader("Last-Modified")) && (S.lastModified[o] = x), (x = k.getResponseHeader("etag")) && (S.etag[o] = x)),
                                      204 === e || "HEAD" === f.type ? (T = "nocontent") : 304 === e ? (T = "notmodified") : ((T = w.state), (p = w.data), (u = !(b = w.error))))
                                    : ((b = T), (!e && T) || ((T = "error"), e < 0 && (e = 0))),
                                (k.status = e),
                                (k.statusText = (t || T) + ""),
                                u ? y.resolveWith(h, [p, T, k]) : y.rejectWith(h, [k, T, b]),
                                k.statusCode(m),
                                (m = void 0),
                                d && v.trigger(u ? "ajaxSuccess" : "ajaxError", [k, f, u ? p : b]),
                                g.fireWith(h, [k, T]),
                                d && (v.trigger("ajaxComplete", [k, f]), --S.active || S.event.trigger("ajaxStop")));
                        }
                        return k;
                    },
                    getJSON: function (e, t, n) {
                        return S.get(e, t, n, "json");
                    },
                    getScript: function (e, t) {
                        return S.get(e, void 0, t, "script");
                    },
                }),
                S.each(["get", "post"], function (e, t) {
                    S[t] = function (e, n, i, o) {
                        return g(n) && ((o = o || i), (i = n), (n = void 0)), S.ajax(S.extend({ url: e, type: t, dataType: o, data: n, success: i }, S.isPlainObject(e) && e));
                    };
                }),
                S.ajaxPrefilter(function (e) {
                    var t;
                    for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
                }),
                (S._evalUrl = function (e, t, n) {
                    return S.ajax({
                        url: e,
                        type: "GET",
                        dataType: "script",
                        cache: !0,
                        async: !1,
                        global: !1,
                        converters: { "text script": function () {} },
                        dataFilter: function (e) {
                            S.globalEval(e, t, n);
                        },
                    });
                }),
                S.fn.extend({
                    wrapAll: function (e) {
                        var t;
                        return (
                            this[0] &&
                                (g(e) && (e = e.call(this[0])),
                                (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
                                this[0].parentNode && t.insertBefore(this[0]),
                                t
                                    .map(function () {
                                        for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                        return e;
                                    })
                                    .append(this)),
                            this
                        );
                    },
                    wrapInner: function (e) {
                        return g(e)
                            ? this.each(function (t) {
                                  S(this).wrapInner(e.call(this, t));
                              })
                            : this.each(function () {
                                  var t = S(this),
                                      n = t.contents();
                                  n.length ? n.wrapAll(e) : t.append(e);
                              });
                    },
                    wrap: function (e) {
                        var t = g(e);
                        return this.each(function (n) {
                            S(this).wrapAll(t ? e.call(this, n) : e);
                        });
                    },
                    unwrap: function (e) {
                        return (
                            this.parent(e)
                                .not("body")
                                .each(function () {
                                    S(this).replaceWith(this.childNodes);
                                }),
                            this
                        );
                    },
                }),
                (S.expr.pseudos.hidden = function (e) {
                    return !S.expr.pseudos.visible(e);
                }),
                (S.expr.pseudos.visible = function (e) {
                    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
                }),
                (S.ajaxSettings.xhr = function () {
                    try {
                        return new n.XMLHttpRequest();
                    } catch (e) {}
                });
            var Ft = { 0: 200, 1223: 204 },
                Bt = S.ajaxSettings.xhr();
            (y.cors = !!Bt && "withCredentials" in Bt),
                (y.ajax = Bt = !!Bt),
                S.ajaxTransport(function (e) {
                    var t, i;
                    if (y.cors || (Bt && !e.crossDomain))
                        return {
                            send: function (o, r) {
                                var s,
                                    a = e.xhr();
                                if ((a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)) for (s in e.xhrFields) a[s] = e.xhrFields[s];
                                for (s in (e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o)) a.setRequestHeader(s, o[s]);
                                (t = function (e) {
                                    return function () {
                                        t &&
                                            ((t = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null),
                                            "abort" === e
                                                ? a.abort()
                                                : "error" === e
                                                ? "number" != typeof a.status
                                                    ? r(0, "error")
                                                    : r(a.status, a.statusText)
                                                : r(
                                                      Ft[a.status] || a.status,
                                                      a.statusText,
                                                      "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText },
                                                      a.getAllResponseHeaders()
                                                  ));
                                    };
                                }),
                                    (a.onload = t()),
                                    (i = a.onerror = a.ontimeout = t("error")),
                                    void 0 !== a.onabort
                                        ? (a.onabort = i)
                                        : (a.onreadystatechange = function () {
                                              4 === a.readyState &&
                                                  n.setTimeout(function () {
                                                      t && i();
                                                  });
                                          }),
                                    (t = t("abort"));
                                try {
                                    a.send((e.hasContent && e.data) || null);
                                } catch (e) {
                                    if (t) throw e;
                                }
                            },
                            abort: function () {
                                t && t();
                            },
                        };
                }),
                S.ajaxPrefilter(function (e) {
                    e.crossDomain && (e.contents.script = !1);
                }),
                S.ajaxSetup({
                    accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                    contents: { script: /\b(?:java|ecma)script\b/ },
                    converters: {
                        "text script": function (e) {
                            return S.globalEval(e), e;
                        },
                    },
                }),
                S.ajaxPrefilter("script", function (e) {
                    void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
                }),
                S.ajaxTransport("script", function (e) {
                    var t, n;
                    if (e.crossDomain || e.scriptAttrs)
                        return {
                            send: function (i, o) {
                                (t = S("<script>")
                                    .attr(e.scriptAttrs || {})
                                    .prop({ charset: e.scriptCharset, src: e.url })
                                    .on(
                                        "load error",
                                        (n = function (e) {
                                            t.remove(), (n = null), e && o("error" === e.type ? 404 : 200, e.type);
                                        })
                                    )),
                                    b.head.appendChild(t[0]);
                            },
                            abort: function () {
                                n && n();
                            },
                        };
                });
            var Ut,
                Xt = [],
                Yt = /(=)\?(?=&|$)|\?\?/;
            S.ajaxSetup({
                jsonp: "callback",
                jsonpCallback: function () {
                    var e = Xt.pop() || S.expando + "_" + St.guid++;
                    return (this[e] = !0), e;
                },
            }),
                S.ajaxPrefilter("json jsonp", function (e, t, i) {
                    var o,
                        r,
                        s,
                        a = !1 !== e.jsonp && (Yt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Yt.test(e.data) && "data");
                    if (a || "jsonp" === e.dataTypes[0])
                        return (
                            (o = e.jsonpCallback = g(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                            a ? (e[a] = e[a].replace(Yt, "$1" + o)) : !1 !== e.jsonp && (e.url += (kt.test(e.url) ? "&" : "?") + e.jsonp + "=" + o),
                            (e.converters["script json"] = function () {
                                return s || S.error(o + " was not called"), s[0];
                            }),
                            (e.dataTypes[0] = "json"),
                            (r = n[o]),
                            (n[o] = function () {
                                s = arguments;
                            }),
                            i.always(function () {
                                void 0 === r ? S(n).removeProp(o) : (n[o] = r), e[o] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(o)), s && g(r) && r(s[0]), (s = r = void 0);
                            }),
                            "script"
                        );
                }),
                (y.createHTMLDocument = (((Ut = b.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === Ut.childNodes.length)),
                (S.parseHTML = function (e, t, n) {
                    return "string" != typeof e
                        ? []
                        : ("boolean" == typeof t && ((n = t), (t = !1)),
                          t || (y.createHTMLDocument ? (((i = (t = b.implementation.createHTMLDocument("")).createElement("base")).href = b.location.href), t.head.appendChild(i)) : (t = b)),
                          (r = !n && []),
                          (o = L.exec(e)) ? [t.createElement(o[1])] : ((o = Te([e], t, r)), r && r.length && S(r).remove(), S.merge([], o.childNodes)));
                    var i, o, r;
                }),
                (S.fn.load = function (e, t, n) {
                    var i,
                        o,
                        r,
                        s = this,
                        a = e.indexOf(" ");
                    return (
                        a > -1 && ((i = yt(e.slice(a))), (e = e.slice(0, a))),
                        g(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (o = "POST"),
                        s.length > 0 &&
                            S.ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                                .done(function (e) {
                                    (r = arguments), s.html(i ? S("<div>").append(S.parseHTML(e)).find(i) : e);
                                })
                                .always(
                                    n &&
                                        function (e, t) {
                                            s.each(function () {
                                                n.apply(this, r || [e.responseText, t, e]);
                                            });
                                        }
                                ),
                        this
                    );
                }),
                (S.expr.pseudos.animated = function (e) {
                    return S.grep(S.timers, function (t) {
                        return e === t.elem;
                    }).length;
                }),
                (S.offset = {
                    setOffset: function (e, t, n) {
                        var i,
                            o,
                            r,
                            s,
                            a,
                            l,
                            c = S.css(e, "position"),
                            d = S(e),
                            u = {};
                        "static" === c && (e.style.position = "relative"),
                            (a = d.offset()),
                            (r = S.css(e, "top")),
                            (l = S.css(e, "left")),
                            ("absolute" === c || "fixed" === c) && (r + l).indexOf("auto") > -1 ? ((s = (i = d.position()).top), (o = i.left)) : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
                            g(t) && (t = t.call(e, n, S.extend({}, a))),
                            null != t.top && (u.top = t.top - a.top + s),
                            null != t.left && (u.left = t.left - a.left + o),
                            "using" in t ? t.using.call(e, u) : d.css(u);
                    },
                }),
                S.fn.extend({
                    offset: function (e) {
                        if (arguments.length)
                            return void 0 === e
                                ? this
                                : this.each(function (t) {
                                      S.offset.setOffset(this, e, t);
                                  });
                        var t,
                            n,
                            i = this[0];
                        return i ? (i.getClientRects().length ? ((t = i.getBoundingClientRect()), (n = i.ownerDocument.defaultView), { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
                    },
                    position: function () {
                        if (this[0]) {
                            var e,
                                t,
                                n,
                                i = this[0],
                                o = { top: 0, left: 0 };
                            if ("fixed" === S.css(i, "position")) t = i.getBoundingClientRect();
                            else {
                                for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position"); ) e = e.parentNode;
                                e && e !== i && 1 === e.nodeType && (((o = S(e).offset()).top += S.css(e, "borderTopWidth", !0)), (o.left += S.css(e, "borderLeftWidth", !0)));
                            }
                            return { top: t.top - o.top - S.css(i, "marginTop", !0), left: t.left - o.left - S.css(i, "marginLeft", !0) };
                        }
                    },
                    offsetParent: function () {
                        return this.map(function () {
                            for (var e = this.offsetParent; e && "static" === S.css(e, "position"); ) e = e.offsetParent;
                            return e || re;
                        });
                    },
                }),
                S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                    var n = "pageYOffset" === t;
                    S.fn[e] = function (i) {
                        return B(
                            this,
                            function (e, i, o) {
                                var r;
                                if ((m(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === o)) return r ? r[t] : e[i];
                                r ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset) : (e[i] = o);
                            },
                            e,
                            i,
                            arguments.length
                        );
                    };
                }),
                S.each(["top", "left"], function (e, t) {
                    S.cssHooks[t] = Be(y.pixelPosition, function (e, n) {
                        if (n) return (n = Fe(e, t)), _e.test(n) ? S(e).position()[t] + "px" : n;
                    });
                }),
                S.each({ Height: "height", Width: "width" }, function (e, t) {
                    S.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                        S.fn[i] = function (o, r) {
                            var s = arguments.length && (n || "boolean" != typeof o),
                                a = n || (!0 === o || !0 === r ? "margin" : "border");
                            return B(
                                this,
                                function (t, n, o) {
                                    var r;
                                    return m(t)
                                        ? 0 === i.indexOf("outer")
                                            ? t["inner" + e]
                                            : t.document.documentElement["client" + e]
                                        : 9 === t.nodeType
                                        ? ((r = t.documentElement), Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e]))
                                        : void 0 === o
                                        ? S.css(t, n, a)
                                        : S.style(t, n, o, a);
                                },
                                t,
                                s ? o : void 0,
                                s
                            );
                        };
                    });
                }),
                S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                    S.fn[t] = function (e) {
                        return this.on(t, e);
                    };
                }),
                S.fn.extend({
                    bind: function (e, t, n) {
                        return this.on(e, null, t, n);
                    },
                    unbind: function (e, t) {
                        return this.off(e, null, t);
                    },
                    delegate: function (e, t, n, i) {
                        return this.on(t, e, n, i);
                    },
                    undelegate: function (e, t, n) {
                        return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                    },
                    hover: function (e, t) {
                        return this.mouseenter(e).mouseleave(t || e);
                    },
                }),
                S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
                    S.fn[t] = function (e, n) {
                        return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                    };
                });
            var Vt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            (S.proxy = function (e, t) {
                var n, i, o;
                if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
                    return (
                        (i = a.call(arguments, 2)),
                        ((o = function () {
                            return e.apply(t || this, i.concat(a.call(arguments)));
                        }).guid = e.guid = e.guid || S.guid++),
                        o
                    );
            }),
                (S.holdReady = function (e) {
                    e ? S.readyWait++ : S.ready(!0);
                }),
                (S.isArray = Array.isArray),
                (S.parseJSON = JSON.parse),
                (S.nodeName = E),
                (S.isFunction = g),
                (S.isWindow = m),
                (S.camelCase = V),
                (S.type = T),
                (S.now = Date.now),
                (S.isNumeric = function (e) {
                    var t = S.type(e);
                    return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
                }),
                (S.trim = function (e) {
                    return null == e ? "" : (e + "").replace(Vt, "");
                }),
                void 0 ===
                    (i = function () {
                        return S;
                    }.apply(t, [])) || (e.exports = i);
            var Jt = n.jQuery,
                Gt = n.$;
            return (
                (S.noConflict = function (e) {
                    return n.$ === S && (n.$ = Gt), e && n.jQuery === S && (n.jQuery = Jt), S;
                }),
                void 0 === o && (n.jQuery = n.$ = S),
                S
            );
        });
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        t.formatMoney = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "USD",
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "en-US",
                i = !0;
            "JPY" === t && (i = !1);
            var o = 0.01 * e;
            return i && o % 1 == 0 ? o.toLocaleString(n, { style: "currency", currency: t }).slice(0, -3) : o.toLocaleString(n, { style: "currency", currency: t });
        };
    },
    function (e, t, n) {
        var i, o, r;
        !(function (s) {
            "use strict";
            (o = [n(0)]),
                void 0 ===
                    (r =
                        "function" ==
                        typeof (i = function (e) {
                            var t = window.Slick || {};
                            (((n = 0),
                            (t = function (t, i) {
                                var o,
                                    r = this;
                                (r.defaults = {
                                    accessibility: !0,
                                    adaptiveHeight: !1,
                                    appendArrows: e(t),
                                    appendDots: e(t),
                                    arrows: !0,
                                    asNavFor: null,
                                    prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
<g clip-path="url(#clip0_1376_6)">
<path d="M17.418 8.20898L10.1263 15.5007L17.418 22.7923" stroke="black" stroke-width="2.1875" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<rect x="-1" y="1" width="28" height="28" rx="14" transform="matrix(-1 0 0 1 28 0)" stroke="black" stroke-width="2"/>
<defs>
<clipPath id="clip0_1376_6">
<rect width="30" height="30" rx="15" transform="matrix(-1 0 0 1 30 0)" fill="white"/>
</clipPath>
</defs>
</svg>
  </button>`,
  nextArrow: `<button type="button" class="slick-next" aria-label="Next">
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
<g clip-path="url(#clip0_1376_2)">
<path d="M12.582 8.20898L19.8737 15.5007L12.582 22.7923" stroke="black" stroke-width="2.1875" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<rect x="1" y="1" width="28" height="28" rx="14" stroke="black" stroke-width="2"/>
<defs>
<clipPath id="clip0_1376_2">
<rect width="30" height="30" rx="15" fill="white"/>
</clipPath>
</defs>
</svg>
  </button>`,
                                    autoplay: !1,
                                    autoplaySpeed: 3e3,
                                    centerMode: !1,
                                    centerPadding: "50px",
                                    cssEase: "ease",
                                    customPaging: function (t, n) {
                                        return e('<button type="button" />').text(n + 1);
                                    },
                                    dots: !1,
                                    dotsClass: "slick-dots",
                                    draggable: !0,
                                    easing: "linear",
                                    edgeFriction: 0.35,
                                    fade: !1,
                                    focusOnSelect: !1,
                                    focusOnChange: !1,
                                    infinite: !0,
                                    initialSlide: 0,
                                    lazyLoad: "ondemand",
                                    mobileFirst: !1,
                                    pauseOnHover: !0,
                                    pauseOnFocus: !0,
                                    pauseOnDotsHover: !1,
                                    respondTo: "window",
                                    responsive: null,
                                    rows: 1,
                                    rtl: !1,
                                    slide: "",
                                    slidesPerRow: 1,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    speed: 500,
                                    swipe: !0,
                                    swipeToSlide: !1,
                                    touchMove: !0,
                                    touchThreshold: 5,
                                    useCSS: !0,
                                    useTransform: !0,
                                    variableWidth: !1,
                                    vertical: !1,
                                    verticalSwiping: !1,
                                    waitForAnimate: !0,
                                    zIndex: 1e3,
                                }),
                                    (r.initials = {
                                        animating: !1,
                                        dragging: !1,
                                        autoPlayTimer: null,
                                        currentDirection: 0,
                                        currentLeft: null,
                                        currentSlide: 0,
                                        direction: 1,
                                        $dots: null,
                                        listWidth: null,
                                        listHeight: null,
                                        loadIndex: 0,
                                        $nextArrow: null,
                                        $prevArrow: null,
                                        scrolling: !1,
                                        slideCount: null,
                                        slideWidth: null,
                                        $slideTrack: null,
                                        $slides: null,
                                        sliding: !1,
                                        slideOffset: 0,
                                        swipeLeft: null,
                                        swiping: !1,
                                        $list: null,
                                        touchObject: {},
                                        transformsEnabled: !1,
                                        unslicked: !1,
                                    }),
                                    e.extend(r, r.initials),
                                    (r.activeBreakpoint = null),
                                    (r.animType = null),
                                    (r.animProp = null),
                                    (r.breakpoints = []),
                                    (r.breakpointSettings = []),
                                    (r.cssTransitions = !1),
                                    (r.focussed = !1),
                                    (r.interrupted = !1),
                                    (r.hidden = "hidden"),
                                    (r.paused = !0),
                                    (r.positionProp = null),
                                    (r.respondTo = null),
                                    (r.rowCount = 1),
                                    (r.shouldClick = !0),
                                    (r.$slider = e(t)),
                                    (r.$slidesCache = null),
                                    (r.transformType = null),
                                    (r.transitionType = null),
                                    (r.visibilityChange = "visibilitychange"),
                                    (r.windowWidth = 0),
                                    (r.windowTimer = null),
                                    (o = e(t).data("slick") || {}),
                                    (r.options = e.extend({}, r.defaults, i, o)),
                                    (r.currentSlide = r.options.initialSlide),
                                    (r.originalSettings = r.options),
                                    void 0 !== document.mozHidden
                                        ? ((r.hidden = "mozHidden"), (r.visibilityChange = "mozvisibilitychange"))
                                        : void 0 !== document.webkitHidden && ((r.hidden = "webkitHidden"), (r.visibilityChange = "webkitvisibilitychange")),
                                    (r.autoPlay = e.proxy(r.autoPlay, r)),
                                    (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
                                    (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
                                    (r.changeSlide = e.proxy(r.changeSlide, r)),
                                    (r.clickHandler = e.proxy(r.clickHandler, r)),
                                    (r.selectHandler = e.proxy(r.selectHandler, r)),
                                    (r.setPosition = e.proxy(r.setPosition, r)),
                                    (r.swipeHandler = e.proxy(r.swipeHandler, r)),
                                    (r.dragHandler = e.proxy(r.dragHandler, r)),
                                    (r.keyHandler = e.proxy(r.keyHandler, r)),
                                    (r.instanceUid = n++),
                                    (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                                    r.registerBreakpoints(),
                                    r.init(!0);
                            })).prototype.activateADA = function () {
                                this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
                            }),
                                (t.prototype.addSlide = t.prototype.slickAdd = function (t, n, i) {
                                    var o = this;
                                    if ("boolean" == typeof n) (i = n), (n = null);
                                    else if (n < 0 || n >= o.slideCount) return !1;
                                    o.unload(),
                                        "number" == typeof n
                                            ? 0 === n && 0 === o.$slides.length
                                                ? e(t).appendTo(o.$slideTrack)
                                                : i
                                                ? e(t).insertBefore(o.$slides.eq(n))
                                                : e(t).insertAfter(o.$slides.eq(n))
                                            : !0 === i
                                            ? e(t).prependTo(o.$slideTrack)
                                            : e(t).appendTo(o.$slideTrack),
                                        (o.$slides = o.$slideTrack.children(this.options.slide)),
                                        o.$slideTrack.children(this.options.slide).detach(),
                                        o.$slideTrack.append(o.$slides),
                                        o.$slides.each(function (t, n) {
                                            e(n).attr("data-slick-index", t);
                                        }),
                                        (o.$slidesCache = o.$slides),
                                        o.reinit();
                                }),
                                (t.prototype.animateHeight = function () {
                                    var e = this;
                                    if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                                        var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                                        e.$list.animate({ height: t }, e.options.speed);
                                    }
                                }),
                                (t.prototype.animateSlide = function (t, n) {
                                    var i = {},
                                        o = this;
                                    o.animateHeight(),
                                        !0 === o.options.rtl && !1 === o.options.vertical && (t = -t),
                                        !1 === o.transformsEnabled
                                            ? !1 === o.options.vertical
                                                ? o.$slideTrack.animate({ left: t }, o.options.speed, o.options.easing, n)
                                                : o.$slideTrack.animate({ top: t }, o.options.speed, o.options.easing, n)
                                            : !1 === o.cssTransitions
                                            ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft),
                                              e({ animStart: o.currentLeft }).animate(
                                                  { animStart: t },
                                                  {
                                                      duration: o.options.speed,
                                                      easing: o.options.easing,
                                                      step: function (e) {
                                                          (e = Math.ceil(e)),
                                                              !1 === o.options.vertical ? ((i[o.animType] = "translate(" + e + "px, 0px)"), o.$slideTrack.css(i)) : ((i[o.animType] = "translate(0px," + e + "px)"), o.$slideTrack.css(i));
                                                      },
                                                      complete: function () {
                                                          n && n.call();
                                                      },
                                                  }
                                              ))
                                            : (o.applyTransition(),
                                              (t = Math.ceil(t)),
                                              !1 === o.options.vertical ? (i[o.animType] = "translate3d(" + t + "px, 0px, 0px)") : (i[o.animType] = "translate3d(0px," + t + "px, 0px)"),
                                              o.$slideTrack.css(i),
                                              n &&
                                                  setTimeout(function () {
                                                      o.disableTransition(), n.call();
                                                  }, o.options.speed));
                                }),
                                (t.prototype.getNavTarget = function () {
                                    var t = this.options.asNavFor;
                                    return t && null !== t && (t = e(t).not(this.$slider)), t;
                                }),
                                (t.prototype.asNavFor = function (t) {
                                    var n = this.getNavTarget();
                                    null !== n &&
                                        "object" == typeof n &&
                                        n.each(function () {
                                            var n = e(this).slick("getSlick");
                                            n.unslicked || n.slideHandler(t, !0);
                                        });
                                }),
                                (t.prototype.applyTransition = function (e) {
                                    var t = this,
                                        n = {};
                                    !1 === t.options.fade ? (n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase) : (n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
                                        !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
                                }),
                                (t.prototype.autoPlay = function () {
                                    var e = this;
                                    e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
                                }),
                                (t.prototype.autoPlayClear = function () {
                                    this.autoPlayTimer && clearInterval(this.autoPlayTimer);
                                }),
                                (t.prototype.autoPlayIterator = function () {
                                    var e = this,
                                        t = e.currentSlide + e.options.slidesToScroll;
                                    e.paused ||
                                        e.interrupted ||
                                        e.focussed ||
                                        (!1 === e.options.infinite &&
                                            (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
                                                ? (e.direction = 0)
                                                : 0 === e.direction && ((t = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 == 0 && (e.direction = 1))),
                                        e.slideHandler(t));
                                }),
                                (t.prototype.buildArrows = function () {
                                    var t = this;
                                    !0 === t.options.arrows &&
                                        ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
                                        (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
                                        t.slideCount > t.options.slidesToShow
                                            ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                              t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                              t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
                                              t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
                                              !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                                            : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
                                }),
                                (t.prototype.buildDots = function () {
                                    var t,
                                        n,
                                        i = this;
                                    if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
                                        for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
                                        (i.$dots = n.appendTo(i.options.appendDots)), i.$dots.find("li").first().addClass("slick-active");
                                    }
                                }),
                                (t.prototype.buildOut = function () {
                                    var t = this;
                                    (t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                                        (t.slideCount = t.$slides.length),
                                        t.$slides.each(function (t, n) {
                                            e(n)
                                                .attr("data-slick-index", t)
                                                .data("originalStyling", e(n).attr("style") || "");
                                        }),
                                        t.$slider.addClass("slick-slider"),
                                        (t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
                                        (t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                                        t.$slideTrack.css("opacity", 0),
                                        (!0 !== t.options.centerMode && !0 !== t.options.swipeToSlide) || (t.options.slidesToScroll = 1),
                                        e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
                                        t.setupInfinite(),
                                        t.buildArrows(),
                                        t.buildDots(),
                                        t.updateDots(),
                                        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                                        !0 === t.options.draggable && t.$list.addClass("draggable");
                                }),
                                (t.prototype.buildRows = function () {
                                    var e,
                                        t,
                                        n,
                                        i,
                                        o,
                                        r,
                                        s,
                                        a = this;
                                    if (((i = document.createDocumentFragment()), (r = a.$slider.children()), a.options.rows > 0)) {
                                        for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
                                            var l = document.createElement("div");
                                            for (t = 0; t < a.options.rows; t++) {
                                                var c = document.createElement("div");
                                                for (n = 0; n < a.options.slidesPerRow; n++) {
                                                    var d = e * s + (t * a.options.slidesPerRow + n);
                                                    r.get(d) && c.appendChild(r.get(d));
                                                }
                                                l.appendChild(c);
                                            }
                                            i.appendChild(l);
                                        }
                                        a.$slider.empty().append(i),
                                            a.$slider
                                                .children()
                                                .children()
                                                .children()
                                                .css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
                                    }
                                }),
                                (t.prototype.checkResponsive = function (t, n) {
                                    var i,
                                        o,
                                        r,
                                        s = this,
                                        a = !1,
                                        l = s.$slider.width(),
                                        c = window.innerWidth || e(window).width();
                                    if (
                                        ("window" === s.respondTo ? (r = c) : "slider" === s.respondTo ? (r = l) : "min" === s.respondTo && (r = Math.min(c, l)),
                                        s.options.responsive && s.options.responsive.length && null !== s.options.responsive)
                                    ) {
                                        for (i in ((o = null), s.breakpoints))
                                            s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? r < s.breakpoints[i] && (o = s.breakpoints[i]) : r > s.breakpoints[i] && (o = s.breakpoints[i]));
                                        null !== o
                                            ? null !== s.activeBreakpoint
                                                ? (o !== s.activeBreakpoint || n) &&
                                                  ((s.activeBreakpoint = o),
                                                  "unslick" === s.breakpointSettings[o]
                                                      ? s.unslick(o)
                                                      : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o])), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                                                  (a = o))
                                                : ((s.activeBreakpoint = o),
                                                  "unslick" === s.breakpointSettings[o]
                                                      ? s.unslick(o)
                                                      : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o])), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                                                  (a = o))
                                            : null !== s.activeBreakpoint && ((s.activeBreakpoint = null), (s.options = s.originalSettings), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t), (a = o)),
                                            t || !1 === a || s.$slider.trigger("breakpoint", [s, a]);
                                    }
                                }),
                                (t.prototype.changeSlide = function (t, n) {
                                    var i,
                                        o,
                                        r = this,
                                        s = e(t.currentTarget);
                                    switch (
                                        (s.is("a") && t.preventDefault(),
                                        s.is("li") || (s = s.closest("li")),
                                        (i = r.slideCount % r.options.slidesToScroll != 0 ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
                                        t.data.message)
                                    ) {
                                        case "previous":
                                            (o = 0 === i ? r.options.slidesToScroll : r.options.slidesToShow - i), r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - o, !1, n);
                                            break;
                                        case "next":
                                            (o = 0 === i ? r.options.slidesToScroll : i), r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + o, !1, n);
                                            break;
                                        case "index":
                                            var a = 0 === t.data.index ? 0 : t.data.index || s.index() * r.options.slidesToScroll;
                                            r.slideHandler(r.checkNavigable(a), !1, n), s.children().trigger("focus");
                                            break;
                                        default:
                                            return;
                                    }
                                }),
                                (t.prototype.checkNavigable = function (e) {
                                    var t, n;
                                    if (((n = 0), e > (t = this.getNavigableIndexes())[t.length - 1])) e = t[t.length - 1];
                                    else
                                        for (var i in t) {
                                            if (e < t[i]) {
                                                e = n;
                                                break;
                                            }
                                            n = t[i];
                                        }
                                    return e;
                                }),
                                (t.prototype.cleanUpEvents = function () {
                                    var t = this;
                                    t.options.dots &&
                                        null !== t.$dots &&
                                        (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
                                        !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)),
                                        t.$slider.off("focus.slick blur.slick"),
                                        !0 === t.options.arrows &&
                                            t.slideCount > t.options.slidesToShow &&
                                            (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
                                            t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide),
                                            !0 === t.options.accessibility && (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))),
                                        t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
                                        t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
                                        t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
                                        t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
                                        t.$list.off("click.slick", t.clickHandler),
                                        e(document).off(t.visibilityChange, t.visibility),
                                        t.cleanUpSlideEvents(),
                                        !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler),
                                        !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler),
                                        e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
                                        e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
                                        e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
                                        e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition);
                                }),
                                (t.prototype.cleanUpSlideEvents = function () {
                                    var t = this;
                                    t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
                                }),
                                (t.prototype.cleanUpRows = function () {
                                    var e,
                                        t = this;
                                    t.options.rows > 0 && ((e = t.$slides.children().children()).removeAttr("style"), t.$slider.empty().append(e));
                                }),
                                (t.prototype.clickHandler = function (e) {
                                    !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
                                }),
                                (t.prototype.destroy = function (t) {
                                    var n = this;
                                    n.autoPlayClear(),
                                        (n.touchObject = {}),
                                        n.cleanUpEvents(),
                                        e(".slick-cloned", n.$slider).detach(),
                                        n.$dots && n.$dots.remove(),
                                        n.$prevArrow &&
                                            n.$prevArrow.length &&
                                            (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
                                            n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
                                        n.$nextArrow &&
                                            n.$nextArrow.length &&
                                            (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
                                            n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
                                        n.$slides &&
                                            (n.$slides
                                                .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                                                .removeAttr("aria-hidden")
                                                .removeAttr("data-slick-index")
                                                .each(function () {
                                                    e(this).attr("style", e(this).data("originalStyling"));
                                                }),
                                            n.$slideTrack.children(this.options.slide).detach(),
                                            n.$slideTrack.detach(),
                                            n.$list.detach(),
                                            n.$slider.append(n.$slides)),
                                        n.cleanUpRows(),
                                        n.$slider.removeClass("slick-slider"),
                                        n.$slider.removeClass("slick-initialized"),
                                        n.$slider.removeClass("slick-dotted"),
                                        (n.unslicked = !0),
                                        t || n.$slider.trigger("destroy", [n]);
                                }),
                                (t.prototype.disableTransition = function (e) {
                                    var t = this,
                                        n = {};
                                    (n[t.transitionType] = ""), !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
                                }),
                                (t.prototype.fadeSlide = function (e, t) {
                                    var n = this;
                                    !1 === n.cssTransitions
                                        ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }), n.$slides.eq(e).animate({ opacity: 1 }, n.options.speed, n.options.easing, t))
                                        : (n.applyTransition(e),
                                          n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
                                          t &&
                                              setTimeout(function () {
                                                  n.disableTransition(e), t.call();
                                              }, n.options.speed));
                                }),
                                (t.prototype.fadeSlideOut = function (e) {
                                    var t = this;
                                    !1 === t.cssTransitions
                                        ? t.$slides.eq(e).animate({ opacity: 0, zIndex: t.options.zIndex - 2 }, t.options.speed, t.options.easing)
                                        : (t.applyTransition(e), t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
                                }),
                                (t.prototype.filterSlides = t.prototype.slickFilter = function (e) {
                                    var t = this;
                                    null !== e && ((t.$slidesCache = t.$slides), t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit());
                                }),
                                (t.prototype.focusHandler = function () {
                                    var t = this;
                                    t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (n) {
                                        n.stopImmediatePropagation();
                                        var i = e(this);
                                        setTimeout(function () {
                                            t.options.pauseOnFocus && ((t.focussed = i.is(":focus")), t.autoPlay());
                                        }, 0);
                                    });
                                }),
                                (t.prototype.getCurrent = t.prototype.slickCurrentSlide = function () {
                                    return this.currentSlide;
                                }),
                                (t.prototype.getDotCount = function () {
                                    var e = this,
                                        t = 0,
                                        n = 0,
                                        i = 0;
                                    if (!0 === e.options.infinite)
                                        if (e.slideCount <= e.options.slidesToShow) ++i;
                                        else for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                                    else if (!0 === e.options.centerMode) i = e.slideCount;
                                    else if (e.options.asNavFor)
                                        for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                                    else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                                    return i - 1;
                                }),
                                (t.prototype.getLeft = function (e) {
                                    var t,
                                        n,
                                        i,
                                        o,
                                        r = this,
                                        s = 0;
                                    return (
                                        (r.slideOffset = 0),
                                        (n = r.$slides.first().outerHeight(!0)),
                                        !0 === r.options.infinite
                                            ? (r.slideCount > r.options.slidesToShow &&
                                                  ((r.slideOffset = r.slideWidth * r.options.slidesToShow * -1),
                                                  (o = -1),
                                                  !0 === r.options.vertical && !0 === r.options.centerMode && (2 === r.options.slidesToShow ? (o = -1.5) : 1 === r.options.slidesToShow && (o = -2)),
                                                  (s = n * r.options.slidesToShow * o)),
                                              r.slideCount % r.options.slidesToScroll != 0 &&
                                                  e + r.options.slidesToScroll > r.slideCount &&
                                                  r.slideCount > r.options.slidesToShow &&
                                                  (e > r.slideCount
                                                      ? ((r.slideOffset = (r.options.slidesToShow - (e - r.slideCount)) * r.slideWidth * -1), (s = (r.options.slidesToShow - (e - r.slideCount)) * n * -1))
                                                      : ((r.slideOffset = (r.slideCount % r.options.slidesToScroll) * r.slideWidth * -1), (s = (r.slideCount % r.options.slidesToScroll) * n * -1))))
                                            : e + r.options.slidesToShow > r.slideCount && ((r.slideOffset = (e + r.options.slidesToShow - r.slideCount) * r.slideWidth), (s = (e + r.options.slidesToShow - r.slideCount) * n)),
                                        r.slideCount <= r.options.slidesToShow && ((r.slideOffset = 0), (s = 0)),
                                        !0 === r.options.centerMode && r.slideCount <= r.options.slidesToShow
                                            ? (r.slideOffset = (r.slideWidth * Math.floor(r.options.slidesToShow)) / 2 - (r.slideWidth * r.slideCount) / 2)
                                            : !0 === r.options.centerMode && !0 === r.options.infinite
                                            ? (r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2) - r.slideWidth)
                                            : !0 === r.options.centerMode && ((r.slideOffset = 0), (r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2))),
                                        (t = !1 === r.options.vertical ? e * r.slideWidth * -1 + r.slideOffset : e * n * -1 + s),
                                        !0 === r.options.variableWidth &&
                                            ((i = r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite ? r.$slideTrack.children(".slick-slide").eq(e) : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow)),
                                            (t = !0 === r.options.rtl ? (i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0) : i[0] ? -1 * i[0].offsetLeft : 0),
                                            !0 === r.options.centerMode &&
                                                ((i =
                                                    r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite
                                                        ? r.$slideTrack.children(".slick-slide").eq(e)
                                                        : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow + 1)),
                                                (t = !0 === r.options.rtl ? (i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0) : i[0] ? -1 * i[0].offsetLeft : 0),
                                                (t += (r.$list.width() - i.outerWidth()) / 2))),
                                        t
                                    );
                                }),
                                (t.prototype.getOption = t.prototype.slickGetOption = function (e) {
                                    return this.options[e];
                                }),
                                (t.prototype.getNavigableIndexes = function () {
                                    var e,
                                        t = this,
                                        n = 0,
                                        i = 0,
                                        o = [];
                                    for (!1 === t.options.infinite ? (e = t.slideCount) : ((n = -1 * t.options.slidesToScroll), (i = -1 * t.options.slidesToScroll), (e = 2 * t.slideCount)); n < e; )
                                        o.push(n), (n = i + t.options.slidesToScroll), (i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow);
                                    return o;
                                }),
                                (t.prototype.getSlick = function () {
                                    return this;
                                }),
                                (t.prototype.getSlideCount = function () {
                                    var t,
                                        n,
                                        i = this;
                                    return (
                                        (n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0),
                                        !0 === i.options.swipeToSlide
                                            ? (i.$slideTrack.find(".slick-slide").each(function (o, r) {
                                                  if (r.offsetLeft - n + e(r).outerWidth() / 2 > -1 * i.swipeLeft) return (t = r), !1;
                                              }),
                                              Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1)
                                            : i.options.slidesToScroll
                                    );
                                }),
                                (t.prototype.goTo = t.prototype.slickGoTo = function (e, t) {
                                    this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
                                }),
                                (t.prototype.init = function (t) {
                                    var n = this;
                                    e(n.$slider).hasClass("slick-initialized") ||
                                        (e(n.$slider).addClass("slick-initialized"),
                                        n.buildRows(),
                                        n.buildOut(),
                                        n.setProps(),
                                        n.startLoad(),
                                        n.loadSlider(),
                                        n.initializeEvents(),
                                        n.updateArrows(),
                                        n.updateDots(),
                                        n.checkResponsive(!0),
                                        n.focusHandler()),
                                        t && n.$slider.trigger("init", [n]),
                                        !0 === n.options.accessibility && n.initADA(),
                                        n.options.autoplay && ((n.paused = !1), n.autoPlay());
                                }),
                                (t.prototype.initADA = function () {
                                    var t = this,
                                        n = Math.ceil(t.slideCount / t.options.slidesToShow),
                                        i = t.getNavigableIndexes().filter(function (e) {
                                            return e >= 0 && e < t.slideCount;
                                        });
                                    t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                                        null !== t.$dots &&
                                            (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (n) {
                                                var o = i.indexOf(n);
                                                if ((e(this).attr({ role: "tabpanel", id: "slick-slide" + t.instanceUid + n, tabindex: -1 }), -1 !== o)) {
                                                    var r = "slick-slide-control" + t.instanceUid + o;
                                                    e("#" + r).length && e(this).attr({ "aria-describedby": r });
                                                }
                                            }),
                                            t.$dots
                                                .attr("role", "tablist")
                                                .find("li")
                                                .each(function (o) {
                                                    var r = i[o];
                                                    e(this).attr({ role: "presentation" }),
                                                        e(this)
                                                            .find("button")
                                                            .first()
                                                            .attr({
                                                                role: "tab",
                                                                id: "slick-slide-control" + t.instanceUid + o,
                                                                "aria-controls": "slick-slide" + t.instanceUid + r,
                                                                "aria-label": o + 1 + " of " + n,
                                                                "aria-selected": null,
                                                                tabindex: "-1",
                                                            });
                                                })
                                                .eq(t.currentSlide)
                                                .find("button")
                                                .attr({ "aria-selected": "true", tabindex: "0" })
                                                .end());
                                    for (var o = t.currentSlide, r = o + t.options.slidesToShow; o < r; o++) t.options.focusOnChange ? t.$slides.eq(o).attr({ tabindex: "0" }) : t.$slides.eq(o).removeAttr("tabindex");
                                    t.activateADA();
                                }),
                                (t.prototype.initArrowEvents = function () {
                                    var e = this;
                                    !0 === e.options.arrows &&
                                        e.slideCount > e.options.slidesToShow &&
                                        (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide),
                                        e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide),
                                        !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)));
                                }),
                                (t.prototype.initDotEvents = function () {
                                    var t = this;
                                    !0 === t.options.dots &&
                                        t.slideCount > t.options.slidesToShow &&
                                        (e("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)),
                                        !0 === t.options.dots &&
                                            !0 === t.options.pauseOnDotsHover &&
                                            t.slideCount > t.options.slidesToShow &&
                                            e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
                                }),
                                (t.prototype.initSlideEvents = function () {
                                    var t = this;
                                    t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
                                }),
                                (t.prototype.initializeEvents = function () {
                                    var t = this;
                                    t.initArrowEvents(),
                                        t.initDotEvents(),
                                        t.initSlideEvents(),
                                        t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler),
                                        t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler),
                                        t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler),
                                        t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler),
                                        t.$list.on("click.slick", t.clickHandler),
                                        e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
                                        !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
                                        !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                                        e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)),
                                        e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)),
                                        e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
                                        e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
                                        e(t.setPosition);
                                }),
                                (t.prototype.initUI = function () {
                                    var e = this;
                                    !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show();
                                }),
                                (t.prototype.keyHandler = function (e) {
                                    var t = this;
                                    e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                                        (37 === e.keyCode && !0 === t.options.accessibility
                                            ? t.changeSlide({ data: { message: !0 === t.options.rtl ? "next" : "previous" } })
                                            : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({ data: { message: !0 === t.options.rtl ? "previous" : "next" } }));
                                }),
                                (t.prototype.lazyLoad = function () {
                                    var t,
                                        n,
                                        i,
                                        o = this;
                                    function r(t) {
                                        e("img[data-lazy]", t).each(function () {
                                            var t = e(this),
                                                n = e(this).attr("data-lazy"),
                                                i = e(this).attr("data-srcset"),
                                                r = e(this).attr("data-sizes") || o.$slider.attr("data-sizes"),
                                                s = document.createElement("img");
                                            (s.onload = function () {
                                                t.animate({ opacity: 0 }, 100, function () {
                                                    i && (t.attr("srcset", i), r && t.attr("sizes", r)),
                                                        t.attr("src", n).animate({ opacity: 1 }, 200, function () {
                                                            t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                                        }),
                                                        o.$slider.trigger("lazyLoaded", [o, t, n]);
                                                });
                                            }),
                                                (s.onerror = function () {
                                                    t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, t, n]);
                                                }),
                                                (s.src = n);
                                        });
                                    }
                                    if (
                                        (!0 === o.options.centerMode
                                            ? !0 === o.options.infinite
                                                ? (i = (n = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2)
                                                : ((n = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1))), (i = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide))
                                            : ((n = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide),
                                              (i = Math.ceil(n + o.options.slidesToShow)),
                                              !0 === o.options.fade && (n > 0 && n--, i <= o.slideCount && i++)),
                                        (t = o.$slider.find(".slick-slide").slice(n, i)),
                                        "anticipated" === o.options.lazyLoad)
                                    )
                                        for (var s = n - 1, a = i, l = o.$slider.find(".slick-slide"), c = 0; c < o.options.slidesToScroll; c++) s < 0 && (s = o.slideCount - 1), (t = (t = t.add(l.eq(s))).add(l.eq(a))), s--, a++;
                                    r(t),
                                        o.slideCount <= o.options.slidesToShow
                                            ? r(o.$slider.find(".slick-slide"))
                                            : o.currentSlide >= o.slideCount - o.options.slidesToShow
                                            ? r(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow))
                                            : 0 === o.currentSlide && r(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow));
                                }),
                                (t.prototype.loadSlider = function () {
                                    var e = this;
                                    e.setPosition(), e.$slideTrack.css({ opacity: 1 }), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
                                }),
                                (t.prototype.next = t.prototype.slickNext = function () {
                                    this.changeSlide({ data: { message: "next" } });
                                }),
                                (t.prototype.orientationChange = function () {
                                    this.checkResponsive(), this.setPosition();
                                }),
                                (t.prototype.pause = t.prototype.slickPause = function () {
                                    this.autoPlayClear(), (this.paused = !0);
                                }),
                                (t.prototype.play = t.prototype.slickPlay = function () {
                                    var e = this;
                                    e.autoPlay(), (e.options.autoplay = !0), (e.paused = !1), (e.focussed = !1), (e.interrupted = !1);
                                }),
                                (t.prototype.postSlide = function (t) {
                                    var n = this;
                                    n.unslicked ||
                                        (n.$slider.trigger("afterChange", [n, t]),
                                        (n.animating = !1),
                                        n.slideCount > n.options.slidesToShow && n.setPosition(),
                                        (n.swipeLeft = null),
                                        n.options.autoplay && n.autoPlay(),
                                        !0 === n.options.accessibility && (n.initADA(), n.options.focusOnChange && e(n.$slides.get(n.currentSlide)).attr("tabindex", 0).focus()));
                                }),
                                (t.prototype.prev = t.prototype.slickPrev = function () {
                                    this.changeSlide({ data: { message: "previous" } });
                                }),
                                (t.prototype.preventDefault = function (e) {
                                    e.preventDefault();
                                }),
                                (t.prototype.progressiveLazyLoad = function (t) {
                                    t = t || 1;
                                    var n,
                                        i,
                                        o,
                                        r,
                                        s,
                                        a = this,
                                        l = e("img[data-lazy]", a.$slider);
                                    l.length
                                        ? ((n = l.first()),
                                          (i = n.attr("data-lazy")),
                                          (o = n.attr("data-srcset")),
                                          (r = n.attr("data-sizes") || a.$slider.attr("data-sizes")),
                                          ((s = document.createElement("img")).onload = function () {
                                              o && (n.attr("srcset", o), r && n.attr("sizes", r)),
                                                  n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
                                                  !0 === a.options.adaptiveHeight && a.setPosition(),
                                                  a.$slider.trigger("lazyLoaded", [a, n, i]),
                                                  a.progressiveLazyLoad();
                                          }),
                                          (s.onerror = function () {
                                              t < 3
                                                  ? setTimeout(function () {
                                                        a.progressiveLazyLoad(t + 1);
                                                    }, 500)
                                                  : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, n, i]), a.progressiveLazyLoad());
                                          }),
                                          (s.src = i))
                                        : a.$slider.trigger("allImagesLoaded", [a]);
                                }),
                                (t.prototype.refresh = function (t) {
                                    var n,
                                        i,
                                        o = this;
                                    (i = o.slideCount - o.options.slidesToShow),
                                        !o.options.infinite && o.currentSlide > i && (o.currentSlide = i),
                                        o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
                                        (n = o.currentSlide),
                                        o.destroy(!0),
                                        e.extend(o, o.initials, { currentSlide: n }),
                                        o.init(),
                                        t || o.changeSlide({ data: { message: "index", index: n } }, !1);
                                }),
                                (t.prototype.registerBreakpoints = function () {
                                    var t,
                                        n,
                                        i,
                                        o = this,
                                        r = o.options.responsive || null;
                                    if ("array" === e.type(r) && r.length) {
                                        for (t in ((o.respondTo = o.options.respondTo || "window"), r))
                                            if (((i = o.breakpoints.length - 1), r.hasOwnProperty(t))) {
                                                for (n = r[t].breakpoint; i >= 0; ) o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
                                                o.breakpoints.push(n), (o.breakpointSettings[n] = r[t].settings);
                                            }
                                        o.breakpoints.sort(function (e, t) {
                                            return o.options.mobileFirst ? e - t : t - e;
                                        });
                                    }
                                }),
                                (t.prototype.reinit = function () {
                                    var t = this;
                                    (t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide")),
                                        (t.slideCount = t.$slides.length),
                                        t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
                                        t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
                                        t.registerBreakpoints(),
                                        t.setProps(),
                                        t.setupInfinite(),
                                        t.buildArrows(),
                                        t.updateArrows(),
                                        t.initArrowEvents(),
                                        t.buildDots(),
                                        t.updateDots(),
                                        t.initDotEvents(),
                                        t.cleanUpSlideEvents(),
                                        t.initSlideEvents(),
                                        t.checkResponsive(!1, !0),
                                        !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                                        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                                        t.setPosition(),
                                        t.focusHandler(),
                                        (t.paused = !t.options.autoplay),
                                        t.autoPlay(),
                                        t.$slider.trigger("reInit", [t]);
                                }),
                                (t.prototype.resize = function () {
                                    var t = this;
                                    e(window).width() !== t.windowWidth &&
                                        (clearTimeout(t.windowDelay),
                                        (t.windowDelay = window.setTimeout(function () {
                                            (t.windowWidth = e(window).width()), t.checkResponsive(), t.unslicked || t.setPosition();
                                        }, 50)));
                                }),
                                (t.prototype.removeSlide = t.prototype.slickRemove = function (e, t, n) {
                                    var i = this;
                                    if (((e = "boolean" == typeof e ? (!0 === (t = e) ? 0 : i.slideCount - 1) : !0 === t ? --e : e), i.slideCount < 1 || e < 0 || e > i.slideCount - 1)) return !1;
                                    i.unload(),
                                        !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(),
                                        (i.$slides = i.$slideTrack.children(this.options.slide)),
                                        i.$slideTrack.children(this.options.slide).detach(),
                                        i.$slideTrack.append(i.$slides),
                                        (i.$slidesCache = i.$slides),
                                        i.reinit();
                                }),
                                (t.prototype.setCSS = function (e) {
                                    var t,
                                        n,
                                        i = this,
                                        o = {};
                                    !0 === i.options.rtl && (e = -e),
                                        (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                                        (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                                        (o[i.positionProp] = e),
                                        !1 === i.transformsEnabled
                                            ? i.$slideTrack.css(o)
                                            : ((o = {}),
                                              !1 === i.cssTransitions ? ((o[i.animType] = "translate(" + t + ", " + n + ")"), i.$slideTrack.css(o)) : ((o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"), i.$slideTrack.css(o)));
                                }),
                                (t.prototype.setDimensions = function () {
                                    var e = this;
                                    !1 === e.options.vertical
                                        ? !0 === e.options.centerMode && e.$list.css({ padding: "0px " + e.options.centerPadding })
                                        : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({ padding: e.options.centerPadding + " 0px" })),
                                        (e.listWidth = e.$list.width()),
                                        (e.listHeight = e.$list.height()),
                                        !1 === e.options.vertical && !1 === e.options.variableWidth
                                            ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length)))
                                            : !0 === e.options.variableWidth
                                            ? e.$slideTrack.width(5e3 * e.slideCount)
                                            : ((e.slideWidth = Math.ceil(e.listWidth)), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
                                    var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                                    !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
                                }),
                                (t.prototype.setFade = function () {
                                    var t,
                                        n = this;
                                    n.$slides.each(function (i, o) {
                                        (t = n.slideWidth * i * -1),
                                            !0 === n.options.rtl
                                                ? e(o).css({ position: "relative", right: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 })
                                                : e(o).css({ position: "relative", left: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 });
                                    }),
                                        n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
                                }),
                                (t.prototype.setHeight = function () {
                                    var e = this;
                                    if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                                        var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                                        e.$list.css("height", t);
                                    }
                                }),
                                (t.prototype.setOption = t.prototype.slickSetOption = function () {
                                    var t,
                                        n,
                                        i,
                                        o,
                                        r,
                                        s = this,
                                        a = !1;
                                    if (
                                        ("object" === e.type(arguments[0])
                                            ? ((i = arguments[0]), (a = arguments[1]), (r = "multiple"))
                                            : "string" === e.type(arguments[0]) &&
                                              ((i = arguments[0]), (o = arguments[1]), (a = arguments[2]), "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? (r = "responsive") : void 0 !== arguments[1] && (r = "single")),
                                        "single" === r)
                                    )
                                        s.options[i] = o;
                                    else if ("multiple" === r)
                                        e.each(i, function (e, t) {
                                            s.options[e] = t;
                                        });
                                    else if ("responsive" === r)
                                        for (n in o)
                                            if ("array" !== e.type(s.options.responsive)) s.options.responsive = [o[n]];
                                            else {
                                                for (t = s.options.responsive.length - 1; t >= 0; ) s.options.responsive[t].breakpoint === o[n].breakpoint && s.options.responsive.splice(t, 1), t--;
                                                s.options.responsive.push(o[n]);
                                            }
                                    a && (s.unload(), s.reinit());
                                }),
                                (t.prototype.setPosition = function () {
                                    var e = this;
                                    e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
                                }),
                                (t.prototype.setProps = function () {
                                    var e = this,
                                        t = document.body.style;
                                    (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
                                        "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                                        (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) || (!0 === e.options.useCSS && (e.cssTransitions = !0)),
                                        e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
                                        void 0 !== t.OTransform &&
                                            ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                                        void 0 !== t.MozTransform &&
                                            ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                                        void 0 !== t.webkitTransform &&
                                            ((e.animType = "webkitTransform"),
                                            (e.transformType = "-webkit-transform"),
                                            (e.transitionType = "webkitTransition"),
                                            void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                                        void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
                                        void 0 !== t.transform && !1 !== e.animType && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                                        (e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType);
                                }),
                                (t.prototype.setSlideClasses = function (e) {
                                    var t,
                                        n,
                                        i,
                                        o,
                                        r = this;
                                    if (((n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")), r.$slides.eq(e).addClass("slick-current"), !0 === r.options.centerMode)) {
                                        var s = r.options.slidesToShow % 2 == 0 ? 1 : 0;
                                        (t = Math.floor(r.options.slidesToShow / 2)),
                                            !0 === r.options.infinite &&
                                                (e >= t && e <= r.slideCount - 1 - t
                                                    ? r.$slides
                                                          .slice(e - t + s, e + t + 1)
                                                          .addClass("slick-active")
                                                          .attr("aria-hidden", "false")
                                                    : ((i = r.options.slidesToShow + e),
                                                      n
                                                          .slice(i - t + 1 + s, i + t + 2)
                                                          .addClass("slick-active")
                                                          .attr("aria-hidden", "false")),
                                                0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")),
                                            r.$slides.eq(e).addClass("slick-center");
                                    } else
                                        e >= 0 && e <= r.slideCount - r.options.slidesToShow
                                            ? r.$slides
                                                  .slice(e, e + r.options.slidesToShow)
                                                  .addClass("slick-active")
                                                  .attr("aria-hidden", "false")
                                            : n.length <= r.options.slidesToShow
                                            ? n.addClass("slick-active").attr("aria-hidden", "false")
                                            : ((o = r.slideCount % r.options.slidesToShow),
                                              (i = !0 === r.options.infinite ? r.options.slidesToShow + e : e),
                                              r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow
                                                  ? n
                                                        .slice(i - (r.options.slidesToShow - o), i + o)
                                                        .addClass("slick-active")
                                                        .attr("aria-hidden", "false")
                                                  : n
                                                        .slice(i, i + r.options.slidesToShow)
                                                        .addClass("slick-active")
                                                        .attr("aria-hidden", "false"));
                                    ("ondemand" !== r.options.lazyLoad && "anticipated" !== r.options.lazyLoad) || r.lazyLoad();
                                }),
                                (t.prototype.setupInfinite = function () {
                                    var t,
                                        n,
                                        i,
                                        o = this;
                                    if ((!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && ((n = null), o.slideCount > o.options.slidesToShow))) {
                                        for (i = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; t -= 1)
                                            (n = t - 1),
                                                e(o.$slides[n])
                                                    .clone(!0)
                                                    .attr("id", "")
                                                    .attr("data-slick-index", n - o.slideCount)
                                                    .prependTo(o.$slideTrack)
                                                    .addClass("slick-cloned");
                                        for (t = 0; t < i + o.slideCount; t += 1)
                                            (n = t),
                                                e(o.$slides[n])
                                                    .clone(!0)
                                                    .attr("id", "")
                                                    .attr("data-slick-index", n + o.slideCount)
                                                    .appendTo(o.$slideTrack)
                                                    .addClass("slick-cloned");
                                        o.$slideTrack
                                            .find(".slick-cloned")
                                            .find("[id]")
                                            .each(function () {
                                                e(this).attr("id", "");
                                            });
                                    }
                                }),
                                (t.prototype.interrupt = function (e) {
                                    e || this.autoPlay(), (this.interrupted = e);
                                }),
                                (t.prototype.selectHandler = function (t) {
                                    var n = this,
                                        i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
                                        o = parseInt(i.attr("data-slick-index"));
                                    o || (o = 0), n.slideCount <= n.options.slidesToShow ? n.slideHandler(o, !1, !0) : n.slideHandler(o);
                                }),
                                (t.prototype.slideHandler = function (e, t, n) {
                                    var i,
                                        o,
                                        r,
                                        s,
                                        a,
                                        l,
                                        c = this;
                                    if (((t = t || !1), !((!0 === c.animating && !0 === c.options.waitForAnimate) || (!0 === c.options.fade && c.currentSlide === e))))
                                        if (
                                            (!1 === t && c.asNavFor(e),
                                            (i = e),
                                            (a = c.getLeft(i)),
                                            (s = c.getLeft(c.currentSlide)),
                                            (c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft),
                                            !1 === c.options.infinite && !1 === c.options.centerMode && (e < 0 || e > c.getDotCount() * c.options.slidesToScroll))
                                        )
                                            !1 === c.options.fade &&
                                                ((i = c.currentSlide),
                                                !0 !== n && c.slideCount > c.options.slidesToShow
                                                    ? c.animateSlide(s, function () {
                                                          c.postSlide(i);
                                                      })
                                                    : c.postSlide(i));
                                        else if (!1 === c.options.infinite && !0 === c.options.centerMode && (e < 0 || e > c.slideCount - c.options.slidesToScroll))
                                            !1 === c.options.fade &&
                                                ((i = c.currentSlide),
                                                !0 !== n && c.slideCount > c.options.slidesToShow
                                                    ? c.animateSlide(s, function () {
                                                          c.postSlide(i);
                                                      })
                                                    : c.postSlide(i));
                                        else {
                                            if (
                                                (c.options.autoplay && clearInterval(c.autoPlayTimer),
                                                (o =
                                                    i < 0
                                                        ? c.slideCount % c.options.slidesToScroll != 0
                                                            ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                                                            : c.slideCount + i
                                                        : i >= c.slideCount
                                                        ? c.slideCount % c.options.slidesToScroll != 0
                                                            ? 0
                                                            : i - c.slideCount
                                                        : i),
                                                (c.animating = !0),
                                                c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                                                (r = c.currentSlide),
                                                (c.currentSlide = o),
                                                c.setSlideClasses(c.currentSlide),
                                                c.options.asNavFor && (l = (l = c.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(c.currentSlide),
                                                c.updateDots(),
                                                c.updateArrows(),
                                                !0 === c.options.fade)
                                            )
                                                return (
                                                    !0 !== n
                                                        ? (c.fadeSlideOut(r),
                                                          c.fadeSlide(o, function () {
                                                              c.postSlide(o);
                                                          }))
                                                        : c.postSlide(o),
                                                    void c.animateHeight()
                                                );
                                            !0 !== n && c.slideCount > c.options.slidesToShow
                                                ? c.animateSlide(a, function () {
                                                      c.postSlide(o);
                                                  })
                                                : c.postSlide(o);
                                        }
                                }),
                                (t.prototype.startLoad = function () {
                                    var e = this;
                                    !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                                        !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                                        e.$slider.addClass("slick-loading");
                                }),
                                (t.prototype.swipeDirection = function () {
                                    var e,
                                        t,
                                        n,
                                        i,
                                        o = this;
                                    return (
                                        (e = o.touchObject.startX - o.touchObject.curX),
                                        (t = o.touchObject.startY - o.touchObject.curY),
                                        (n = Math.atan2(t, e)),
                                        (i = Math.round((180 * n) / Math.PI)) < 0 && (i = 360 - Math.abs(i)),
                                        (i <= 45 && i >= 0) || (i <= 360 && i >= 315)
                                            ? !1 === o.options.rtl
                                                ? "left"
                                                : "right"
                                            : i >= 135 && i <= 225
                                            ? !1 === o.options.rtl
                                                ? "right"
                                                : "left"
                                            : !0 === o.options.verticalSwiping
                                            ? i >= 35 && i <= 135
                                                ? "down"
                                                : "up"
                                            : "vertical"
                                    );
                                }),
                                (t.prototype.swipeEnd = function (e) {
                                    var t,
                                        n,
                                        i = this;
                                    if (((i.dragging = !1), (i.swiping = !1), i.scrolling)) return (i.scrolling = !1), !1;
                                    if (((i.interrupted = !1), (i.shouldClick = !(i.touchObject.swipeLength > 10)), void 0 === i.touchObject.curX)) return !1;
                                    if ((!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe)) {
                                        switch ((n = i.swipeDirection())) {
                                            case "left":
                                            case "down":
                                                (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount()), (i.currentDirection = 0);
                                                break;
                                            case "right":
                                            case "up":
                                                (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount()), (i.currentDirection = 1);
                                        }
                                        "vertical" != n && (i.slideHandler(t), (i.touchObject = {}), i.$slider.trigger("swipe", [i, n]));
                                    } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), (i.touchObject = {}));
                                }),
                                (t.prototype.swipeHandler = function (e) {
                                    var t = this;
                                    if (!(!1 === t.options.swipe || ("ontouchend" in document && !1 === t.options.swipe) || (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))))
                                        switch (
                                            ((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1),
                                            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
                                            !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
                                            e.data.action)
                                        ) {
                                            case "start":
                                                t.swipeStart(e);
                                                break;
                                            case "move":
                                                t.swipeMove(e);
                                                break;
                                            case "end":
                                                t.swipeEnd(e);
                                        }
                                }),
                                (t.prototype.swipeMove = function (e) {
                                    var t,
                                        n,
                                        i,
                                        o,
                                        r,
                                        s,
                                        a = this;
                                    return (
                                        (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
                                        !(!a.dragging || a.scrolling || (r && 1 !== r.length)) &&
                                            ((t = a.getLeft(a.currentSlide)),
                                            (a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
                                            (a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
                                            (a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2)))),
                                            (s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2)))),
                                            !a.options.verticalSwiping && !a.swiping && s > 4
                                                ? ((a.scrolling = !0), !1)
                                                : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s),
                                                  (n = a.swipeDirection()),
                                                  void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && ((a.swiping = !0), e.preventDefault()),
                                                  (o = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
                                                  !0 === a.options.verticalSwiping && (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
                                                  (i = a.touchObject.swipeLength),
                                                  (a.touchObject.edgeHit = !1),
                                                  !1 === a.options.infinite &&
                                                      ((0 === a.currentSlide && "right" === n) || (a.currentSlide >= a.getDotCount() && "left" === n)) &&
                                                      ((i = a.touchObject.swipeLength * a.options.edgeFriction), (a.touchObject.edgeHit = !0)),
                                                  !1 === a.options.vertical ? (a.swipeLeft = t + i * o) : (a.swipeLeft = t + i * (a.$list.height() / a.listWidth) * o),
                                                  !0 === a.options.verticalSwiping && (a.swipeLeft = t + i * o),
                                                  !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? ((a.swipeLeft = null), !1) : void a.setCSS(a.swipeLeft))))
                                    );
                                }),
                                (t.prototype.swipeStart = function (e) {
                                    var t,
                                        n = this;
                                    if (((n.interrupted = !0), 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow)) return (n.touchObject = {}), !1;
                                    void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                                        (n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                                        (n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                                        (n.dragging = !0);
                                }),
                                (t.prototype.unfilterSlides = t.prototype.slickUnfilter = function () {
                                    var e = this;
                                    null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
                                }),
                                (t.prototype.unload = function () {
                                    var t = this;
                                    e(".slick-cloned", t.$slider).remove(),
                                        t.$dots && t.$dots.remove(),
                                        t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
                                        t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
                                        t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
                                }),
                                (t.prototype.unslick = function (e) {
                                    var t = this;
                                    t.$slider.trigger("unslick", [t, e]), t.destroy();
                                }),
                                (t.prototype.updateArrows = function () {
                                    var e = this;
                                    Math.floor(e.options.slidesToShow / 2),
                                        !0 === e.options.arrows &&
                                            e.slideCount > e.options.slidesToShow &&
                                            !e.options.infinite &&
                                            (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                            e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                            0 === e.currentSlide
                                                ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                                                : ((e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode) || (e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode)) &&
                                                  (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
                                }),
                                (t.prototype.updateDots = function () {
                                    var e = this;
                                    null !== e.$dots &&
                                        (e.$dots.find("li").removeClass("slick-active").end(),
                                        e.$dots
                                            .find("li")
                                            .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
                                            .addClass("slick-active"));
                                }),
                                (t.prototype.visibility = function () {
                                    var e = this;
                                    e.options.autoplay && (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
                                }),
                                (e.fn.slick = function () {
                                    var e,
                                        n,
                                        i = this,
                                        o = arguments[0],
                                        r = Array.prototype.slice.call(arguments, 1),
                                        s = i.length;
                                    for (e = 0; e < s; e++) if (("object" == typeof o || void 0 === o ? (i[e].slick = new t(i[e], o)) : (n = i[e].slick[o].apply(i[e].slick, r)), void 0 !== n)) return n;
                                    return i;
                                });
                            var n;
                        })
                            ? i.apply(t, o)
                            : i) || (e.exports = r);
        })();
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), (t.updateCart = t.addFormToCart = t.addToCart = t.getCart = void 0);
        var i = r(n(6)),
            o = r(n(5));
        function r(e) {
            return e && e.__esModule ? e : { default: e };
        }
        var s = function () {
            return (0, i.default)("/cart.json", { credentials: "same-origin" })
                .then(function (e) {
                    if (!e.ok) throw Error(e.statusText);
                    return e.json();
                })
                .catch(function (e) {
                    console.error(e);
                });
        };
        (t.getCart = s),
            (t.addToCart = function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                return (0, i.default)("/cart/add.json", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: e, quantity: t, properties: n }) })
                    .then(function (e) {
                        if (!e.ok) throw Error(e.statusText);
                        return s();
                    })
                    .catch(function (e) {
                        console.error(e);
                    });
            }),
            (t.addFormToCart = function (e) {
                var t = (0, o.default)(e, { hash: !0 });
                return (0, i.default)("/cart/add.json", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) })
                    .then(function (e) {
                        if (!e.ok) throw Error(e.statusText);
                        return s();
                    })
                    .catch(function (e) {
                        console.error(e);
                    });
            }),
            (t.updateCart = function (e, t) {
                return (0, i.default)("/cart/change.json", { method: "POST", credentials: "same-origin", body: JSON.stringify({ line: e, quantity: t }), headers: { "Content-Type": "application/json" } })
                    .then(function (e) {
                        if (!e.ok) throw Error(e.statusText);
                        return s();
                    })
                    .catch(function (e) {
                        console.error(e);
                    });
            });
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), (t.hideDrawer = t.showDrawer = t.updateDrawer = t.drawer = void 0);
        var i = function (e, t) {
                if (Array.isArray(e)) return e;
                if (Symbol.iterator in Object(e))
                    return (function (e, t) {
                        var n = [],
                            i = !0,
                            o = !1,
                            r = void 0;
                        try {
                            for (var s, a = e[Symbol.iterator](); !(i = (s = a.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0);
                        } catch (e) {
                            (o = !0), (r = e);
                        } finally {
                            try {
                                !i && a.return && a.return();
                            } finally {
                                if (o) throw r;
                            }
                        }
                        return n;
                    })(e, t);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            },
            o = n(3),
            r = n(7),
            s = n(1),
            a = document.querySelector(".js-ajax-cart"),
            l = document.querySelector(".js-ajax-cart-backdrop"),
            c = function (e) {
                var t = e.item_count,
                    n = !0,
                    i = !1,
                    o = void 0;
                try {
                    for (var r, s = document.querySelectorAll(".js-ajax-cart-count")[Symbol.iterator](); !(n = (r = s.next()).done); n = !0) {
                        r.value.innerHTML = t;
                    }
                } catch (e) {
                    (i = !0), (o = e);
                } finally {
                    try {
                        !n && s.return && s.return();
                    } finally {
                        if (i) throw o;
                    }
                }
                var a = !0,
                    l = !1,
                    c = void 0;
                try {
                    for (var d, u = document.querySelectorAll(".js-ajax-cart-items-text")[Symbol.iterator](); !(a = (d = u.next()).done); a = !0) {
                        var p = d.value;
                        p.innerHTML = 1 === t ? "Item" : "Items";
                    }
                } catch (e) {
                    (l = !0), (c = e);
                } finally {
                    try {
                        !a && u.return && u.return();
                    } finally {
                        if (l) throw c;
                    }
                }
            },
            d = function (e) {
                var t = e.currency,
                    n = e.total_price,
                    i = !0,
                    o = !1,
                    r = void 0;
                try {
                    for (var a, l = document.querySelectorAll(".js-ajax-cart-subtotal")[Symbol.iterator](); !(i = (a = l.next()).done); i = !0) {
                        a.value.innerHTML = (0, s.formatMoney)(n, t);
                    }
                } catch (e) {
                    (o = !0), (r = e);
                } finally {
                    try {
                        !i && l.return && l.return();
                    } finally {
                        if (o) throw r;
                    }
                }
            },
            u = function (e) {
                var t = e.currency,
                    n = e.items,
                    o = e.item_count,
                    s = a.querySelector(".js-ajax-cart-empty"),
                    l = a.querySelector(".js-ajax-cart-full"),
                    u = a.querySelector(".js-ajax-cart-items");
                if ((c(e), d(e), 0 === o)) return s.classList.remove("hide"), l.classList.add("hide"), void (u.innerHTML = "");
                for (; u.hasChildNodes(); ) u.removeChild(u.firstChild);
                s.classList.add("hide"), l.classList.remove("hide");
                var p = !0,
                    f = !1,
                    h = void 0;
                try {
                    for (var v, y = n.entries()[Symbol.iterator](); !(p = (v = y.next()).done); p = !0) {
                        var g = v.value,
                            m = i(g, 2),
                            b = m[0],
                            w = m[1],
                            x = w.url,
                            T = w.product_title,
                            S = w.variant_title,
                            k = w.quantity,
                            C = w.image,
                            A = w.price;
                        C = C.replace(".jpg", "_150x.jpg");
                        var j = document.createElement("template");
                        (j.innerHTML = (0, r.cartItem)(b + 1, x, T, S, k, C, A, t)), u.appendChild(j.content.firstChild);
                    }
                } catch (e) {
                    (f = !0), (h = e);
                } finally {
                    try {
                        !p && y.return && y.return();
                    } finally {
                        if (f) throw h;
                    }
                }
            },
            p = function () {
                (a.style.zIndex = "2147483647"), a.classList.remove("is-closed"), l.classList.remove("is-closed"), document.body.classList.add("overflow-y-hidden");
            };
        function f() {
            (a.style.zIndex = "0"), l.classList.add("is-closed"), a.classList.add("is-closed"), document.body.classList.remove("overflow-y-hidden");
            var e = !0,
                t = !1,
                n = void 0;
            try {
                for (var i, o = document.querySelectorAll('[data-behavior="show-cart"]')[Symbol.iterator](); !(e = (i = o.next()).done); e = !0) {
                    i.value.setAttribute("aria-expanded", "false");
                }
            } catch (e) {
                (t = !0), (n = e);
            } finally {
                try {
                    !e && o.return && o.return();
                } finally {
                    if (t) throw n;
                }
            }
        }
        var h = void 0;
        a &&
            (a.addEventListener("change", function (e) {
                if ("update-line" === e.target.getAttribute("data-behavior") && e.target.closest("[data-cart-line]") && e.target.value) {
                    e.preventDefault();
                    var t = e;
                    window.clearTimeout(h),
                        (h = window.setTimeout(function () {
                            var e = t.target.closest("[data-cart-line]").getAttribute("data-cart-line");
                            (0, o.updateCart)(e, t.target.value)
                                .then(function (e) {
                                    "/cart" !== window.location.pathname ? (c(e), d(e)) : window.location.reload();
                                })
                                .catch(function (e) {
                                    console.error(e);
                                });
                        }, 500));
                }
            }),
            a.addEventListener("click", function (e) {
                if (e.target.closest('[data-behavior="remove-line"]') && e.target.closest("[data-cart-line]")) {
                    e.preventDefault();
                    var t = e.target.closest("[data-cart-line]"),
                        n = e.target.closest("[data-cart-line]").getAttribute("data-cart-line");
                    (0, o.updateCart)(n, 0)
                        .then(function (e) {
                            "/cart" !== window.location.pathname
                                ? (t.classList.add("animate-slide-up"),
                                  setTimeout(function () {
                                      u(e);
                                  }, 800))
                                : window.location.reload();
                        })
                        .catch(function (e) {
                            console.error(e);
                        });
                }
            }),
            document.addEventListener("click", function (e) {
                var t = e.target.getAttribute("aria-expanded"),
                    n = e.target;
                n.hasAttribute("data-behavior") && "show-cart" == n.getAttribute("data-behavior") && ("false" == t && (n.setAttribute("aria-expanded", "true"), p()), "true" == t && (n.setAttribute("aria-expanded", "false"), f())),
                    n.hasAttribute("data-behavior") && "hide-cart" == n.getAttribute("data-behavior") && f();
            }),
            (0, o.getCart)()
                .then(function (e) {
                    u(e);
                })
                .catch(function (e) {
                    console.error(e);
                })),
            (t.drawer = a),
            (t.updateDrawer = u),
            (t.showDrawer = p),
            (t.hideDrawer = f);
    },
    function (e, t) {
        var n = /^(?:submit|button|image|reset|file)$/i,
            i = /^(?:input|select|textarea|keygen)/i,
            o = /(\[[^\[\]]*\])/g;
        function r(e, t, n) {
            if (t.match(o)) {
                !(function e(t, n, i) {
                    if (0 === n.length) return (t = i);
                    var o = n.shift(),
                        r = o.match(/^\[(.+?)\]$/);
                    if ("[]" === o) return (t = t || []), Array.isArray(t) ? t.push(e(null, n, i)) : ((t._values = t._values || []), t._values.push(e(null, n, i))), t;
                    if (r) {
                        var s = r[1],
                            a = +s;
                        isNaN(a) ? ((t = t || {})[s] = e(t[s], n, i)) : ((t = t || [])[a] = e(t[a], n, i));
                    } else t[o] = e(t[o], n, i);
                    return t;
                })(
                    e,
                    (function (e) {
                        var t = [],
                            n = new RegExp(o),
                            i = /^([^\[\]]*)/.exec(e);
                        for (i[1] && t.push(i[1]); null !== (i = n.exec(e)); ) t.push(i[1]);
                        return t;
                    })(t),
                    n
                );
            } else {
                var i = e[t];
                i ? (Array.isArray(i) || (e[t] = [i]), e[t].push(n)) : (e[t] = n);
            }
            return e;
        }
        function s(e, t, n) {
            return (n = n.replace(/(\r)?\n/g, "\r\n")), (n = (n = encodeURIComponent(n)).replace(/%20/g, "+")), e + (e ? "&" : "") + encodeURIComponent(t) + "=" + n;
        }
        e.exports = function (e, t) {
            "object" != typeof t ? (t = { hash: !!t }) : void 0 === t.hash && (t.hash = !0);
            for (var o = t.hash ? {} : "", a = t.serializer || (t.hash ? r : s), l = e && e.elements ? e.elements : [], c = Object.create(null), d = 0; d < l.length; ++d) {
                var u = l[d];
                if ((t.disabled || !u.disabled) && u.name && i.test(u.nodeName) && !n.test(u.type)) {
                    var p = u.name,
                        f = u.value;
                    if ((("checkbox" !== u.type && "radio" !== u.type) || u.checked || (f = void 0), t.empty)) {
                        if (("checkbox" !== u.type || u.checked || (f = ""), "radio" === u.type && (c[u.name] || u.checked ? u.checked && (c[u.name] = !0) : (c[u.name] = !1)), null == f && "radio" == u.type)) continue;
                    } else if (!f) continue;
                    if ("select-multiple" !== u.type) o = a(o, p, f);
                    else {
                        f = [];
                        for (var h = u.options, v = !1, y = 0; y < h.length; ++y) {
                            var g = h[y],
                                m = t.empty && !g.value,
                                b = g.value || m;
                            g.selected && b && ((v = !0), (o = t.hash && "[]" !== p.slice(p.length - 2) ? a(o, p + "[]", g.value) : a(o, p, g.value)));
                        }
                        !v && t.empty && (o = a(o, p, ""));
                    }
                }
            }
            if (t.empty) for (var p in c) c[p] || (o = a(o, p, ""));
            return o;
        };
    },
    function (e, t, n) {
        "use strict";
        n.r(t);
        var i =
            "function" == typeof fetch
                ? fetch.bind()
                : function (e, t) {
                      return (
                          (t = t || {}),
                          new Promise(function (n, i) {
                              var o = new XMLHttpRequest();
                              for (var r in (o.open(t.method || "get", e, !0), t.headers)) o.setRequestHeader(r, t.headers[r]);
                              function s() {
                                  var e,
                                      t = [],
                                      n = [],
                                      i = {};
                                  return (
                                      o.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (o, r, s) {
                                          t.push((r = r.toLowerCase())), n.push([r, s]), (e = i[r]), (i[r] = e ? e + "," + s : s);
                                      }),
                                      {
                                          ok: 2 == ((o.status / 100) | 0),
                                          status: o.status,
                                          statusText: o.statusText,
                                          url: o.responseURL,
                                          clone: s,
                                          text: function () {
                                              return Promise.resolve(o.responseText);
                                          },
                                          json: function () {
                                              return Promise.resolve(o.responseText).then(JSON.parse);
                                          },
                                          blob: function () {
                                              return Promise.resolve(new Blob([o.response]));
                                          },
                                          headers: {
                                              keys: function () {
                                                  return t;
                                              },
                                              entries: function () {
                                                  return n;
                                              },
                                              get: function (e) {
                                                  return i[e.toLowerCase()];
                                              },
                                              has: function (e) {
                                                  return e.toLowerCase() in i;
                                              },
                                          },
                                      }
                                  );
                              }
                              (o.withCredentials = "include" == t.credentials),
                                  (o.onload = function () {
                                      n(s());
                                  }),
                                  (o.onerror = i),
                                  o.send(t.body || null);
                          })
                      );
                  };
        t.default = i;
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), (t.youtubeModal = t.cartItem = void 0);
        var i = n(1),
            o = function () {
                return '\n  <svg class="svg-close" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n    <title>Close</title>\n    <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/>\n  </svg>\n  '.trim();
            },
            r = function () {
                return '\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">\n    <title>minus</title>\n    <path d="M436 284c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h424z"/>\n  </svg>\n  '.trim();
            },
            s = function () {
                return '\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">\n    <title>plus</title>\n    <path d="M436 228H252V44c0-6.6-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12v184H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h184v184c0 6.6 5.4 12 12 12h32c6.6 0 12-5.4 12-12V284h184c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12z"/>\n  </svg>\n  '.trim();
            };
        (t.cartItem = function (e, t, n, a, l, c, d) {
            var u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "USD";
            return (
                '\n  <div class="ajax-cart-item relative flex padding-vertical-5 padding-left-3 padding-right-5" data-cart-line="' +
                e +
                '">\n\n    <a href="' +
                t +
                '" class="block margin-right-3">\n      <span class="invisible">' +
                n +
                ' Product Page</span>\n      <img src="' +
                c +
                '" class="cart-item-image fit-cover block width-100" alt="' +
                n +
                ' Product Image"/>\n    </a>\n\n    <div class="flex-item-1 margin-right-2">\n      <div class="height-100 flex flex-column justify-between">\n\n        <div>\n          <a href="' +
                t +
                '" class="ajax-cart-item-title block margin-vertical-0 link font-size-2">' +
                n +
                "</a>\n          " +
                (null === a ? "" : '<p class="margin-vertical-0 font-size-1 text-grey">' + a + "</p>") +
                '\n        </div>\n\n        <div class="js-number-input number-input margin-top-2">\n          <label for="cart_quantity_' +
                e +
                '" class="invisible">Item Quantity</label>\n          <button type="button" data-behavior="decrement">' +
                r() +
                '</button>\n          <input type="number" id="cart_quantity_' +
                e +
                '" name="cart_quantity_' +
                e +
                '" value="' +
                l +
                '" min="1" max="999" data-behavior="update-line" />\n          <button type="button" data-behavior="increment">' +
                s() +
                '</button>\n        </div>\n\n      </div>\n    </div>\n\n    <div class="flex flex-column justify-between items-end">\n      <button class="ajax-cart-item-remove-button button-reset" data-behavior="remove-line">\n        <span class="invisible">Remove Item</span>\n        ' +
                o() +
                '\n      </button>\n\n      <span class="font-size-2 font-weight-3">' +
                (0, i.formatMoney)(d, u) +
                "</span>\n    </div>\n  </div>\n  "
            ).trim();
        }),
            (t.youtubeModal = function (e) {
                return (
                    '\n  <div id="modal-video-' +
                    e +
                    '" class="modal is-closed" data-modal data-youtube-id="' +
                    e +
                    '">\n    <div class="modal-backdrop hide large--block" data-behavior="close-modal"></div>\n\n    <div class="modal-wrapper">\n        <div class="modal-container">\n          <div class="modal-content">\n            <button class="modal-close hide large--block" data-behavior="close-modal">\n              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">\n                <title>\n                  Close\n                </title>\n                <path d="M231.6 256l130.1-130.1c4.7-4.7 4.7-12.3 0-17l-22.6-22.6c-4.7-4.7-12.3-4.7-17 0L192 216.4 61.9 86.3c-4.7-4.7-12.3-4.7-17 0l-22.6 22.6c-4.7 4.7-4.7 12.3 0 17L152.4 256 22.3 386.1c-4.7 4.7-4.7 12.3 0 17l22.6 22.6c4.7 4.7 12.3 4.7 17 0L192 295.6l130.1 130.1c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17L231.6 256z"/>\n              </svg>\n            </button>\n\n            <div class="flex flex-column height-100 large--block">\n              <div class="flex items-center padding-horizontal-3 padding-vertical-2 background-smoke small--padding-horizontal-4 large--hide">\n                <button class="button-reset margin-right-2 font-size-8 large--hide" data-behavior="close-modal">\n                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">\n                    <title>\n                      Close\n                    </title>\n                    <path d="M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"/>\n                  </svg>\n                </button>\n\n                <p class="inline-block margin-vertical-0 font-size-7 font-weight-3 line-height-solid large--font-size-8 large--font-weight-7 large--line-height-title">\n                  Video\n                </p>\n              </div>\n\n              <div class="flex-item-1 flex background-black">\n                <div id="youtube-player-' +
                    e +
                    '" class="width-100 margin-auto"></div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n  </div>\n  '
                ).trim();
            });
    },
    function (e, t, n) {
        var i = n(27),
            o = n(9);
        e.exports = function (e, t, n) {
            var r = !0,
                s = !0;
            if ("function" != typeof e) throw new TypeError("Expected a function");
            return o(n) && ((r = "leading" in n ? !!n.leading : r), (s = "trailing" in n ? !!n.trailing : s)), i(e, t, { leading: r, maxWait: t, trailing: s });
        };
    },
    function (e, t) {
        e.exports = function (e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
        };
    },
    function (e, t, n) {
        "use strict";
        var i,
            o,
            r,
            s,
            a,
            l,
            c,
            d = n(0),
            u = (i = d) && i.__esModule ? i : { default: i };
        n(2),
            document.querySelector(".js-product-related") &&
                ((o = ".js-product-related"),
                (r = function () {
                    function e() {
                        (0, u.default)(".js-product-related").each(function () {
                            var e = (0, u.default)(this);
                            (0, u.default)(window).width() > 1023
                                ? e.hasClass("slick-initialized") && e.slick("unslick")
                                : e.not(".slick-initialized").slick({ dots: !1, arrows: !1, infinite: !1, centerMode: !0, speed: 500, mobileFirst: !0 });
                        });
                    }
                    e(), (0, u.default)(window).on("load resize orientationchange", e);
                }),
                (s = { rootMargin: "10px", threshold: 0.5 }),
                (a = !1),
                (l = new IntersectionObserver(function (e) {
                    e.forEach(function (e) {
                        !a && e.isIntersecting && (r(), (a = !0));
                    }, s);
                })),
                (c = document.querySelector(o)),
                l.observe(c));
    },
    function (e, t, n) {
        "use strict";
        var i,
            o = n(0),
            r = (i = o) && i.__esModule ? i : { default: i };
        (0, r.default)(".tab_content").hide(),
            (0, r.default)(".tab_content:first").show(),
            (0, r.default)("ul.tabs li").click(function () {
                (0, r.default)(".tab_content").hide();
                var e = (0, r.default)(this).attr("rel");
                (0, r.default)("#" + e).fadeIn(),
                    (0, r.default)("ul.tabs li").removeClass("active"),
                    (0, r.default)(this).addClass("active"),
                    (0, r.default)(".tab_drawer_heading").removeClass("d_active"),
                    (0, r.default)(".tab_drawer_heading[rel^='" + e + "']").addClass("d_active");
            }),
            (0, r.default)(".tab_drawer_heading").click(function () {
                if ((0, r.default)(this).hasClass("d_active")) (0, r.default)(".tab_content").hide(), (0, r.default)(".tab_drawer_heading").removeClass("d_active");
                else {
                    (0, r.default)(".tab_content").hide();
                    var e = (0, r.default)(this).attr("rel");
                    (0, r.default)("#" + e).fadeIn(),
                        (0, r.default)(".tab_drawer_heading").removeClass("d_active"),
                        (0, r.default)(this).addClass("d_active"),
                        (0, r.default)("ul.tabs li").removeClass("active"),
                        (0, r.default)("ul.tabs li[rel^='" + e + "']").addClass("active");
                }
            }),
            (0, r.default)("ul.tabs li").last().addClass("tab_last"),
            document.addEventListener("click", function (e) {
                if (e.target.closest('[data-behavior="toggle-filters"]'))
                    if (document.querySelector(".blog-filter").classList.contains("hide")) for (var t = document.getElementsByClassName("blog-filter"), n = 0; n < t.length; n++) t.item(n).classList.remove("hide");
                    else for (t = document.getElementsByClassName("blog-filter"), n = 0; n < t.length; n++) t.item(n).classList.add("hide");
            });
        var s = function () {
            var e = document.getElementById("trustspot-widget-wrapper").offsetTop - document.getElementById("shopify-section-header").offsetHeight - 30;
            (0, r.default)([document.documentElement, document.body]).animate({ scrollTop: e }, 1500);
        };
        "#reviews" === window.location.hash && s(),
            document.addEventListener("click", function (e) {
                e.target.closest('[data-behavior="jump-to-reviews"]') && (e.preventDefault(), s());
            });
    },
    function (e, t, n) {
        "use strict";
        n(13), n(14), n(17);
    },
    function (e, t, n) {
        "use strict";
        var i,
            o =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (e) {
                          return typeof e;
                      }
                    : function (e) {
                          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                      },
            r = n(5),
            s = (i = r) && i.__esModule ? i : { default: i },
            a = n(3),
            l = n(4);
        document.addEventListener("submit", function (e) {
            if (e.target.closest('[data-behavior="ajax-cart-form"]')) {
                e.preventDefault();
                var t = e.target.closest('[data-behavior="ajax-cart-form"]'),
                    n = t.querySelector('button[type="submit"]'),
                    i = n.innerHTML;
                (n.disabled = !0), (n.innerHTML = "Adding...");
                var r = [];
                r.push((0, s.default)(t, { hash: !0 }));
                var c = !0,
                    d = !1,
                    u = void 0;
                try {
                    for (var p, f = document.querySelectorAll(".js-product-addon[data-selected]")[Symbol.iterator](); !(c = (p = f.next()).done); c = !0) {
                        var h = p.value.getAttribute("data-addon-id");
                        r.push({ id: h, quantity: 1 });
                    }
                } catch (e) {
                    (d = !0), (u = e);
                } finally {
                    try {
                        !c && f.return && f.return();
                    } finally {
                        if (d) throw u;
                    }
                }
                var v,
                    y = !0,
                    g = !1,
                    m = void 0;
                try {
                    for (var b, w = r[Symbol.iterator](); !(y = (b = w.next()).done); y = !0) {
                        (h = b.value).hasOwnProperty("event_id") && "object" == o(h.event_id) && (h.event_id = h.event_id[h.event_id.length - 1]);
                    }
                } catch (e) {
                    (g = !0), (m = e);
                } finally {
                    try {
                        !y && w.return && w.return();
                    } finally {
                        if (g) throw m;
                    }
                }
                ((v = r),
                fetch("/cart/add.js", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: v }) })
                    .then(function (e) {
                        if (!e.ok) throw Error(e.statusText);
                        return (0, a.getCart)();
                    })
                    .catch(function (e) {
                        console.error(e);
                    }))
                    .then(function () {
                        return (0, a.getCart)();
                    })
                    .then(function (e) {
                        (0, l.updateDrawer)(e), (0, l.showDrawer)(), (n.disabled = !1), (n.innerHTML = i);
                    })
                    .catch(function (e) {
                        console.error(e), (n.disabled = !1), (n.innerHTML = i);
                    });
            }
        });
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), (t.updateProduct = void 0);
        var i,
            o = n(0),
            r = ((i = o) && i.__esModule, n(1)),
            s = n(15),
            a = n(16);
        var l = document.getElementById("subscription-purchase"),
            c = function (e) {
                var t = !0,
                    n = !1,
                    i = void 0;
                try {
                    for (var o, r = document.querySelectorAll(".js-product-sku")[Symbol.iterator](); !(t = (o = r.next()).done); t = !0) {
                        o.value.innerHTML = e;
                    }
                } catch (e) {
                    (n = !0), (i = e);
                } finally {
                    try {
                        !t && r.return && r.return();
                    } finally {
                        if (n) throw i;
                    }
                }
                var s = !0,
                    l = !1,
                    c = void 0;
                try {
                    for (var d, u = document.querySelectorAll("[data-product-sku]")[Symbol.iterator](); !(s = (d = u.next()).done); s = !0) {
                        d.value.setAttribute("data-product-sku", e);
                    }
                } catch (e) {
                    (l = !0), (c = e);
                } finally {
                    try {
                        !s && u.return && u.return();
                    } finally {
                        if (l) throw c;
                    }
                }
                (0, a.updateSubtotal)();
            },
            d = function (e, t, n) {
                var i = t.id;
                null != l && l.checked && (i = window.Rosewood.variantMap[i].discount_variant_id);
                var o = !0,
                    s = !1,
                    d = void 0;
                try {
                    for (var u, p = document.querySelectorAll(n + ' [name="id"]')[Symbol.iterator](); !(o = (u = p.next()).done); o = !0) {
                        u.value.value = i;
                    }
                } catch (e) {
                    (s = !0), (d = e);
                } finally {
                    try {
                        !o && p.return && p.return();
                    } finally {
                        if (s) throw d;
                    }
                }
                !(function (e) {
                    var t = Shopify.currency.active,
                        n = e.price;
                    null != l && l.checked && (n *= window.Rosewood.discountMultiplier);
                    var i = !0,
                        o = !1,
                        s = void 0;
                    try {
                        for (var c, d = document.querySelectorAll(".js-price")[Symbol.iterator](); !(i = (c = d.next()).done); i = !0) {
                            c.value.innerHTML = (0, r.formatMoney)(n, t);
                        }
                    } catch (e) {
                        (o = !0), (s = e);
                    } finally {
                        try {
                            !i && d.return && d.return();
                        } finally {
                            if (o) throw s;
                        }
                    }
                    var u = !0,
                        p = !1,
                        f = void 0;
                    try {
                        for (var h, v = document.querySelectorAll(".js-compare-price")[Symbol.iterator](); !(u = (h = v.next()).done); u = !0) {
                            h.value.innerHTML = (0, r.formatMoney)(e.compare_at_price, t);
                        }
                    } catch (e) {
                        (p = !0), (f = e);
                    } finally {
                        try {
                            !u && v.return && v.return();
                        } finally {
                            if (p) throw f;
                        }
                    }
                    var y = !0,
                        g = !1,
                        m = void 0;
                    try {
                        for (var b, w = document.querySelectorAll(".js-product-subtotal")[Symbol.iterator](); !(y = (b = w.next()).done); y = !0) {
                            b.value.setAttribute("data-product-price", n);
                        }
                    } catch (e) {
                        (g = !0), (m = e);
                    } finally {
                        try {
                            !y && w.return && w.return();
                        } finally {
                            if (g) throw m;
                        }
                    }
                    (0, a.updateSubtotal)();
                })(t),
                    (function (e) {
                        var t = "?variant=" + e.id,
                            n = !0,
                            i = !1,
                            o = void 0;
                        try {
                            for (var r, s = window.location.search.split("&")[Symbol.iterator](); !(n = (r = s.next()).done); n = !0) {
                                var a = r.value;
                                a && -1 === a.indexOf("variant=") && (t += "&" + a);
                            }
                        } catch (e) {
                            (i = !0), (o = e);
                        } finally {
                            try {
                                !n && s.return && s.return();
                            } finally {
                                if (i) throw o;
                            }
                        }
                        var l = "" + window.location.pathname + t;
                        window.history.replaceState({}, null, l);
                    })(t),
                    c(t.sku),
                    (function (e, t) {
                        var n = !0,
                            i = !1,
                            o = void 0;
                        try {
                            for (var r, s = document.querySelectorAll(t + " .js-add-to-cart")[Symbol.iterator](); !(n = (r = s.next()).done); n = !0) {
                                var a = r.value;
                                e.available ? ((a.disabled = !1), (a.innerHTML = "Add to Cart"), null != l && l.checked ? (a.innerHTML = "Subscribe") : (a.innerHTML = "Add to Cart")) : ((a.disabled = !0), (a.innerHTML = "Out of Stock"));
                            }
                        } catch (e) {
                            (i = !0), (o = e);
                        } finally {
                            try {
                                !n && s.return && s.return();
                            } finally {
                                if (i) throw o;
                            }
                        }
                    })(t, n);
            },
            u = function () {
                var e = ".js-product-form",
                    t = document.querySelector(e),
                    n = (function (e, t) {
                        var n = { option1: null, option2: null, option3: null },
                            i = !0,
                            o = !1,
                            r = void 0;
                        try {
                            for (var s, a = t.querySelectorAll(".js-product-option")[Symbol.iterator](); !(i = (s = a.next()).done); i = !0) {
                                var l = s.value;
                                "INPUT" === l.tagName && /(radio|checkbox)/.test(l.getAttribute("type")) ? l.checked && (n[l.getAttribute("name")] = decodeURIComponent(l.value)) : (n[l.getAttribute("name")] = decodeURIComponent(l.value));
                            }
                        } catch (e) {
                            (o = !0), (r = e);
                        } finally {
                            try {
                                !i && a.return && a.return();
                            } finally {
                                if (o) throw r;
                            }
                        }
                        if (1 == e.variants.length) return e.variants[0];
                        for (var c = 0; c < e.variants.length; ++c) {
                            var d = e.variants[c];
                            if (d.option1 === n.option1 && d.option2 === n.option2 && d.option3 === n.option3) return d;
                        }
                        return !1;
                    })(s.product, t);
                n
                    ? d(s.product, n, e)
                    : (function (e) {
                          c("");
                          var t = !0,
                              n = !1,
                              i = void 0;
                          try {
                              for (var o, r = document.querySelectorAll(".js-price")[Symbol.iterator](); !(t = (o = r.next()).done); t = !0) {
                                  o.value.innerHTML = "";
                              }
                          } catch (e) {
                              (n = !0), (i = e);
                          } finally {
                              try {
                                  !t && r.return && r.return();
                              } finally {
                                  if (n) throw i;
                              }
                          }
                          var s = !0,
                              a = !1,
                              l = void 0;
                          try {
                              for (var d, u = document.querySelectorAll(".js-compare-price")[Symbol.iterator](); !(s = (d = u.next()).done); s = !0) {
                                  d.value.innerHTML = "";
                              }
                          } catch (e) {
                              (a = !0), (l = e);
                          } finally {
                              try {
                                  !s && u.return && u.return();
                              } finally {
                                  if (a) throw l;
                              }
                          }
                          var p = !0,
                              f = !1,
                              h = void 0;
                          try {
                              for (var v, y = document.querySelectorAll(".js-product-subtotal")[Symbol.iterator](); !(p = (v = y.next()).done); p = !0) {
                                  v.value.setAttribute("data-product-price", "");
                              }
                          } catch (e) {
                              (f = !0), (h = e);
                          } finally {
                              try {
                                  !p && y.return && y.return();
                              } finally {
                                  if (f) throw h;
                              }
                          }
                          var g = !0,
                              m = !1,
                              b = void 0;
                          try {
                              for (var w, x = document.querySelectorAll(e + " .js-add-to-cart")[Symbol.iterator](); !(g = (w = x.next()).done); g = !0) {
                                  var T = w.value;
                                  (T.disabled = !0), (T.innerHTML = "Unavailable");
                              }
                          } catch (e) {
                              (m = !0), (b = e);
                          } finally {
                              try {
                                  !g && x.return && x.return();
                              } finally {
                                  if (m) throw b;
                              }
                          }
                      })(e);
            };
        s.product &&
            document.addEventListener("change", function (e) {
                if (e.target.closest(".js-product-option") && e.target.closest(".js-product-form")) {
                    e.preventDefault();
                    var t = e.target.closest(".js-product-form"),
                        n = e.target.closest(".js-product-option"),
                        i = n.getAttribute("name"),
                        o = n.value;
                    !(function (e, t, n, i) {
                        var o = !0,
                            r = !1,
                            s = void 0;
                        try {
                            for (var a, l = document.querySelectorAll(i)[Symbol.iterator](); !(o = (a = l.next()).done); o = !0) {
                                var c = a.value;
                                if (c !== e) {
                                    var d = !0,
                                        u = !1,
                                        p = void 0;
                                    try {
                                        for (var f, h = c.querySelectorAll('[name="' + t + '"]')[Symbol.iterator](); !(d = (f = h.next()).done); d = !0) {
                                            var v = f.value;
                                            "INPUT" === v.tagName && /(radio|checkbox)/.test(v.getAttribute("type")) ? (v.checked = v.value === n) : (v.value = n);
                                        }
                                    } catch (e) {
                                        (u = !0), (p = e);
                                    } finally {
                                        try {
                                            !d && h.return && h.return();
                                        } finally {
                                            if (u) throw p;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            (r = !0), (s = e);
                        } finally {
                            try {
                                !o && l.return && l.return();
                            } finally {
                                if (r) throw s;
                            }
                        }
                    })(t, i, o, ".js-product-form"),
                        "quantity" !== i
                            ? u()
                            : (function (e) {
                                  var t = !0,
                                      n = !1,
                                      i = void 0;
                                  try {
                                      for (var o, r = document.querySelectorAll("[data-product-quantity]")[Symbol.iterator](); !(t = (o = r.next()).done); t = !0) {
                                          o.value.setAttribute("data-product-quantity", e);
                                      }
                                  } catch (e) {
                                      (n = !0), (i = e);
                                  } finally {
                                      try {
                                          !t && r.return && r.return();
                                      } finally {
                                          if (n) throw i;
                                      }
                                  }
                                  (0, a.updateSubtotal)();
                              })(o);
                }
            }),
            (t.updateProduct = u);
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var i = !!document.querySelector("#product-json") && JSON.parse(document.querySelector("#product-json").innerHTML);
        t.product = i;
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), (t.updateSubtotal = void 0);
        var i = n(1);
        t.updateSubtotal = function () {
            var e = !0,
                t = !1,
                n = void 0;
            try {
                for (var o, r = document.querySelectorAll(".js-product-subtotal")[Symbol.iterator](); !(e = (o = r.next()).done); e = !0) {
                    var s = o.value,
                        a = { price: parseFloat(s.getAttribute("data-product-price")), quantity: parseInt(s.getAttribute("data-product-quantity"), 10) };
                    s.innerHTML = (0, i.formatMoney)(a.price * a.quantity);
                }
            } catch (e) {
                (t = !0), (n = e);
            } finally {
                try {
                    !e && r.return && r.return();
                } finally {
                    if (t) throw n;
                }
            }
        };
    },
    function (e, t, n) {
        "use strict";
        var i,
            o = n(0),
            r = (i = o) && i.__esModule ? i : { default: i };
        n(2);
        var s = (0, r.default)(".js-product-carousel");
        s.slick({ dots: true, infinite: true, arrows: true, speed: 500, fade: true, cssEase: "ease" })
            (0, r.default)(".js-product-carousel-thumbnails").slick({
                dots: true,
                arrows: true,
                vertical: !0,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 2,
                verticalSwiping: !0,
                prevArrow: ".js-prev-arrow",
                nextArrow: ".js-next-arrow",
                responsive: [{ breakpoint: 768, settings: { verticalSwiping: !1, vertical: !1, slidesToShow: 4, slidesToScroll: 2 } }],
            }),
            (0, r.default)('[data-behavior="goto-slide"]').click(function (e) {
                var t = this.getAttribute("data-thumbnail-index");
                s.slick("slickGoTo", t);
            }),
            s.on("beforeChange", function (e, t, n, i) {
                (0, r.default)(".js-product-thumbnail.selected").removeClass("selected"), (0, r.default)('[data-thumbnail-index="' + i + '"]').addClass("selected");
            }),
            (0, r.default)("[data-thumbnail-index]").click(function (e) {
                var t = this.getAttribute("data-thumbnail-index");
                s.slick("slickGoTo", t);
            });
    },
    function (e, t, n) {
        "use strict";
        var i = r(n(0)),
            o = r(n(8));
        function r(e) {
            return e && e.__esModule ? e : { default: e };
        }
        var s = (0, i.default)(".hamburger"),
            a = (0, i.default)("body"),
            l = (0, i.default)(".js-mobile-menu"),
            c = (0, i.default)("#shopify-section-header"),
            d = (0, i.default)("#shopify-section-header-top-bar"),
            u = function () {
                l.css("margin-top", c.outerHeight() + d.outerHeight() + "px");
            },
            p =
                (window.innerWidth,
                function () {
                    s.removeClass("is-active"), a.removeClass("overflow-y-hidden"), a.removeClass("mobile-menu-is-active"), l.removeClass("is-active"), l.attr("aria-hidden", "true");
                });
        (0, i.default)('[data-behavior="toggle-submenu"]').on("click", function (e) {
            e.preventDefault(), (0, i.default)(this).toggleClass("active"), (0, i.default)(this).next("ul").slideToggle();
        }),
            s.on("click", function () {
                l.hasClass("is-active") ? p() : (u(), s.addClass("is-active"), a.addClass("overflow-y-hidden"), a.addClass("mobile-menu-is-active"), l.addClass("is-active"), l.attr("aria-hidden", "false"), l.css("z-index", 2147483647));
            }),
            u();
        var f = window.innerWidth;
        (0, i.default)(window).resize(
            (0, o.default)(function () {
                u();
                var e = window.innerWidth;
                e > f && f <= 959 && e > 959 && p(), (f = e);
            }, 100)
        );
    },
    function (e, t, n) {
        var i = n(29),
            o = "object" == typeof self && self && self.Object === Object && self,
            r = i || o || Function("return this")();
        e.exports = r;
    },
    function (e, t, n) {
        var i = n(19).Symbol;
        e.exports = i;
    },
    function (e, t, n) {
        "use strict";
        n(22), n(23), n(24), n(4), n(25), n(26), n(18), n(39), n(40), n(41), n(10), n(11), n(3), n(42), n(43), n(44), n(45), n(12), n(46);
    },
    function (e, t, n) {
        "use strict";
        function i(e) {
            var t = document.createElement("link");
            (t.rel = "stylesheet"), (t.href = e), document.head.prepend(t);
        }
        function o(e) {
            var t, n;
            i("https://cdn.shopify.com/s/files/1/0015/9829/2056/t/40/assets/bc-sf-filter.scss.css"),
                i("https://trustspot.io/index.php/api/pub/product_widget_css/7593/widget.css"),
                (t = "https://trustspot.io/assets/js/trustspot_product_reviews.js"),
                ((n = document.createElement("script")).src = t),
                document.body.append(n),
                r.forEach(function (e) {
                    document.removeEventListener(e, o, !0);
                });
        }
        var r = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];
        window.onload = function () {
            r.forEach(function (e) {
                document.addEventListener(e, o, !0);
            });
        };
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.lazyloadElements = function (e, t) {
                var n = { rootMargin: "10px", threshold: 0.5 },
                    i = !1,
                    o = new IntersectionObserver(function (e) {
                        e.forEach(function (e) {
                            !i && e.isIntersecting && (t(), (i = !0));
                        }, n);
                    }),
                    r = document.querySelector(e);
                o.observe(r);
            });
    },
    function (e, t, n) {
        "use strict";
        var i,
            o =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (e) {
                          return typeof e;
                      }
                    : function (e) {
                          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                      },
            r = n(0),
            s = (i = r) && i.__esModule ? i : { default: i };
        (0, s.default)("[data-behavior=accordion]").each(function () {
            var e = (0, s.default)(this),
                t = e.find(".accordion-content");
            e.find("summary").on("click", function (n) {
                n.preventDefault();
                var i = e.attr("open");
                "undefined" !== (void 0 === i ? "undefined" : o(i)) && !1 !== i
                    ? t.slideUp(250, function () {
                          e.removeAttr("open");
                      })
                    : (e.attr("open", "open"), t.slideDown(250));
            });
        });
    },
    function (e, t, n) {
        "use strict";
        var i = n(3),
            o = n(4);
        document.addEventListener("click", function (e) {
            if (e.target.closest('[data-behavior="ajax-cart-button"]') && e.target.closest("[data-variant-id]")) {
                e.preventDefault();
                var t = e.target.closest('[data-behavior="ajax-cart-button"]'),
                    n = e.target.closest("[data-variant-id]").getAttribute("data-variant-id"),
                    r = t.innerHTML;
                (t.innerHTML = "Adding..."),
                    (t.disabled = !0),
                    (0, i.addToCart)(n, 1)
                        .then(function (e) {
                            "/cart" !== window.location.pathname ? ((0, o.updateDrawer)(e), (0, o.showDrawer)(), (t.disabled = !1), (t.innerHTML = r)) : window.location.reload();
                        })
                        .catch(function (e) {
                            console.error(e), (t.disabled = !1), (t.innerHTML = r);
                        });
            }
        });
    },
    function (e, t, n) {
        "use strict";
        document.addEventListener("click", function (e) {
            if (e.target.closest('[data-behavior="change-currency"]')) {
                var t = document.getElementById("currency_form"),
                    n = document.querySelector("#currency_form select"),
                    i = e.target.closest('[data-behavior="change-currency"]').getAttribute("data-currency-code");
                (n.value = i), t.submit();
            }
        });
    },
    function (e, t, n) {
        var i = n(9),
            o = n(28),
            r = n(31),
            s = Math.max,
            a = Math.min;
        e.exports = function (e, t, n) {
            var l,
                c,
                d,
                u,
                p,
                f,
                h = 0,
                v = !1,
                y = !1,
                g = !0;
            if ("function" != typeof e) throw new TypeError("Expected a function");
            function m(t) {
                var n = l,
                    i = c;
                return (l = c = void 0), (h = t), (u = e.apply(i, n));
            }
            function b(e) {
                return (h = e), (p = setTimeout(x, t)), v ? m(e) : u;
            }
            function w(e) {
                var n = e - f;
                return void 0 === f || n >= t || n < 0 || (y && e - h >= d);
            }
            function x() {
                var e = o();
                if (w(e)) return T(e);
                p = setTimeout(
                    x,
                    (function (e) {
                        var n = t - (e - f);
                        return y ? a(n, d - (e - h)) : n;
                    })(e)
                );
            }
            function T(e) {
                return (p = void 0), g && l ? m(e) : ((l = c = void 0), u);
            }
            function S() {
                var e = o(),
                    n = w(e);
                if (((l = arguments), (c = this), (f = e), n)) {
                    if (void 0 === p) return b(f);
                    if (y) return clearTimeout(p), (p = setTimeout(x, t)), m(f);
                }
                return void 0 === p && (p = setTimeout(x, t)), u;
            }
            return (
                (t = r(t) || 0),
                i(n) && ((v = !!n.leading), (d = (y = "maxWait" in n) ? s(r(n.maxWait) || 0, t) : d), (g = "trailing" in n ? !!n.trailing : g)),
                (S.cancel = function () {
                    void 0 !== p && clearTimeout(p), (h = 0), (l = f = c = p = void 0);
                }),
                (S.flush = function () {
                    return void 0 === p ? u : T(o());
                }),
                S
            );
        };
    },
    function (e, t, n) {
        var i = n(19);
        e.exports = function () {
            return i.Date.now();
        };
    },
    function (e, t, n) {
        (function (t) {
            var n = "object" == typeof t && t && t.Object === Object && t;
            e.exports = n;
        }.call(this, n(30)));
    },
    function (e, t) {
        var n;
        n = (function () {
            return this;
        })();
        try {
            n = n || new Function("return this")();
        } catch (e) {
            "object" == typeof window && (n = window);
        }
        e.exports = n;
    },
    function (e, t, n) {
        var i = n(32),
            o = n(9),
            r = n(34),
            s = /^[-+]0x[0-9a-f]+$/i,
            a = /^0b[01]+$/i,
            l = /^0o[0-7]+$/i,
            c = parseInt;
        e.exports = function (e) {
            if ("number" == typeof e) return e;
            if (r(e)) return NaN;
            if (o(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = o(t) ? t + "" : t;
            }
            if ("string" != typeof e) return 0 === e ? e : +e;
            e = i(e);
            var n = a.test(e);
            return n || l.test(e) ? c(e.slice(2), n ? 2 : 8) : s.test(e) ? NaN : +e;
        };
    },
    function (e, t, n) {
        var i = n(33),
            o = /^\s+/;
        e.exports = function (e) {
            return e ? e.slice(0, i(e) + 1).replace(o, "") : e;
        };
    },
    function (e, t) {
        var n = /\s/;
        e.exports = function (e) {
            for (var t = e.length; t-- && n.test(e.charAt(t)); );
            return t;
        };
    },
    function (e, t, n) {
        var i = n(35),
            o = n(38);
        e.exports = function (e) {
            return "symbol" == typeof e || (o(e) && "[object Symbol]" == i(e));
        };
    },
    function (e, t, n) {
        var i = n(20),
            o = n(36),
            r = n(37),
            s = i ? i.toStringTag : void 0;
        e.exports = function (e) {
            return null == e ? (void 0 === e ? "[object Undefined]" : "[object Null]") : s && s in Object(e) ? o(e) : r(e);
        };
    },
    function (e, t, n) {
        var i = n(20),
            o = Object.prototype,
            r = o.hasOwnProperty,
            s = o.toString,
            a = i ? i.toStringTag : void 0;
        e.exports = function (e) {
            var t = r.call(e, a),
                n = e[a];
            try {
                e[a] = void 0;
                var i = !0;
            } catch (e) {}
            var o = s.call(e);
            return i && (t ? (e[a] = n) : delete e[a]), o;
        };
    },
    function (e, t) {
        var n = Object.prototype.toString;
        e.exports = function (e) {
            return n.call(e);
        };
    },
    function (e, t) {
        e.exports = function (e) {
            return null != e && "object" == typeof e;
        };
    },
    function (e, t, n) {
        "use strict";
        var i = o(n(0));
        n(2);
        o(n(8));
        function o(e) {
            return e && e.__esModule ? e : { default: e };
        }
        (0, i.default)(".js-mobile-carousel").length &&
            (0, i.default)(window).on("load resize orientationchange", function () {
                (0, i.default)(".js-mobile-carousel").each(function () {
                    var e = (0, i.default)(this);
                    (0, i.default)(window).width() < 768
                        ? (e.on("init", function () {
                              e.addClass("loaded");
                          }),
                          e.slick({ dots: true, arrows: true, centerMode: true, appendDots: e.next(".js-mobile-carousel-nav"), infinite: !1, speed: 500, cssEase: "ease" }))
                        : e.hasClass(".slick-initialized") && e.slick("unslick");
                });
            });
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var i = function (e, t) {
            e.value = t;
            var n = new Event("change", { bubbles: !0, cancellable: !0 });
            e.dispatchEvent(n);
        };
        document.addEventListener("click", function (e) {
            if (e.target.closest(".js-number-input")) {
                e.preventDefault();
                var t = e.target.closest(".js-number-input").querySelector('input[type="number"]'),
                    n = parseInt(t.value, 10);
                if (e.target.closest('[data-behavior="increment"]') && n < 999) i(t, n + 1);
                else if (e.target.closest('[data-behavior="decrement"]') && n > 1) i(t, n - 1);
                else if (e.target.closest('[data-behavior="decrement"]') && 1 === n) {
                    if ("1" === t.getAttribute("min")) return;
                    i(t, 0);
                    var o = e.target.closest("[data-cart-line]");
                    (o = o.querySelector('[data-behavior="remove-line"]')).click();
                }
            }
        }),
            (t.updateInput = i);
    },
    function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), (t.loadJS = t.loadCSS = t.fetchSectionByID = t.reloadSection = void 0);
        var i,
            o = function (e, t) {
                if (Array.isArray(e)) return e;
                if (Symbol.iterator in Object(e))
                    return (function (e, t) {
                        var n = [],
                            i = !0,
                            o = !1,
                            r = void 0;
                        try {
                            for (var s, a = e[Symbol.iterator](); !(i = (s = a.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0);
                        } catch (e) {
                            (o = !0), (r = e);
                        } finally {
                            try {
                                !i && a.return && a.return();
                            } finally {
                                if (o) throw r;
                            }
                        }
                        return n;
                    })(e, t);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            },
            r = n(0),
            s = (i = r) && i.__esModule ? i : { default: i };
        var a = function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = "shopify-section-" + e;
                return l(e, t).then(function (t) {
                    document.querySelector("#" + n) &&
                        ((document.querySelector("#" + n).outerHTML = t), document.querySelector("#" + n).classList.add("section-api-loaded"), (0, s.default)(window).trigger("ajaxLoaded", [e]), console.log("ajaxLoaded", e));
                });
            },
            l = function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = new URL("" + window.location.href),
                    i = new URLSearchParams(n.search.slice(1));
                i.append("section_id", e), i.append("load", "true");
                var r = !0,
                    s = !1,
                    a = void 0;
                try {
                    for (var l, c = Object.entries(t)[Symbol.iterator](); !(r = (l = c.next()).done); r = !0) {
                        var d = l.value,
                            u = o(d, 2),
                            p = u[0],
                            f = u[1];
                        i.append(p, f);
                    }
                } catch (e) {
                    (s = !0), (a = e);
                } finally {
                    try {
                        !r && c.return && c.return();
                    } finally {
                        if (s) throw a;
                    }
                }
                return (
                    (n.search = new URLSearchParams(i)),
                    fetch(n, { credentials: "same-origin" })
                        .then(function (e) {
                            if (!e.ok) throw Error(e.statusText);
                            return e.text();
                        })
                        .catch(function (e) {
                            console.error(e);
                        })
                );
            },
            c = function () {
                (0, s.default)(".shopify-section").each(function () {
                    (0, s.default)(this).addClass("loaded");
                });
            };
        (window.Rosewood && (window.Rosewood.isThemeSettings || window.Rosewood.isAppProxy)) ||
            ((0, s.default)("body").removeClass("hide"),
            (0, s.default)(".shopify-section").each(function () {
                var e = (0, s.default)(this),
                    t = e.attr("id"),
                    n = t.split("shopify-section-")[1],
                    i = document.querySelector("#" + t),
                    o = s.default.trim(e.html()),
                    r = [];
                i.classList.forEach(function (e, t, n) {
                    return r.push(e);
                });
                var a =
                    r.findIndex(function (e) {
                        return e.includes("section-");
                    }) > -1 &&
                    r
                        .find(function (e) {
                            return e.includes("section-");
                        })
                        .split("section-")[1];
                a &&
                    0 === o.length &&
                    l(n).then(function (e) {
                        (document.querySelector("#" + t).outerHTML = e), document.querySelector("#" + t).classList.add("loaded"), (0, s.default)(window).trigger("ajaxLoaded", [a]), console.log("ajaxLoaded", a);
                    });
            })),
            window.Rosewood && (window.Rosewood.isThemeSettings || window.Rosewood.isAppProxy) && c(),
            (0, s.default)(window).on("ajaxLoaded", function (e, t) {
                c();
            }),
            (window.Rosewood = window.Rosewood || {}),
            (window.Rosewood.reloadSection = a),
            (t.reloadSection = a),
            (t.fetchSectionByID = l),
            (t.loadCSS = function (e) {
                return new Promise(function (t, n) {
                    var i = document.createElement("link");
                    (i.rel = "stylesheet"),
                        (i.href = e),
                        document.head.appendChild(i),
                        (i.onload = function () {
                            t();
                        });
                });
            }),
            (t.loadJS = function (e) {
                return new Promise(function (t, n) {
                    var i = document.createElement("script");
                    (i.src = e),
                        document.head.appendChild(i),
                        (i.onload = function () {
                            t();
                        });
                });
            });
    },
    function (e, t, n) {
        "use strict";
        "function" == typeof Symbol && Symbol.iterator;
        var i,
            o,
            r,
            s = n(0);
        (r = s) && r.__esModule;
        (i = [n(0)]),
            void 0 ===
                (o = function (e) {
                    return (function (e) {
                        (e.easing.jswing = e.easing.swing),
                            Math.pow,
                            Math.sqrt,
                            Math.sin,
                            Math.cos,
                            Math.PI,
                            e.extend(e.easing, {
                                def: "easeOutQuad",
                                easeOut: function (e) {
                                    return 1 - (1 - e) * (1 - e);
                                },
                                easeOutQuad: function (e) {
                                    return 1 - (1 - e) * (1 - e);
                                },
                            });
                    })(e);
                }.apply(t, i)) || (e.exports = o);
    },
    function (e, t, n) {
        "use strict";
        var i = s(n(0)),
            o = s(n(8)),
            r = s(n(18));
        function s(e) {
            return e && e.__esModule ? e : { default: e };
        }
        (0, i.default)(".hamburger");
        var a = (0, i.default)("body");
        (0, i.default)(".js-main-menu");
        (0, i.default)(".js-mobile-search-trigger").on("click", function () {
            openMobileMenu(), (0, i.default)(".js-mobile-search").focus();
        }),
            (0, i.default)(".root-menu-title.has-children").on("click", function (e) {
                e.preventDefault(), (0, i.default)(this).parent().toggleClass("mobile-active");
            }),
            (0, i.default)('[data-behavior="toggle-dropdown"], [data-behavior="toggle-dropdown"] *, .main-menu-dropdown').on("mouseenter", function (e) {
                a.addClass("desktop-menu-is-active");
            }),
            (0, i.default)('[data-behavior="toggle-dropdown"], [data-behavior="toggle-dropdown"] *').on("mouseout", function (e) {
                a.removeClass("desktop-menu-is-active");
            });
        var l = window.innerWidth;
        (0, i.default)(window).resize(
            (0, o.default)(function () {
                var e = window.innerWidth;
                e > l && l <= 767 && e > 767 && (0, r.default)(), (l = e);
            }, 100)
        );
    },
    function (e, t, n) {
        "use strict";
        var i,
            o = n(0),
            r = (i = o) && i.__esModule ? i : { default: i };
        n(2),
            (0, r.default)(".js-mobile-slider").length &&
                (0, r.default)(".js-mobile-slider").slick({ slidesToShow: 1, slidesToScroll: 1, centerMode: !0, initialSlide: 0, infinite: !1, arrows: !1, mobileFirst: !0, responsive: [{ breakpoint: 768, settings: "unslick" }] });
    },
    function (e, t, n) {
        "use strict";
        var i,
            o = n(0),
            r = (i = o) && i.__esModule ? i : { default: i };
        n(2),
            document.querySelector(".js-slick-slides") &&
                (function (e, t) {
                    console.log("function");
                    var n = { rootMargin: "10px", threshold: 0.5 },
                        i = !1,
                        o = new IntersectionObserver(function (e) {
                            e.forEach(function (e) {
                                !i && e.isIntersecting && (t(), (i = !0));
                            }, n);
                        }),
                        r = document.querySelector(e);
                    o.observe(r);
                })(".js-slick-slides", function () {
                    (0, r.default)(".js-slick-slides").length &&
                        (0, r.default)(".js-slick-slides").each(function () {
                            var e = (0, r.default)(this),
                                t = (0, r.default)(this).data("slides-to-show"),
                                n = (0, r.default)(this).data("slides-to-show-mobile"),
                                i = (0, r.default)(this).data("slides-to-show-tablet"),
                                o = (0, r.default)(this).data("slides-to-show-desktop-small"),
                                s = (0, r.default)(this).data("center-mode"),
                                a = ((0, r.default)(this).data("center-padding"), (0, r.default)(this).data("mobile-first")),
                                l = (0, r.default)(this).data("initial-slide");
                            function c() {
                                e.slick({
                                    slidesToShow: t,
                                    slidesToScroll: t,
                                    dots: true,
                                    arrows: true,
                                    infinite: !0,
                                    centerPadding: "70px",
                                    initialSlide: l,
                                    centerMode: s,
                                    autoplay: !1,
                                    pauseOnFocus: !1,
                                    pauseOnHover: !1,
                                    prevArrow: ".hero.js-prev-arrow",
                                    nextArrow: ".hero.js-next-arrow",
                                    responsive: [
                                        { breakpoint: 1260, settings: { slidesToShow: o, slidesToScroll: o } },
                                        { breakpoint: 960, settings: { slidesToShow: i, slidesToScroll: i } },
                                        { breakpoint: 768, settings: { slidesToShow: n, slidesToScroll: n, infinite: !0, dots: !1 } },
                                    ],
                                });
                            }
                            e.find("[data-behavior='js-next-slide']").on("click", function (t) {
                                t.preventDefault(), e.slick("slickNext");
                            }),
                                e.on("init", function () {
                                    e.addClass("loaded");
                                }),
                                "true" == a
                                    ? (0, r.default)(window).on("load resize orientationchange", function () {
                                          (0, r.default)(window).width() > 768 ? e.hasClass("slick-initialized") && e.slick("unslick") : c();
                                      })
                                    : c();
                        });
                });
    },
    function (e, t) {
        class n extends HTMLElement {
            connectedCallback() {
                this.videoId = this.getAttribute("videoid");
                let e = this.querySelector(".lty-playbtn");
                if (
                    ((this.playLabel = (e && e.textContent.trim()) || this.getAttribute("playlabel") || "Play"),
                    this.style.backgroundImage || ((this.posterUrl = `https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg`), n.addPrefetch("preload", this.posterUrl, "image"), (this.style.backgroundImage = `url("${this.posterUrl}")`)),
                    e || ((e = document.createElement("button")), (e.type = "button"), e.classList.add("lty-playbtn"), this.append(e)),
                    !e.textContent)
                ) {
                    const t = document.createElement("span");
                    (t.className = "lyt-visually-hidden"), (t.textContent = this.playLabel), e.append(t);
                }
                this.addEventListener("pointerover", n.warmConnections, { once: !0 }), this.addEventListener("click", (e) => this.addIframe());
            }
            static addPrefetch(e, t, n) {
                const i = document.createElement("link");
                (i.rel = e), (i.href = t), n && (i.as = n), document.head.append(i);
            }
            static warmConnections() {
                n.preconnected ||
                    (n.addPrefetch("preconnect", "https://www.youtube-nocookie.com"),
                    n.addPrefetch("preconnect", "https://www.google.com"),
                    n.addPrefetch("preconnect", "https://googleads.g.doubleclick.net"),
                    n.addPrefetch("preconnect", "https://static.doubleclick.net"),
                    (n.preconnected = !0));
            }
            addIframe() {
                const e = new URLSearchParams(this.getAttribute("params") || []);
                e.append("autoplay", "1");
                const t = document.createElement("iframe");
                (t.width = 560),
                    (t.height = 315),
                    (t.title = this.playLabel),
                    (t.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"),
                    (t.allowFullscreen = !0),
                    (t.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.videoId)}?${e.toString()}`),
                    this.append(t),
                    this.classList.add("lyt-activated"),
                    this.querySelector("iframe").focus();
            }
        }
        customElements.define("lite-youtube", n);
    },
]);
